export const PRODUCTS = [
  {
    id: 4908781240451,
    title: "MultiThera 1 Capsule Formula (Plus k)",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/MT1C-K_hires_web_600x600.png?v=1719524904",
    short_desc:
      "Easily dissolved, iron-free multivitamin capsules with folate, vitamin B12, vitamin A, E, K and D3, amino acids, calcium, copper, zinc, and many trace minerals. This is a super complete daily supplement for men and women, perfect for comprehensive, every day support.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement take one capsule daily or as directed by a physician.",
  },

  {
    id: 4908895273091,
    title: "PGX Daily Singles 30 ct.",
    vendor: "Natural Factors",
    image:
      "//drhyman.com/cdn/shop/files/3570-3U_PGXDaily_30Singles_BOX_7-R0816028_R_600x600.png?v=1706130896",
    short_desc:
      "Easy to use, unflavored fiber supplement that helps curb cravings and appetite so you feel more satiated, supporting healthy weight loss and stabilized blood sugar levels.",
    delivery_form: "Daily Packet",
    directions:
      "Stir 1–2 packets into 375–500 mL of cold water or juice or as directed by your healthcare practitioner. Drink additional water (375–500 mL) after taking PGX",
  },

  {
    id: 4908899926147,
    title: "Wellness Essentials Healthy Balance",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/WellnessEssentialsHealthyBalance_30P_LWE046Ov.0.2.6.4_BOX_WELB_600x600.png?v=1706203248",
    short_desc:
      "This once-daily packet contains phytonutrients for optimal cell function, essential fatty acids for healthy blood sugar, mood and heart health, essential vitamins, and alpha-lipoid acids for the nervous system, brain function and to protect against free radicals.",
    delivery_form: "Packet",
    directions:
      "Take one packet daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4909006946435,
    title: "MegaSporebiotic",
    vendor: "MICROBIOME LABS",
    image:
      "//drhyman.com/cdn/shop/files/MegaSporeBiotic-Mockup-1201x1536_600x600.png?v=1682621208",
    short_desc:
      "MegaSporeBiotic is a probiotic blend of 5 Bacillusspores that have been clinically shown to maintain healthy gut barrier function and overall immunity. The bi-phasic life cycle of the Bacillusspores allows them to remain dormant in harsh environments until they reach more favorable environments like the human gastrointestinal tract. Once inside the large intestine, these dormant spores can change into their active, vegetative forms and begin colonizing in the gut. This unique probiotic blend aims to RECONDITION the gut instead of reseeding with probiotic strains that cannot survive digestion or colonize the gut.",
    delivery_form: "Capsules",
    directions:
      "Start with 1/2 capsule or 1 full capsule with food and slowly increase to 2 capsules per day using the following protocol.",
  },

  {
    id: 4908900417667,
    title: "PureLean Pure Pack",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/image83_600x600.png?v=1705696898",
    short_desc:
      "Comprehensive daily weight management support packet providing core nutrients, alpha-lipoic acid, taurine, berberine, fish oil and green tea†‡",
    delivery_form: "Packet",
    directions:
      "As a dietary supplement, take 1 packet daily (7 capsules), with a meal",
  },

  {
    id: 4908816957571,
    title: "Vitamin D3 1000 IU 120 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/VitaminD31000IU120ct._600x600.png?v=1704296849",
    short_desc:
      "Vitamin D to support calcium metabolism and healthy bones, proper colon function, breast and prostate health, and immune system bolstering.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1-5 capsules daily, or as directed by a health professional. Consume with food.",
  },

  {
    id: 4908804014211,
    title: "PGX WellBetX with Mulberry",
    vendor: "Natural Factors",
    image: "//drhyman.com/cdn/shop/files/pgx_600x600.png?v=1709572535",
    short_desc:
      "PGX, which promotes a feeling of fullness and reduces cravings, is combined with mulberry leaf extract, an excellent source of fiber, to help balance blood sugar and normalize glucose levels, which helps promote healthy weight loss.",
    delivery_form: "Capsules",
    directions:
      "2-4 capsules, taken with 8-16 fl oz of water, 5 to 10 minutes before meals or as directed by a health professional.",
  },

  {
    id: 4908956254339,
    title: "Energize Plus Pure Packs",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/EnergizePlus_PurePack30packets_600x600.png?v=1704297423",
    short_desc:
      "Support for cellular energy production and nutrient metabolism in a convenient, once-daily packet",
    delivery_form: "Capsules",
    directions: "1 packet daily (7 capsules) with a meal",
  },

  {
    id: 4908814565507,
    title: "Magnesium Glycinate 120mg - 180ct",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/Untitled-6_600x600.png?v=1709689574",
    short_desc:
      "Magnesium is essential for cardiovascular health, acid-alkaline balance, energy production, metabolism of carbs, amino-acids and fats, as well as the utilization of calcium, potassium and other minerals, along with vitamins B, C and E. This form is less likely to cause loose stools than other forms.  180 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "1-4 capsules daily. Consume with food or as directed by your health care practitioner.",
  },

  {
    id: 4908838518915,
    title: "OsteoThera Capsule Formula",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/OSTC_hires_web_600x600.png?v=1719524936",
    short_desc:
      "A multi-nutrient complex with highly bioavailable minerals including calcium and vitamin D to help prevent bone mass loss in young women and slow the rate of bone loss in elders. Vitamin K activates proteins, magnesium supports bone health, boron promotes balance, and silicon regulates calcium deposits and helps form collagen.",
    delivery_form: "Capsules",
    directions:
      "2 capsules, 2 times daily with food or as directed by a healthcare professional .",
  },

  {
    id: 4908851331203,
    title: "Vitamin D3 1000 IU 60 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/VitaminD325mcg_1_000IU__60ct_600x600.png?v=1704296979",
    short_desc:
      "Vitamin D is essential support for bones, especially in aiding absorption of calcium and phosphorous and preventing calcium loss through urine, for the cardiovascular system, immunity, colon health, breast and prostate tissue, and cell metabolism.",
    delivery_form: "Capsules",
    directions: "1-5 capsules daily. Consume with food.",
  },

  {
    id: 4908814991491,
    title: "Magnesium (Citrate) 150mg",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/MC1_RGB_600x600.png?v=1709770838",
    short_desc:
      "Easily absorbed magnesium which activates enzymes necessary for neuromuscular and cardiac systems, acid-alkaline balance, metabolism of carbs, amino acids and fats, energy production and utilization of essential vitamins and minerals.  180 ct. veg. capsules",
    delivery_form: "Capsules",
    directions: "1-4 capsules daily. Consume with food.",
  },

  {
    id: 4908821381251,
    title: "Homocysteine Supreme",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/HomocysteineSupreme_600x600.png?v=1709770685",
    short_desc:
      "A powerful amino acid that naturally occurs in the body, needed for detoxification, joint and cartilage repair and brain health. This product helps keep levels at a safe level so toxic accumulation doesn't occur and helps support with diabetes, artery issues, hypertension, erectile dysfunction, Alzheimer's, MS, type 2 diabetes, and renal failure.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules per day with meals or as directed by your health-care practitioner.",
  },

  {
    id: 4908866142339,
    title: "Alpha Lipoic Acid 600 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/AlphaLipoicAcid600mg-60ct_600x600.png?v=1704337526",
    short_desc:
      "Alpha Lipoic Acid is a powerful antioxidant that helps fight free radicals, supports liver function, boosts metabolism, enhances absorption of certain vitamins, and helps turn calories into energy in the muscles. Our bodies manufacture this, but often not enough to perform these necessary functions.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-2 times daily, with meals.",
  },

  {
    id: 4908800639107,
    title: "OmegaGenics EPA-DHA 720 - 120 ct.",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/101355_600x600.jpg?v=1742568286",
    short_desc:
      "High levels of omega-3's without any fishy taste, to help support healthy cardiovascular, immune, gastrointestinal and musculoskeletal systems. This is a crucial part of a properly functioning nervous system. Includes an antioxidant blend and rosemary for oil stabilization.",
    delivery_form: "Softgel Capsules",
    directions:
      "Two softgels up to three times daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908817809539,
    title: "Vitamin D3 5000 IU",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/VitaminD3125mcg_5_000IU___1_600x600.png?v=1704296701",
    short_desc:
      "Vitamin D is essential for cardiovascular, colon and cellular health. It supports healthy breast and prostate cell activity, supports the absorption of calcium in the body for healthy bone composition, and is key for immune health.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule daily, or as directed by a health professional. Consume with food.",
  },

  {
    id: 4908874137731,
    title: "Vitamin D Supreme",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/vds060_vitamin-d-supreme_100cc_ipsos-badge_1_600x600.png?v=1741628225",
    short_desc:
      "Vitamins D and K work synergistically, thus, increasing vitamin D increases the need for vitamin K.",
    delivery_form: "Capsules",
    directions:
      "Take one capsule per day with a meal, or as directed by your health-care practitioner.",
  },

  {
    id: 4908886294659,
    title: "Magnesium (Citrate) 150mg 90 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/Magnesium_citrate_600x600.png?v=1704297879",
    short_desc:
      "Highly absorbable magnesium, to help activate neuromuscular, cardiac, carbohydrate and fat metabolism functions, as well as supporting energy production and utilization of calcium, phosphorus, sodium, potassium and vitamins B, C and E.",
    delivery_form: "Capsules",
    directions: "1-4 capsules daily. Consume with food.",
  },

  {
    id: 4908888424579,
    title: "Magnesium Glycinate 120mg - 90 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/MagnesiumGlycinate_600x600.png?v=1704297730",
    short_desc:
      "Highly absorbable magnesium, essential for cardiac and neuromuscular function, acid-alkaline balance, metabolism of carbs, proteins and fat, energy production and the utilization of many other important nutrients. This form is less likely to cause loose stools than other forms.",
    delivery_form: "Capsules",
    directions:
      "1-4 capsules daily. Consume with food or as directed by your health care practitioner",
  },

  {
    id: 4908789170307,
    title: "CandiBactin-AR",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/104712_600x600.jpg?v=1742568026",
    short_desc:
      "Aromatic Essential Oils for Support of a Healthy Intestinal Environment",
    delivery_form: "Softgel Capsules",
    directions:
      "One soft gel three times daily before or with meals or as directed by your healthcare practitioner.",
  },

  {
    id: 4908783140995,
    title: "Insulin Guard (name change 2025)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/InsulinGuard_600x600.png?v=1742500658",
    short_desc:
      "A groundbreaking tool which helps support healthy insulin function, triglyceride regulation, and blood sugar transport in the body.",
    delivery_form: "Tablets",
    directions:
      "Three tablets daily or as directed by your healthcare provider.",
  },

  {
    id: 4908915032195,
    title: "PhytoMulti Multivitamin Tablets 120ct",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/101858_600x600.jpg?v=1742568356",
    short_desc:
      "Highly concentrated full spectrum of phytonutrients, vitamins and minerals, for advanced cell protection and function, to recharge, nourish and defend cells like no other nutritional formula.",
    delivery_form: "Tablets",
    directions:
      "Take one to two tablets once daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908789563523,
    title: "CandiBactin-BR",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/104873_600x600.jpg?v=1742568044",
    short_desc:
      "High quality extracts and herbs containing berberine, coptis and Indian barberry roots, along with Chinese herbs such as ginger, licorice and rhubarb, work together to encourage healthy intestinal environment, immune function and detoxification.",
    delivery_form: "Tablets",
    directions:
      "Two tablets two to three times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908861489283,
    title: "Fenugreek Plus",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/FenugreekPlus_60C_LFE032Z2_120cc_600x600.png?v=1706118374",
    short_desc:
      "A combination of fenugreek, gymnema and bitter gourd, three highly valued herbs that support blood glucose function, support healthy triglyceride levels, and help to keep blood sugar levels normal.",
    delivery_form: "Capsules",
    directions:
      "Two capsules twice daily with 6 to 8 ounces of water before meals, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908818071683,
    title: "B-Complex Plus",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/B-ComplexPlus_600x600.png?v=1704338425",
    short_desc:
      "A B vitamin complex is essential in converting carbohydrates to energy, metabolizing fats and protein, maintaining muscle tone in the GI tract and supporting integrity of skin, hair and liver, and is crucial in supporting the nervous system.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-2 times daily, with meals.",
  },

  {
    id: 4908910936195,
    title: "Blood Sugar Solution (Hard Cover)",
    vendor: "Hyman Enterprises",
    image:
      "//drhyman.com/cdn/shop/files/9780316196178__97523_600x600.jpg?v=1705696995",
    short_desc:
      "The Blood Sugar Solution is a personalized approach to health that works by pinpointing and then eliminating the true underlying causes of your blood sugar dysfunction. Hardcover.",
    delivery_form: "Book",
    directions: "",
  },

  {
    id: 4908848644227,
    title: "Buffered Ascorbic Acid Capsules - 90 count",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_2694e89e-2b81-4c6a-ace3-f10b1bb3e59f_600x600.png?v=1705620986",
    short_desc:
      "Vitamin C for sensitive individuals, this buffered ascorbic acid combines calcium ascorbate, magnesium ascorbate, and potassium ascorbate to create a neutral pH vitamin C to lessen possible gastric irritation in sensitive individuals.",
    delivery_form: "Capsules",
    directions:
      "1 Capsule,1-4 times daily, with or between meals, or as directed by a health professional",
  },

  {
    id: 4908911296643,
    title: "Wellness Essentials Women's Prime Daily Packs",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/eyJwYXRoIjoibWV0YWdlbmljc1wvZmlsZVwvdkRIUllHa0hWekV1QXZGZHRIYXkucG5nIn0_metagenics_gvxibeR1CWm_pKSVGjJRDTH8fYpJS_yGGvFsvPgn0oA_600x600.png?v=1742568711",
    short_desc:
      "Advanced nutritional support for menopause and beyond, this is formulated to support energy metabolism, heart and bone health as well as to maintain women's vitality, mood and overall whole body health.",
    delivery_form: "Capsules",
    directions:
      "One packet daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908952977539,
    title: "MCT Oil USP - 16 oz",
    vendor: "NuMedica",
    image: "//drhyman.com/cdn/shop/files/oil_16_600x600.png?v=1706571867",
    short_desc:
      "Medium-chain triglycerides (MCTs) are a special type of fatty acids which are metabolized more fully for energy in the body.",
    delivery_form: "Oil",
    directions:
      "Take one tablespoon two to four times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 5071327953027,
    title: "O.N.E.™ Multivitamin 60 ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_e77619ea-9253-4bf6-a30a-15b803ea2791_600x600.png?v=1706583234",
    short_desc: "Once-daily nutrient essentials with sustained-release CoQ10",
    delivery_form: "Capsules",
    directions: "Take 1 capsule daily, with a meal.",
  },

  {
    id: 4908800180355,
    title: "UltraInflamX PLUS 360 (Pineapple-Banana)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/UltraInflamXPlus360_PineappleBanana_1558220H3_64oz_a9da1e3b-3cea-4ec0-8bcd-6a92bb7555fa_600x600.png?v=1706210487",
    short_desc:
      "Advanced Support for the Nutritional Management of Compromised Gut Function in IBD",
    delivery_form: "Powder",
    directions:
      "Blend (for no longer than 15 seconds), shake, or briskly stir about 2 level scoops (45 grams) into 8 fluid ounces of chilled water, juice, or acceptable fruit as listed in the dietary guidelines. Consume within 10 minutes of reconstitution.",
  },

  {
    id: 4908786843779,
    title: "UltraClear Plus pH Detox Powder (Vanilla)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/UltraClearPluspH_Vanilla_1531230S10_64oz_600x600.png?v=1706212264",
    short_desc:
      "A medical food which provides potent nutrition to enhance detoxification and promote the excretion of toxins through the kidneys. This can help patients with compromised or overly acidic pH levels, and those with chronic fatigue syndrome.",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir 2 scoops (46 grams) of UltraClear Plus pH into 8 fluid ounces of chilled water or juiceor as directed by your health care practitioner.",
  },

  {
    id: 7891597131907,
    title: "Omega-3 Rejuvenate",
    vendor: "Big Bold Health",
    image:
      "//drhyman.com/cdn/shop/files/omega-3-rejuvenate__1_600x600.png?v=1705098563",
    short_desc:
      "Health Interests: Immunity, Immune Response, Immune Rejuvenation, Skin Health, Eye Health",
    delivery_form: "Softgel Capsules",
    directions:
      "Take 2 softgels, 1 to 2 times daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908885737603,
    title: "OmegaGenics EPA-DHA 720 - 60 ct.",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/101352_c2c988f2-53b5-48a1-b50e-2da48a7406a2_600x600.jpg?v=1742568299",
    short_desc:
      "A blend of pharmaceutical grade omega-3 fatty acids derived from sustainably sourced cold water fish and antioxidants to support cardiovascular, immune, gastrointestinal, nervous and musculoskeletal systems.",
    delivery_form: "Softgel Capsules",
    directions:
      "2 softgels up to three times daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908947013763,
    title: "E-lyte Balanced Electrolyte Concentrate 16 oz.",
    vendor: "Body Bio",
    image: "//drhyman.com/cdn/shop/files/f_600x600.png?v=1707445622",
    short_desc:
      "Balanced Electrolyte formula is a physiological solution which can be used for mineral balancing preferably as a preliminary approach to nutritional support.",
    delivery_form: "Liquid",
    directions:
      "Mix 1 capful in 8 oz water. Can be further diluted to desired taste.Drink 1-2 servings per day or as directed by your physician for optimal hydration. When engaging in strenuous activity, use prior to help maintain healthy electrolyte levels in the body for improved performance and fewer muscle cramps. E-Lyte can also be used to relieve night muscle cramps.",
  },

  {
    id: 4908909854851,
    title: "Wellness Essentials Women's Daily Packs",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/103918_600x600.jpg?v=1742568693",
    short_desc:
      "Specific to women's health needs, these essentials include omega-3's, calcium, and a multivitamin with extracts, phytonutrients, iron and other trace minerals, formulated to support heart, bones, metabolism and to promote optimal overall health and vitality.",
    delivery_form: "Daily Packet",
    directions:
      "One packet daily or as directed by your healthcare practitioner",
  },

  {
    id: 4908840321155,
    title: "Active B12 Folate (sublingual)",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/ABF_hi_res_web_600x600.png?v=1713460006",
    short_desc:
      "A high concentration of vitamin B12 is included to bypass normal absorptive mechanisms that rely on intrinsic factor. Folate complements actions of B12 for homocysteine methylation and nervous system function.† Provides bioactive forms of both vitamin B12 and folate for highest bioavailability of these important B vitamins. Tablets may be dissolved in the mouth or swallowed whole.",
    delivery_form: "Lozenges",
    directions:
      "Dissolve 1 lozenge daily in the mouth before swallowing or as directed by a healthcare professional.",
  },

  {
    id: 4908909559939,
    title: "Wellness Essentials",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/104166_600x600.jpg?v=1742568649",
    short_desc:
      "Wellness Essentials is formulated to support your nutritional needs to help you stay active and vital and maintain overall health.",
    delivery_form: "Daily Packet",
    directions:
      "One packet daily or as directed by your healthcare practitioner",
  },

  {
    id: 4908943605891,
    title: "O.N.E. Omega 60 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_77b359ca-99da-4cef-9382-8c3a8c671893_600x600.png?v=1705975907",
    short_desc:
      "Once daily pure omega-3's, twice as potent as other fish oils, provides essential support for cardiovascular, joint, cognitive and skin health.",
    delivery_form: "Capsules",
    directions:
      "1 capsule daily, with a meal or as recommended by a healthcare practitioner.",
  },

  {
    id: 4908799721603,
    title: "UltraInflamX PLUS 360 (Original Spice)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/UltraInflamXPlus360_OriginalSpice_1558205H4_64oz_600x600.png?v=1706210663",
    short_desc:
      "A medical food providing nutritional support for compromised gut function and inflammation in ulcerative colitis and Crohn's disease. Low allergen, rice protein, antioxidants, minerals, vitamins and L-glutamine to support intestinal function.",
    delivery_form: "Powder",
    directions:
      "Blend (for no longer than 15 seconds), shake, or briskly stir about 2 level scoops (45 grams) into 8 fluid ounces of chilled water, juice, or acceptable fruit as listed in the dietary guidelines. Consume within 10 minutes of reconstitution.",
  },

  {
    id: 4908820299907,
    title: "Red Yeast Rice + CoQ10 (formerly Choleast)",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/sf751-front_600x600.png?v=1709775346",
    short_desc:
      "Red yeast rice powder, used in Traditional Chinese Medicine, works to support healthy cholesterol levels, provides essential fatty acids, isoflavones and protein, and is combined with CoQ10 to help balance blood lipids in the body.",
    delivery_form: "Capsules",
    directions: "2-4 capsules or as directed by your health care practitioner.",
  },

  {
    id: 4908996558979,
    title: "O.N.E Multivitamin 120 ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_838d5153-e80c-4189-93b5-bafbd7b06907_600x600.png?v=1705975041",
    short_desc: "Once-daily nutrient essentials with sustained-release CoQ10",
    delivery_form: "Capsules",
    directions: "Pure Encapsulations recommends 1 capsule daily, with a meal.",
  },

  {
    id: 4908833407107,
    title: "Energy Multi-Plex",
    vendor: "Researched Nutritionals",
    image:
      "//drhyman.com/cdn/shop/files/EnergyMulti-Plex_600x600.png?v=1719525146",
    short_desc:
      "Advanced adrenal support with a blend of adaptogenic herbs and minerals, to provide natural energy, help cognitive function, boost metabolism, promote fat utilization and loss, support the cardiovascular and immune systems, promote cell stability and muscle function.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take three capsules per day (at one time or throughout the day) or as directed by your healthcare professional.",
  },

  {
    id: 4908901924995,
    title: "Digestive Enzymes Ultra 180 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_9f4f5aa4-aaa6-4786-b80e-f38368650387_600x600.png?v=1705717184",
    short_desc:
      "A comprehensive vegetarian enzyme that provides optimal support across a wide pH range and may ease gas and bloating with certain foods. These help break down carbohydrates, fat, glucose, lactose and fiber, and as cell walls are broken down, nutrients are more available and better absorbed.",
    delivery_form: "Capsules",
    directions: "1 softgel capsule, 1-4 times daily, with or between meals.",
  },

  {
    id: 4908832325763,
    title: "Transfer Factor Multi-Immune",
    vendor: "Researched Nutritionals",
    image:
      "//drhyman.com/cdn/shop/files/TFMultiImmune_600x600.png?v=1709771088",
    short_desc:
      "Transfer Factor Multi-Immune™ is a daily use immune support product promoting healthy NK cell levels, keeping bugs at bay.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take three capsules per day on an empty stomach (two hours after eating or one hour before eating) or as directed by your health care professional.",
  },

  {
    id: 4908828459139,
    title: "CoQ10 100mg",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/eoj8hirbvpm3yyvkyduo_df9a6bd0-bea1-46e2-a035-7391e09f8096_600x600.webp?v=1705617255",
    short_desc:
      "CoQ10 is a key component to energy production in the body and especially in the heart. Supports healthy aging as the body naturally starts to decrease CoQ10 production as we age.60 ct. softgels",
    delivery_form: "Softgel Capsules",
    directions:
      "1 softgel 3 times daily or as recommended by a health care professional",
  },

  {
    id: 5179271741571,
    title: "Longevity Roadmap Workbook",
    vendor: "Longevity Series",
    image:
      "//drhyman.com/cdn/shop/products/B6B6FAA4-35AF-485A-A97F-B942FFB5D0DE_600x600.png?v=1608306109",
    short_desc:
      "As a companion guide to the Longevity Roadmapdocu-series, the 30 Days to Aging Backwards Workbook is your go-to resource to create radiant, optimal health and learn how to age in reverse.",
    delivery_form: "Course",
    directions: "",
  },

  {
    id: 4908927975555,
    title: "Tri-Fortify Orange Gel",
    vendor: "Researched Nutritionals",
    image:
      "//drhyman.com/cdn/shop/files/Tri-FortifyOrange-Tube_600x600.png?v=1709771250",
    short_desc:
      "An essential antioxidant to help with detoxification in the body, this gel is designed to bypass the digestive process for faster nutrient absorption and utilization by directly entering the bloodstream. Delicious orange flavor.  ALSO NOW AVAILABLE IN WATERMELON.",
    delivery_form: "Gel",
    directions:
      "As a dietary supplement, gently squeeze the tube to fill 1 teaspoon (5 mL), and then swallow or use as directed by your health care professional.",
  },

  {
    id: 4908800016515,
    title: "UltraInflamX PLUS 360 (Mango)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/UltraInflamXPlus360_Mango_1558210H3_64oz_600x600.png?v=1706210824",
    short_desc:
      "Advanced Support for the Nutritional Management of Compromised Gut Function in IBD.",
    delivery_form: "Powder",
    directions:
      "Blend (for no longer than 15 seconds), shake, or briskly stir about 2 level scoops (45 grams) into 8 fluid ounces of chilled water, juice, or acceptable fruit as listed in the dietary guidelines. Consume within 10 minutes of reconstitution.",
  },

  {
    id: 4908798378115,
    title: "Thyrosol",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105014_600x600.jpg?v=1742568479",
    short_desc:
      "Thyrosol offers a multifaceted approach by providing nutritional support for healthy thyroid function along with additional support for stress-related fatigue.*",
    delivery_form: "Capsules",
    directions:
      "Take one tablet three times a day with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908982173827,
    title: "UltraGI Replenish Gut Support Vanilla",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/V_600x600.jpg?v=1742568594",
    short_desc:
      "UltraGI Replenish is a medical food formulated to provide specialized macro and micronutrient support for patients with compromised gut function with digestive disorders including malabsorption",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir 2 level scoops (43.5 grams) into 8 fluid ounces of chilled water. Take twice daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 6575074967683,
    title: "NAC",
    vendor: "Integrative Therapeutics",
    image: "//drhyman.com/cdn/shop/products/NACIT_600x600.png?v=1739227113",
    short_desc: "HELPS REPLENISH INTRACELLULAR GLUTATHIONE.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule once or twice daily, or as recommended by your healthcare professional.",
  },

  {
    id: 4908897960067,
    title: "PGX SlimStyles Granules",
    vendor: "Natural Factors",
    image:
      "//drhyman.com/cdn/shop/files/3585-7U_SS_PGXGranules_BOT500PANO_600x600.png?v=1706130948",
    short_desc:
      "Reduces appetite by promoting a feeling of fullness.* Helps lower the glycemic index.* Helps maintain healthy blood sugar and total cholesterol levels already within the normal range.",
    delivery_form: "Powder",
    directions:
      "PGX Granules can be taken with or without food with a glass of water (8–16 oz. or 1–2 cups) or as directed by a health professional. Drink additional water after ingesting PGX. Use consistently with or without meals or with healthy snacks to greatly reduce appetite and curb food cravings.*Week 1: 1/2 scoop, once daily.Week 2: 1/2–1 scoop, once daily.Week 3 and beyond: 1 scoop, once daily",
  },

  {
    id: 4908782846083,
    title: "MetaGlycemX 120 ct.",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/120_600x600.jpg?v=1742568211",
    short_desc:
      "Advanced nutritional support for healthy insulin and glucose levels. A unique combination of antioxidants, vitamins, green tea, herbs and micronutrients to support insulin activity, free radical scavenging, reduce oxidative stress and protect cells.",
    delivery_form: "Tablets",
    directions:
      "Take two tablets once daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908788482179,
    title: "Glutagenics",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105104_600x600.jpg?v=1742568150",
    short_desc:
      "Glutamine (an amino acid), licorice (processed to negate any adverse licorice effects) and aloe vera (with the laxative properties removed) combine to effectively support the integrity and healthy function of the gastrointestinal lining for healthy digestion, immunity and overall wellness.",
    delivery_form: "Powder",
    directions:
      "Mix one teaspoon(4.33 g)with water three times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908848021635,
    title: "NAC 600mg - 90 count",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_daf1d538-0ea4-4f82-9833-3fe19050ac11_600x600.png?v=1705970383",
    short_desc:
      "Supports lung tissue, fights free radicals and supports the body's natural immunity. Helps to chelate heavy metals and detoxify the body.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-3 times daily, between meals.",
  },

  {
    id: 6723317170307,
    title: "Bioactive Collagen Complex",
    vendor: "Vital Proteins",
    image: "//drhyman.com/cdn/shop/files/bio_600x600.png?v=1719192854",
    short_desc:
      "BIOACTIVE COLLAGEN COMPLEX Daily Foundational Support** offers a clinically-backed, comprehensive approach to collagen supplementation. Developed with a team of leading nutrition experts, this formulation combines three types of bioactive collagen peptides with liposomal vitamin C to help enhance the body's ability to stimulate collagen production.**",
    delivery_form: "Powder",
    directions:
      "Mix one scoop in 8 oz. of liquid—like coffee, water or smoothie—and consume every day.",
  },

  {
    id: 4908839862403,
    title: "Melatonin-SR 2mg",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/ML2.75_hires_web_600x600.png?v=1710454425",
    short_desc: "",
    delivery_form: "Capsules",
    directions:
      "1 capsule one hour before bedtime or as directed by your health care practitioner.",
  },

  {
    id: 4908942917763,
    title: "Multi t/d 60 ct.",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/MTD26_RGB_600x600.png?v=1709775914",
    short_desc:
      "Two a day multivitamin/mineral for optimal bioavailability and absorption. Specifically the folic acid, vitamin B6 and 12 may help reduce the risk of cardiovascular disease, with trace minerals and antioxidants for overall wellness.",
    delivery_form: "Capsules",
    directions: "Twice daily multivitamin/mineral complex for daily wellness.",
  },

  {
    id: 4908767838339,
    title: "Brain Vitale Capsules",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/BrainVitaleCapsules_600x600.png?v=1709775140",
    short_desc:
      "A combination of the two most powerful and beneficial brain nutrients, to help enhance memory, relieve depression, improve mental function, promote recovery from stroke and nerve injury and slow the progression of Alzheimer's disease. Also used for sports performance and muscle recovery.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take two capsules per day with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908786417795,
    title: "UltraClear Plus Detox Powder",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/102185_600x600.jpg?v=1742568413",
    short_desc:
      "A powdered nutritional medical food to support management of chronic fatigue syndrome and to assist in detoxification with glycine, taurine, and green tea extracts.",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir two level scoops (44 grams) into eight fluid ounces of chilled water or juice,or as directed by your health care practitioner.",
  },

  {
    id: 4908899303555,
    title: "PhytoMulti Multivitamin Tablets 60ct",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/101855_600x600.jpg?v=1742568370",
    short_desc:
      "PhytoMulti goes beyond basic wellness support with a proprietary blend of concentrated plant extracts and phytonutrients with scientifically tested biological activity to recharge, nourish and defend cells, activating health potential like no other supplement.",
    delivery_form: "Tablets",
    directions:
      "Take one to two tablets daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908981485699,
    title: "UltraGI Replenish Gut Support Chocolate",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/C_600x600.jpg?v=1742568576",
    short_desc:
      "Support for the Management of Compromised Gut Function with Digestive Disorders including Malabsorption.",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir 2 level scoops (45 grams) into 8 fluid ounces of chilled water. Take twice daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4909013500035,
    title: "PlusOne Daily Prenatal Pack",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/Prego_600x600.png?v=1742568397",
    short_desc:
      "PlusOne Daily Prenatal Packs provide comprehensive supplements to nutritionally support women, featuring vitamins, minerals, and phytonutrients, from preconception through nursing.* This science-based combination features targeted nutrition in a convenient once-daily packet.",
    delivery_form: "Packet",
    directions: "1 Packet daily",
  },

  {
    id: 4908785270915,
    title: "AdvaClear 126",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/advac_600x600.jpg?v=1742567959",
    short_desc:
      "Advanced support for the body's detoxification process, helps to promote renewed vitality, energy and overall well-being, while protecting against free-radicals with potent antioxidants.",
    delivery_form: "Capsules",
    directions:
      "Two capsules one to three times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908862767235,
    title: "UltraMeal RICE (Vanilla)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/VanillaRice_600x600.jpg?v=1742568625",
    short_desc:
      "UltraMeal RICE is a tasty, non-dairy, nutritionally fortified, powdered meal replacement for those who want to support healthy body composition but may be sensitive to soy. The rice protein powder in UltraMeal RICE is provided via a patented process that ensures consistent quality, and is suitable for modified dietary elimination programs.",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir 2 level scoops (48 g) into 8 fluid ounces of chilled water twice daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908862341251,
    title: "UltraClear Renew Detox Powder",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/100963_600x600.jpg?v=1742568537",
    short_desc:
      "A powdered medical food formulated to provide specialized nutritional support for patients with fibromyalgia and is designed for those who may benefit from additional nutritional support for hepatic detoxification function.",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir about 2 level scoops (40 grams) into 8 ounces of chilled water or juice twice daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908778356867,
    title: "Ther-biotic Vital-Zymes Complete",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-VZM_hires_web_600x600.png?v=1708304354",
    short_desc:
      "Potent, full spectrum enzyme blend for maximum support of intestinal function. A wide range of plant and microbial based enzymes work together to maintain healthy levels in the body, break down food for important assimilation, and help soothe intestinal inflammation.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement take two capsules at the beginning of each meal or as directed by a physician.",
  },

  {
    id: 4908793888899,
    title: "Adreset 180 ct.",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/AD180_600x600.jpg?v=1742567928",
    short_desc:
      "Adrenal support formula for those who are “stressed and tired” with adaptogenic herbal extracts to help reduce negative effects of stress and promote vitality, immunity, energy levels, and mental clarity. Includes ginseng, rhodiola and cordyceps.180 ct. capsules",
    delivery_form: "Capsules",
    directions:
      "Take two capsules two times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908887081091,
    title: "Zinc citrate 60 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_34e9dce6-5012-4c03-a20b-ba0ebfd14f91_600x600.png?v=1706585805",
    short_desc:
      "Zinc plays a crucial role in immunity and absorption of B vitamins. Assists in digestion and metabolism and tissue respiration. Helps metabolize carbohydrates, form healthy tissue and collagen and is essential for healthy fetal and reproductive development as well as prostate function.",
    delivery_form: "Capsules",
    directions:
      "1 capsule daily, with a meal or as directed by a health professional.",
  },

  {
    id: 4908792447107,
    title: "Meta-Sitosterol 2.0",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/Meta-Sitosterol2.0_90T_LME044Q1_250cc_600x600.png?v=1706120867",
    short_desc:
      "A balanced blend of plant sterols to support healthy cholesterol levels and overall cardiovascular health.",
    delivery_form: "Tablets",
    directions:
      "One tablet with each meal or as directed by your healthcare practitioner.",
  },

  {
    id: 4908871385219,
    title: "CoQ10: Ubiquinol QH: 100 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_2406848d-fbe8-446f-9a4f-c366b724c129_600x600.png?v=1705622180",
    short_desc:
      "Ubiquinol is the active antioxidant form of CoQ10 and this formula is unique in it's composition, making it especially important for older individuals, those with lots of oxidative and physical stress, or those don't respond to regular CoQ10 supplementation.",
    delivery_form: "Softgel Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-2 times daily, with meals.",
  },

  {
    id: 4908768231555,
    title: "5-HTP Synergy",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/HTP090_600x600.png?v=1709775625",
    short_desc:
      "Stress lowers feel-good neurotransmitter serotonin. This leads to food cravings, depression and other mood disorders. This replenishes levels naturally in the activated form of vitamin B6 to support healthy moods, and to help reduce food cravings.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take one capsule per day or as directed by your health care practitioner.",
  },

  {
    id: 4908781469827,
    title: "VitaPrime",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/VTP_hires_web_600x600.png?v=1709775529",
    short_desc:
      "Just twice daily multi for those looking for less supplements, and iron-free. A strong core of vitamins and minerals with enhanced antioxidant protection, broader trace mineral nutrition and heightened B vitamin support.  60 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "Adults: 2 tablets daily with food. Children 4 to 14: Take 1 tablet daily with food or as directed by healthcare professional. Children less than 4 years of age: As directed by healthcare professional.",
  },

  {
    id: 4908869648515,
    title: "Estrovera Perimenopause \u0026 Menopause Relief",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/100847_600x600.jpg?v=1742568134",
    short_desc:
      "Significantly shown to reduce menopausal hot flashes, in an all natural therapy as opposed to low-dose hormone therapies. May help with sleep disturbances, irritability, anxiety, heart health, joint and muscle soreness, urinary tract symptoms, vaginal dryness and sexual problems.",
    delivery_form: "Tablets",
    directions:
      "As a dietary supplement, take one tablet with food and a glass of water once daily at the same time of day or as directed by your healthcare practitioner.",
  },

  {
    id: 4908828754051,
    title: "Zen 200mg",
    vendor: "Allergy Research Group",
    image: "//drhyman.com/cdn/shop/files/zen_600x600.png?v=1708302058",
    short_desc:
      "A unique and natural way to promote relaxation without sedation. L-theanine and GABA stimulate alpha-wave activity in the brain, to reduce anxiety while increasing mental alertness and acuity.60 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "2 capsules, one to two times per day, or as directed by a healthcare practitoner.",
  },

  {
    id: 4908787990659,
    title: "BioPure Protein",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/BioPureProtein_1530503L1_58oz_600x600.png?v=1706040100",
    short_desc:
      "Pure high quality whey protein with naturally occurring antibodies to support lean muscle mass, healthy immune function and intestinal health. Low fat, low sodium and 95% lactose free.",
    delivery_form: "Powder",
    directions:
      "Mix two scoops (20g) with a cold beverage or add to your favorite recipe once daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908774457475,
    title: "Metabolic Synergy",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/msc180_metabolic-synergy_400cc_ipsos-badge_600x600.png?v=1742310964",
    short_desc:
      "This highly potent multivitamin and mineral formula was designed by a doctor specializing in blood sugar and endocrine health, for superior magnesium, chromium, zinc, manganese and vanadium chelates and their absorption into the body.",
    delivery_form: "Capsules",
    directions:
      "Take three capsules twice per day with a meal, or as directed by your health care practitioner.",
  },

  {
    id: 4908813942915,
    title: "NAC 600mg - 180 count",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_a4ea47b5-b6cf-4897-96b5-9dbbd78cc32c_600x600.png?v=1705970162",
    short_desc:
      "Fights free-radicals and is a key component of a healthy antioxidant-rich immune system, helps to chelate heavy metals and remove them from the body, and especially supportive of lung tissue.180 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "3 capsules per day, in divided doses, between meals or as directed by your health care practitioner.",
  },

  {
    id: 4908993904771,
    title: "Food: What the Heck Should I Eat?",
    vendor: "UWC",
    image:
      "//drhyman.com/cdn/shop/products/foodbooksite_600x600.png?v=1587241417",
    short_desc:
      "Food: What the Heck Should I Eat? is a no-nonsense guide to achieving optimal weight and lifelong health.",
    delivery_form: "Book",
    directions: "",
  },

  {
    id: 4908803555459,
    title: "D3 2000 Complex (formally Iso D3 2000 IU)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/102824_600x600.jpg?v=1742568102",
    short_desc:
      "Vitamin D complex with isoflavones for better utilization and enhanced health benefits. Supports healthy immune system, bone density and overall wellness.",
    delivery_form: "Tablets",
    directions:
      "Take 1 tablet daily with food or as directed by your health care practitioner.",
  },

  {
    id: 4908824330371,
    title: "VitaTab Chewable",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/VCW.250_hires_web_600x600.png?v=1709775835",
    short_desc:
      "Chewable multi-vitamin and mineral wafers formulated for kids but perfect for anyone who has trouble swallowing pills. Two tablets daily provides three times the RDA levels of vitamin C and E, and twice the RDA for most B vitamins. Includes easy to absorb minerals, no artificial colors or flavors.  60 ct. chewable tablets",
    delivery_form: "Chewable Tablets",
    directions:
      "1 capsule, 1 to 4 times daily or as directed by a healthcare professional.",
  },

  {
    id: 4908888719491,
    title: "Chromium (picolinate) 500 mcg. 60 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_45b13cca-ffe1-4c93-ad72-81931b13059f_600x600.png?v=1705621801",
    short_desc:
      "Chromium supports lipid and glucose metabolism and is important for fat metabolism, enzyme activation, and glucose support. It promotes healthy lipid and carbohydrate utilization.",
    delivery_form: "Capsules",
    directions: "1 capsule, 1-2 times daily, with meals.",
  },

  {
    id: 4908990136451,
    title: "Tri-Fortify Watermelon Gel",
    vendor: "Researched Nutritionals",
    image:
      "//drhyman.com/cdn/shop/files/Tri-FortifyWatermelon-Tube_600x600.png?v=1709775988",
    short_desc:
      "An essential antioxidant to help with detoxification in the body, this gel is designed to bypass the digestive process for faster nutrient absorption and utilization by directly entering the bloodstream. Delicious watermelon flavor.",
    delivery_form: "Gel",
    directions:
      "As a dietary supplement, gently squeeze the tube to fill 1 teaspoon (5 mL), and then swallow or use as directed by your health care professional.",
  },

  {
    id: 4908852281475,
    title: "Omega Twin",
    vendor: "Barlean",
    image:
      "//drhyman.com/cdn/shop/products/bar-othlo12oz_600x600.jpg?v=1710208927",
    short_desc:
      "Nourish your body with a pure and unrefined blend of organic flax and borage oil for essential omega-3/6/9 balance. This is the leading essential fatty acid formula for overall health and immunity.",
    delivery_form: "Liquid",
    directions:
      "You'll want to give the bottle a vigorous shake before your daily serving since we've left in some of the flax particulate, which provide powerful antioxidant flax lignans. 1-2 Tbsp. daily, can be used in salad dressings, mixed with yogurt, cottage cheese, oatmeal, blended beverages &amp; protein drinks.",
  },

  {
    id: 4908805357699,
    title: "ProOmega 120 gels Lemon",
    vendor: "Nordic Naturals",
    image: "//drhyman.com/cdn/shop/files/Untitled-3_600x600.png?v=1709584977",
    short_desc:
      "A high concentration of EPA and DHA essential fatty acids, essential for optimal growth and development throughout our lives. 70% pure omega-3 and completely free of PCBs and heavy metals.120 ct. softgels",
    delivery_form: "Softgel Capsules",
    directions:
      "Two soft gels daily, with food, or as directed by your health care professional or pharmacist. For intense support, take two soft gels with food twice daily.",
  },

  {
    id: 6597320638595,
    title: "Dutch Harbor Omega Maintain Capsules",
    vendor: "Big Bold Health",
    image:
      "//drhyman.com/cdn/shop/files/DutchHarborOmegaCapsules_600x600.png?v=1705360731",
    short_desc:
      "The pristine waters of the Aleutian Islands are home to scores of fish species, including one that has been linked to health and wellness for more than a century: Alaskan Cod. This is a fish that contains high levels of omega-3 fatty acids, including EPA, DHA, and DPA.",
    delivery_form: "Softgel Capsules",
    directions:
      "Take 2 softgels, 1 to 2 times daily with food or as directed by your healthcare practitioner",
  },

  {
    id: 4908864602243,
    title: "Adreset 60 ct. RS",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/adre60_600x600.jpg?v=1742567943",
    short_desc:
      "Extracts of adaptogenic herbs, ginseng, rhodiola and cordyceps provide support for people who are “stressed and tired”. Helps the body adapt to stressful environments and the negative effects of stress for overall energy, mental clarity and wellness.",
    delivery_form: "Capsules",
    directions:
      "1 capsule daily with food, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908772982915,
    title: "Quercetin and Nettles",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/QuercetinandNettles_600x600.png?v=1709776076",
    short_desc:
      "Nettles have long been documented in treating coughs, tuberculosis, arthritis and in stimulating hair growth. Quercetin has anti-inflammatory and anti-histamine properties, protects good LDL cholesterol levels and has anti-estrogenic",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take one or three capsules daily with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908818563203,
    title: "Buffered Ascorbic Acid Capsules - 250 count",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_f368672e-93d1-48fb-9a57-dd3a62e93a5b_600x600.png?v=1705621096",
    short_desc:
      "Buffered ascorbic acid combines calcium ascorbate, magnesium ascorbate, and potassium ascorbate to create a neutral pH vitamin C, essential for overall health and wellness.250 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "1 capsule, 1-4 times daily, with or between meals, or as directed by a health professional",
  },

  {
    id: 4908864962691,
    title: "MetaGlycemX 60 ct.",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105414_600x600.jpg?v=1742568229",
    short_desc:
      "A highly potent combination of green tea extract, cinnamon and alpha-lipoic acid for help maintaining blood sugar levels, supporting insulin balance and protecting pancreatic cells. Antioxidants help fight free radicals and can aid in glucose transport between cells and overall blood sugar control. Also helps to reduce oxidative stress.",
    delivery_form: "Tablets",
    directions:
      "Take two tablets once daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908910674051,
    title: "Wellness Essentials Active Daily Packs",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105963_600x600.jpg?v=1742568678",
    short_desc:
      "Weekend warriors or anyone concerned with joint flexibility, mobility, and comfort, may benefit from extra nutritional support for joint health. This is formulated to target your unique nutritional needs to help you stay active, vital and maintain overall health.",
    delivery_form: "Daily Packet",
    directions:
      "One packet daily or as directed by your healtcare practitioner",
  },

  {
    id: 4908840616067,
    title: "Vitamin D3 Liquid",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/VitaminD3liquid22.5ml_600x600.png?v=1704297157",
    short_desc:
      "Supports bone, breast, prostate, cardiovascular, colon and immune health in an easy to use liquid form of essential vitamin D for quick and effective absorption. 22.5 ml liquidPlease note-*Bottle has been changed from a child-proof dropper dispensing package, to a glass bottle with dispensing insert and child proof cap (no dropper) inside box",
    delivery_form: "Liquid",
    directions:
      "1-7 drops daily, with a meal, or as directed by your health professional.",
  },

  {
    id: 4908794085507,
    title:
      "Bone Builder with Magnesium ( Formally Cal Apatite Bone Builder with Magnesium)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105007_600x600.jpg?v=1742568010",
    short_desc:
      "Superior bone health support from naturally occurring magnesium, calcium, and phosphorus, along with other trace minerals and bone proteins like collagen. Features vitamin D for enhanced bone health and muscle relaxation. 2:1 calcium to magnesium ratio.180 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "Take three tablets daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4909010124931,
    title: "ATP 360",
    vendor: "Researched Nutritionals",
    image:
      "//drhyman.com/cdn/shop/products/ATP-360-450x450_600x600.png?v=1709776501",
    short_desc:
      "ATP 360 is a comprehensive formula to support mitochondrial health and is backed by peer-reviewed, published clinical research. Using powerful, researched ingredients, ATP 360 provides targeted, effective support.",
    delivery_form: "Capsules",
    directions: "Take 3 capsules once daily with or without food.",
  },

  {
    id: 4908973588611,
    title: "MethylCare 120 ct. ( Formally Vessel Care )",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105023_600x600.jpg?v=1742568245",
    short_desc:
      "Vessel Care is a comprehensive formula that supports Healthy Methylation & Homocysteine Metabolism.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules once daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908813713539,
    title: "L-Glutamine Powder",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_5cc8ade4-509f-427d-9b5c-907de0c74644_600x600.png?v=1705865285",
    short_desc:
      "l-Glutamine, the most abundant amino acid in the body, is utilized in times of stress for tissue repair, gastrointestinal tract support, and natural defense system function. Glutamine plays a large role in maintaining healthy intestinal integrity by enhancing the intestine's protective mucosal lining. It's key in the preservation of muscle mass.227 g. powder",
    delivery_form: "Powder",
    directions:
      "2–6 teaspoons per day, in divided doses, between meals or as directed by your health care practitioner.",
  },

  {
    id: 4908824428675,
    title: "Iron Chelate",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/IRN30.120_hires_web_600x600.png?v=1709855151",
    short_desc:
      "This exceptionally well-tolerated form of iron is produced through a special process that completely bonds iron to the amino acid glycine forming iron bis-glycinate, a well absorbed form of this essential mineral. Supplies 30 mg elemental iron as iron amino acid chelate.100 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "Adults: 1 capsule daily with food or as directed by a healthcare professional. Not intended for children.",
  },

  {
    id: 4908857098371,
    title: "Ultra Potent-C 500",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/103036_600x600.jpg?v=1742568505",
    short_desc:
      "A patented formula to enhance utilization of vitamin C in the body for valuable antioxidant protection, production of collagen and connective tissue, immune function, white blood cell promotion, and in a buffered form to prevent stomach upset.",
    delivery_form: "Tablets",
    directions:
      "One tablet three times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908927516803,
    title: "PGX Daily Singles 15 ct.",
    vendor: "Natural Factors",
    image:
      "//drhyman.com/cdn/shop/files/3594-9U_PGX_SinglesGranules_BOX_7-R0816029_R_600x600.png?v=1706130677",
    short_desc:
      "Easy to use, unflavored fiber supplement that helps curb cravings and appetite so you feel more satiated, supporting healthy weight loss and stabilized blood sugar levels.",
    delivery_form: "Daily Packet",
    directions:
      "Stir 1 packet into 375–500 mL of cold water or juice before meals or as directed by your healthcare practitioner. Drink additional water (375–500 mL) after taking PGX.",
  },

  {
    id: 4908882591875,
    title: "Junior Nutrients",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_5722c0fb-5322-4b77-9c4f-3bf7c910e774_600x600.png?v=1705863628",
    short_desc:
      "Designed for children and teens ages 4 and up. It is a complete hypo-allergenic, nutrient rich, highly bioavailable multi-vitamin, multi-mineral, antioxidants and trace element supplement in small capsules for easy swallowing. Supports optimal overall health and wellness for kids.",
    delivery_form: null,
    directions:
      "Ages 4 to 13, take 2 capsules daily, with meal. Ages 14 and up, take 2 capsule twice daily, with meals.",
  },

  {
    id: 7722575331459,
    title: "Creatine",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/Creatine_600x600.png?v=1704492463",
    short_desc:
      "Promote enhanced muscle performance with the amino acid creatine.",
    delivery_form: "Powder",
    directions:
      "Mix 1 scoop with at least 8 ounces of water, juice, or preferred beverage daily or as recommended by your health-care or performance professional. Can be used 30-90 minutes before or after exercise.",
  },

  {
    id: 4908819316867,
    title: "Resveratrol 120 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_b51f7f98-7415-4f5c-b60e-fee41c583cf6_600x600.png?v=1706585316",
    short_desc:
      "A compound associated with health benefits of red wine, with powerful antioxidant and heart protective properties. Promotes healthy platelet function, this Resveratrol is sourced from one of the richest and oldest herbs used for centuries.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions: "1-5 capsules daily, with or between meals.",
  },

  {
    id: 4908902580355,
    title: "Quercetin 120ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_986bc614-3ba7-4dfe-ae6d-de7ef674caa0_600x600.png?v=1706584882",
    short_desc:
      "Quercetin has been shown to be one of the most bioactive flavonoids, and helps maintain healthy histimine production by supporting healthy enzyme activity.",
    delivery_form: "Capsules",
    directions: "2 capsules, 1-2 times daily, between meals.",
  },

  {
    id: 4908842418307,
    title: "Boluoke Lumbrokinase",
    vendor: "Researched Nutritionals",
    image:
      "//drhyman.com/cdn/shop/files/circ_c0992314-49d6-4da1-b36c-17192cd54f92_600x600.png?v=1709592487",
    short_desc:
      "The only fully researched oral fibrinolytic supplement on the market. This is the process that prevents blood clots from growing. Beneficial for any illness that has an accompanying hypercoagulable blood state, shown to be present in many chronic illnesses. Recommended for some on hormone replacement therapy or birth control pills, and some who can't tolerate standard preventative pharmaceutical drugs.",
    delivery_form: null,
    directions:
      "If Boluoke is to be taken for chronic conditions, it should be taken at the dose of 1 capsule one to three times daily on an empty stomach. However, the practitioner may recommend 2 capsules three times daily for 3 to 6 weeks in conditions with severe hypoperfusion. The therapeutic dose for children (according to the manufacturer)is 1 capsule per 8Kg (about 17 pounds) per day. If the lumbrokinase is emptied out from the capsule, still try to take the powder on an empty stomach.",
  },

  {
    id: 4908777996419,
    title: "HepatoThera Forte",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/HEPF_hires_web_600x600.png?v=1709776374",
    short_desc:
      "Formulated for intense intestinal support. Provides nutrients that support antioxidant pathways, detoxification mechanisms, and enzyme regulation during illness or significant exposure to chemical toxins, heavy metals, drugs, hepatitis C and other viral burdens.",
    delivery_form: "Capsules",
    directions:
      "Adults: 1 capsule, 3 times daily with food or as directed by a healthcare professional. Children 4 to 14 years: Take 1 capsule daily or as directed by a healthcare professional. Children less than 4 years of age: As directed by a healthcare professional.",
  },

  {
    id: 4909011435651,
    title: "Cortisol Manager Allergen Free",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/z02hyz4bg9mf52fxkwe6_600x600.webp?v=1705617710",
    short_desc:
      "Cortisol Manager AF is formulated with stress-reducing ingredients and botanicals to promote relaxation, help alleviate fatigue, and support healthy cortisol levels.",
    delivery_form: "Capsules",
    directions:
      "For adults, take 1 capsule before bedtime or as recommended by your healthcare professional. Increase to 2 capsules during times of high stress. For every night use.",
  },

  {
    id: 4908985974915,
    title: "BIOHM Probiotic Supplement",
    vendor: "BIOHM",
    image:
      "//drhyman.com/cdn/shop/products/biohm_probiotic_grounded-600x400_600x600.jpg?v=1587241336",
    short_desc:
      "On SALE-SAVE $15 a bottle! While supplies last. Product dated to expire 2/28/2021",
    delivery_form: "Capsules",
    directions: "",
  },

  {
    id: 4908815483011,
    title: "Zinc citrate 180 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_81495db2-7128-4670-b763-8f1f84ae6ae9_600x600.png?v=1706585887",
    short_desc:
      "Zinc is super important in immunity, digestion, metabolism function and healthy tissue and collagen formation. Crucial for normal fetal and reproductive development in women, and a healthy prostate for men.180 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "1 capsule daily, with a meal or as directed by a health professional",
  },

  {
    id: 4909007863939,
    title: "EstroFactors Capsules Healthy Estrogen Support",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/100398_600x600.jpg?v=1742568118",
    short_desc:
      "EstroFactors now features BioResponse DIM complex technology, which may support the 2-hydroxyestrone pathway and promote healthy estrogen metabolism, as well as support breast comfort during normal estrogen cycles in women. Now in an easier-to-take capsule form.",
    delivery_form: "Capsules",
    directions:
      "Take two capsules once or twice daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4909002850435,
    title: "Biomega-1000",
    vendor: "Biotics",
    image: "//drhyman.com/cdn/shop/products/biomega_600x600.png?v=1587241501",
    short_desc:
      "Biomega-1000™ provides a potent dose of omega-3 essential fatty acids (EFAs), sourced from the cold Pacific waters off the coast of South America, guaranteeing the freshest raw material available, full traceability of the products and unparalleled purity.",
    delivery_form: "Softgel Capsules",
    directions:
      "One (1) softgel capsule with each meal as a dietary supplement or as otherwise directed by a healthcare professional.",
  },

  {
    id: 4908915687555,
    title: "Sinatrol (RS)",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/516-60-Sinatrol_600x600.png?v=1705958610",
    short_desc:
      "The standardized botanical extracts and nutrients in Sinatrolsupport sinus health by reducing the viscosity of mucus, clearing airway passages, and promoting nasal microbial and inflammatory balance.",
    delivery_form: "Capsules",
    directions:
      "3 capsules per day or as recommended by your health careprofessional.",
  },

  {
    id: 4908804898947,
    title: "Arctic-D Cod Liver Oil - Lemon",
    vendor: "Nordic Naturals",
    image: "//drhyman.com/cdn/shop/files/Untitled-35_600x600.png?v=1709672208",
    short_desc:
      "100% pure Arctic Cod Liver Oil, helps improve calcium absorption to promote strong bones, may help reduce PMS symptoms and increases immunity for overall health. Includes low levels of vitamin A, has a great natural lemon flavor and no fishy taste!",
    delivery_form: "Liquid",
    directions:
      "One teaspoon daily, with food, or as directed by your healthcare professional or pharmacist. For best results, please refrigerate and use within three months after opening",
  },

  {
    id: 4908863422595,
    title: "UltraMeal RICE (Chocolate)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105401_600x600.jpg?v=1742568610",
    short_desc:
      "A delicious, non-dairy, soy-free, nutritionally fortified powdered meal replacement made from rice protein, to support healthy body composition, with essential vitamins and minerals and a low glycemic index.",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir 2 level scoops (48 g) into 8 fluid ounces of chilled water twice daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908873875587,
    title: "Zinc Supreme",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/zincs_600x600.png?v=1709776655",
    short_desc:
      "Made with chelated minerals for optimal absorption. The minerals and B vitamins in Zinc Supreme are very well tolerated and very well absorbed for optimal health and wellness.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule per day with a meal or as directed by your health-care practitioner.",
  },

  {
    id: 4908840091779,
    title: "Vitamin K2",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/VK2.75_hires_web_600x600.png?v=1706733733",
    short_desc: "",
    delivery_form: "Capsules",
    directions:
      "1 capsule daily with food or as directed by your health care practitioner.",
  },

  {
    id: 4908839633027,
    title: "Quercetin-Bromelain Forte",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/QBF.250_hires_web_600x600.png?v=1706716188",
    short_desc:
      "A mixture of enzymes and bioflavonoids from Quercetin and Bromelain to regulate the immune response during inflammatory episodes. Helps protect the cells from free radical damage and insures proper breakdown of protein molecules that cause allergic reactions.",
    delivery_form: "Tablets",
    directions:
      "2 tablets up to 4 times daily or as directed by your health care practitioner.",
  },

  {
    id: 4908827771011,
    title: "Biotin 8mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_ea915d5a-859f-4a94-b7ef-166955a21362_600x600.png?v=1705620689",
    short_desc:
      "Biotin provides potential support for healthy glucose metabolism, nerve function, and nail strength.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions: "1 capsule, 1-2 times daily, with a meal.",
  },

  {
    id: 5192932098179,
    title: "HTB Rejuvenate",
    vendor: "Big Bold Health",
    image:
      "//drhyman.com/cdn/shop/files/HTB_Rejuvenate_600x600.png?v=1705360859",
    short_desc:
      "Phytonutrients for health-promoting effects on immunity, metabolism, and cellular rejuvenation.",
    delivery_form: "Capsules",
    directions: "Take 2 capsules every day, with or without food.",
  },

  {
    id: 4908945375363,
    title: "B12 Folate 60's",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/B12Folate60_s_600x600.png?v=1704338719",
    short_desc:
      "B12 Folate provides powerful support for the GI tract, nervous system and aids in the metabolism of fats and protein. It helps skin, hair and liver integrity and is necessary for healthy fetal development.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-2 times daily, with meals.",
  },

  {
    id: 4908836028547,
    title: "BiotaGen Capsules",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-BTGC_hi_res_web_600x600.png?v=1697653722",
    short_desc:
      "Prebiotic formula to help support optimal gut and bowel function and to support optimal immunity. Activates beneficial bacteria growth for a flourishing gut environment for overall health.",
    delivery_form: "Capsules",
    directions:
      "4 capsules once or twice daily or as directed by your health care practitioner.",
  },

  {
    id: 4908829802627,
    title: "ImmuCore",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105423_600x600.jpg?v=1742568183",
    short_desc:
      "Ideal for long term immune protection, designed to support a healthy immune system with zinc, mushroom extracts, oleanolic acid, selenium and vitamin C.",
    delivery_form: "Tablets",
    directions:
      "Three tablets daily with food for up to three months or as directed by your healthcare practitioner.",
  },

  {
    id: 4908836421763,
    title: "Evening Primrose Oil - Bioactive GLA",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/EPO_hires_web_600x600.png?v=1709776594",
    short_desc:
      "The seed oil of Evening Primrose (Oenothera biennis) provides gamma-linolenic acid (GLA), an essential omega-6 fatty acid. Cold-pressed without hexane or other solvents, these softgels contain 76 mg of biologically active GLA. Evening primrose supports cartilage and joint function, neuroendocrine and cognitive health, skin and connective tissue health, and helps maintain nerve function, and cardiovascular health.†",
    delivery_form: "Softgel Capsules",
    directions:
      "Adults: 1 softgel, 1 to 2 times daily with food or as directed by a healthcare professional.",
  },

  {
    id: 4908914540675,
    title: "PhytoMulti Multivitamin with Iron",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/101845_600x600.jpg?v=1742568383",
    short_desc:
      "A powerful multivitamin, with iron, to take you beyond basic wellness support. A blend of 13 concentrated extracts and phytonutrients to protect your cells and activate your health potential like no other supplement.",
    delivery_form: "Tablets",
    directions:
      "Take one to two tablets once daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908801097859,
    title: "OmegaGenics EPA-DHA 2400",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/102269_600x600.jpg?v=1742568274",
    short_desc:
      "Super concentrated EPA and DHA essential omega-3 fatty acids from sustainably sourced, cold-water fish. A natural light lemon flavor with antioxidants to maximize freshness.",
    delivery_form: "Liquid",
    directions:
      "Take one teaspoon(5 ml)one to three times daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908838158467,
    title: "Glucosamine/Chondroitin",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/GCH_hires_web_600x600.png?v=1709776871",
    short_desc:
      "A popular and powerful combination for the joints. Chondroitin sulfate supports synthesis of cartilage tissue and inhibits cartilage degrading enzymes. Using both chondroitin and glucosamine offers conjoined and specific benefits.",
    delivery_form: "Capsules",
    directions:
      "1 capsule three times daily with food or as directed by your health care practitioner.",
  },

  {
    id: 4909013926019,
    title: "HistaQuel",
    vendor: "Researched Nutritionals",
    image: "//drhyman.com/cdn/shop/files/Histaquel_600x600.png?v=1708311276",
    short_desc:
      "Histaquel™ combines seven flavonoids shown to support healthy mast cell function by promoting a healthy amount of histamine release, along with herbs shown to block histamine from attaching to receptors via competitive inhibition.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules twice per day with or without meals.",
  },

  {
    id: 4909003800707,
    title: "Theracurmin HP",
    vendor: "Integrative Therapeutics",
    image: "//drhyman.com/cdn/shop/files/TheraC_600x600.webp?v=1725648937",
    short_desc:
      "Theracurmin HP provides 180 mg curcumin in only two capsules allowing for flexibility in dosing.",
    delivery_form: "Capsules",
    directions:
      "Aduts take 2 capsules daily or as recommended by a heathcare professional.",
  },

  {
    id: 4908983451779,
    title: "Arctic Cod Liver Oil Capsules",
    vendor: "Nordic Naturals",
    image: "//drhyman.com/cdn/shop/files/Untitled-15_600x600.png?v=1739908044",
    short_desc:
      "Supports heart and brain health.Essential for proper function of the immuneand nervous systems.",
    delivery_form: "Softgel Capsules",
    directions:
      "Three soft gels daily, with food, or as directed by your health care professional or pharmacist.",
  },

  {
    id: 4908917981315,
    title: "CoQ10 ST-100 60 SG (100 mg)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/100920_600x600.jpg?v=1742568083",
    short_desc:
      "CoQ10 has potent antioxidant properties to help support cell function, healthy blood pressure, energy production and overall cardiovascular health. This includes vitamin E to help support the CoQ10 activity and is often used when taking statins to prevent a deficiency in CoQ10. Easy to take soft gel.",
    delivery_form: "Softgel Capsules",
    directions:
      "Take one softgel daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908921815171,
    title: "PhytoMulti Multivitamin Capsules",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/101841_600x600.jpg?v=1742568340",
    short_desc:
      "A concentrated and high potency blend of vitamins, minerals, plant extracts, phytonutrients including lycopene, lutein and resveratrol, to help recharge, nourish and defend cells.",
    delivery_form: "Capsules",
    directions:
      "Take one to three capsules once daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908802244739,
    title: "Zinc A.G.™ 20mg",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105932_600x600.jpg?v=1742568730",
    short_desc:
      "GI Friendly, Highly Absorbable Zinc. Zinc A.G.features a 100% nutrient-dense formula in that each of the active ingredients—zinc, arginine, and glycine—play important and well-established physiologic roles.",
    delivery_form: "Tablets",
    directions:
      "One tablet one to two times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908945113219,
    title: "PureGenomics Multivitamin 60s",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_960ba168-9519-43ab-a580-2db42b5d8db1_600x600.png?v=1706584694",
    short_desc:
      "Multivitamin/mineral complex targeting common genetic polymorphisms.",
    delivery_form: "Capsules",
    directions: "As a dietary supplement, take 1 capsule daily, with a meal.",
  },

  {
    id: 4908815908995,
    title: "UltraNutrient",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/ultra2_600x600.png?v=1709662105",
    short_desc:
      "So much nutritional support packed into this multivitamin! Antioxidants, vitamins, minerals, botanicals, alpha-lipoic acids, CoQ10, glutathione, extracts of hawthorn, ginger, milk thistle and turmeric, this is for optimal heart health and overall wellness.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 3 capsules, 1-2 times daily, with meals.",
  },

  {
    id: 4908841304195,
    title: "UltraFlora Acute Care Probiotic",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/102310_600x600.jpg?v=1742568557",
    short_desc:
      "Targeted immune and intestinal support, this offers concentrated probiotics to maintain a healthy digestive tract and a good intestinal flora balance for overall health and wellness.",
    delivery_form: "Capsules",
    directions:
      "One capsule one to two times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908864077955,
    title: "Best-Rest Formula",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/best_rest1_600x600.png?v=1705620451",
    short_desc:
      "Best-Rest Formula supports healthy sleep cycles by encouraging an easy transition to sleep and a restful night's sleep.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, 30-60 minutes before bedtime.",
  },

  {
    id: 4908807684227,
    title: "l-Tyrosine",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_af97d165-cfa7-42d1-acbc-b8681c13df00_600x600.png?v=1705630952",
    short_desc:
      "This amino acid helps support emotional well-being and mental function, promotes healthy neurotransmitter function in response to environmental and emotional stress, cognitive function and memory, helps enhance mood and sleep patterns, and is a key component in thyroid hormone function. 90 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take1 capsule, 1-4 times daily, between meals",
  },

  {
    id: 4908796117123,
    title: "Chasteberry Plus PMS Relief (Chasteberry Plus)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105279_600x600.jpg?v=1742568061",
    short_desc:
      "Chasteberry Plus is a special formula designed for menstrual and reproductive health in women in their childbearing years.",
    delivery_form: "Tablets",
    directions:
      "One tablet twice daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908886720643,
    title: "CoQ10: Ubiquinol QH: 50 mg (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_e418947a-a510-4ffe-b741-5ee4ebae68ec_600x600.png?v=1705622747",
    short_desc:
      "Active antioxidant form of CoQ10, especially important for the elderly or anyone experiencing greater levels of oxidative or physical stress. This form absorbs into the gastrointestinal tract easily.",
    delivery_form: "Capsules",
    directions:
      "1–2 softgels daily with meals or as directed by your healthcare practitioner.",
  },

  {
    id: 4908968837251,
    title: "Curcum-Evail 400",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/curc_600x600.png?v=1709777241",
    short_desc:
      "Curcum-Evail is a highly bioavailable curcuminoid formulation containing three bioactive, extensively researched curcuminoids. Curcumin is derived from turmeric (Curcuma longa), which is used both medicinally and as a spice. Curcumin supports healthy metabolism, cellular function, and healthy cardiovascular and neurological functions. It also supports a healthy response to oxidative stress and a normal inflammatory response within the body.*  Designs for Health's proprietary Evail™ emulsification technology is designed to enhance the bioavailability and absorption of bioactive ingredients. The Evail™ process uses a quillaja extract, along with delta- and gamma-tocotrienols and medium-chain triglycerides (MCTs) to support absorption.",
    delivery_form: "Capsules",
    directions:
      "Take one softgel per day with a meal, or as directed by your healthcare professional",
  },

  {
    id: 4908922175619,
    title: "GI-Revive 225 gram Powder",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/GI-Revive225gramPowder_600x600.png?v=1709777114",
    short_desc:
      "Comprehensive support for those with poor gut function and integrity, food sensitivities and compromised nutrient absorption. Provides therapeutic levels of L-glutamine, herbs and fiber for soothing regularity and gut wall permeability. Helps support overall immunity and health.",
    delivery_form: "Powder",
    directions:
      "Mix 8 grams (approx. one scoop) in water or other liquid per day, or as directed by your health care practitioner.",
  },

  {
    id: 4908901793923,
    title: "E.P.O. Evening Primrose Oil",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image86_e84bfc06-1785-4396-83f0-644879ed92c4_600x600.png?v=1705717670",
    short_desc:
      "Cold-pressed evening primrose oil to support healthy skin, cardiovascular function and women's premenstrual phase.",
    delivery_form: "Softgel Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-4 times daily, with or between meals.",
  },

  {
    id: 4908891242627,
    title: "Ther-biotic Saccharomyces Boulardii 60 ct.",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/V776-06_hires_web_600x600.png?v=1708304264",
    short_desc:
      "A super potent and high quality microorganism used to treat diarrhea and dysentery. Supports healthy gut function and immunity, may help reduce inflammation and supports the gut, especially in cases of C diff, IBS, traveler's and antibiotic related diarrhea.",
    delivery_form: "Capsules",
    directions:
      "One capsule twice daily with meals or as directed by a healthcare practitioner.",
  },

  {
    id: 4908894257283,
    title: "Silymarin 80",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/Silymarin80_90T_LSY001T3_60cc_600x600.png?v=1706201289",
    short_desc:
      "Standardized milk thistle seed extract, standardized to 80% silymarin, an active compound noted for its antioxidant properties and support for healthy liver function. Very helpful during any detox program.",
    delivery_form: "Tablets",
    directions:
      "Take one tablet three times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908881838211,
    title:
      "UltraMind Solution Book: Fix Your Broken Brain by Healing Your Body First (Paperback)",
    vendor: "Simon & Schuster",
    image:
      "//drhyman.com/cdn/shop/files/81BixrUGznL._SL1500_600x600.jpg?v=1705718984",
    short_desc:
      "The essential guide to unleashing the body's ability to dramatically improve mood, memory and thinking speed. Become happy, peaceful, calm, centered, yet sharp, focused, alert and wide-awake. This is supportive of those who suffer from depression, ADD, Alzheimer's, brain fog, anxiety and so much more.",
    delivery_form: "Book",
    directions: "",
  },

  {
    id: 4908946456707,
    title: "10-Day Detox Diet (Hardcover Book)",
    vendor: "Hyman Enterprises",
    image:
      "//drhyman.com/cdn/shop/products/sugar11f-5-web_600x600.jpg?v=1587240966",
    short_desc:
      "In his best-selling book Dr. Hyman explains why we get stuck and how we can achieve lasting weight loss goals, reverse chronic conditions, improve youroverall optimal health andrestart the rest of your life. All in just 10 days!",
    delivery_form: "Book",
    directions: "",
  },

  {
    id: 4908980994179,
    title: "Liver-G.I. Detox",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_0aa1da1a-619f-4ce6-abf8-faf46cdd8464_600x600.png?v=1705865973",
    short_desc:
      "Liver-G.I. Detox promotes hepatic and gastrointestinal detoxification by providing nutrients and botanical extracts that enhance toxin elimination, digestion, intestinal motility, gut integrity and cell function.",
    delivery_form: "Capsules",
    directions: "2 capsules daily, with meals",
  },

  {
    id: 4908813320323,
    title: "l-Glutamine 500mg capsules",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_cc8d7956-32e5-4e1e-8e0e-bb474b2c8b73_600x600.png?v=1705631104",
    short_desc:
      "l-Glutamine is the most abundant amino acid in the body and supports tissue repair, stress reduction, GI tract support and immune function. Enhances the intestine's protective mucosal lining and preserves muscle mass in the body.90 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "1 capsule, 1-4 times daily, between meals, or as directed by a health professional",
  },

  {
    id: 4908923027587,
    title: "Basic Prenatal",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/vmp-front_600x600.png?v=1709777654",
    short_desc:
      "New & ImprovedBasic Prenatal is a comprehensive supplement formulated with the special needs of pregnancy in mind. No additives and highly potent without stomach upset. Can also be taken by nursing mothers, includes iron and folate.",
    delivery_form: "Capsules",
    directions:
      "Take 3 capsules daily with food or as recommended by your health professional.",
  },

  {
    id: 7874800746627,
    title: "Akkermansia",
    vendor: "Pendulum",
    image:
      "//drhyman.com/cdn/shop/products/Pendulum-Akkermansia_BottleHR_fc9472f8-23c3-4f71-ac94-a53bb5fba942_600x600.png?v=1679324256",
    short_desc:
      "The only brand with Akkermansia, a beneficial microbe. Nurture your body's microbiome and help keep your gut healthy.",
    delivery_form: "Capsules",
    directions: "Adults take 1 capsule daily with food.",
  },

  {
    id: 4908808863875,
    title: "Betaine HCL Pepsin",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/image1_600x600.png?v=1705620567",
    short_desc:
      "Betaine HCl Pepsin provides optimal nutritional support for a well-functioning digestive system, necessary for adequate absorption of protein, calcium, vitamin B12 and iron. Perfect supplement for enhanced digestive function.250 ct. veg. capsules",
    delivery_form: "Capsules",
    directions: "1 capsule, 3 times daily, with each meal.",
  },

  {
    id: 4909009338499,
    title: "Bone Builder Chewable",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/BBCh_600x600.jpg?v=1742567993",
    short_desc:
      "A well-rounded formula designed to support bone mineral density and also features vitamin D and additional magnesium for enhanced bone health support.",
    delivery_form: "Chewable Tablets",
    directions:
      "Children age 2 to adults take one to three tablets once daily or as directed by your healthcare practitioner. Chew or crush tablets completely before swallowing. Do not swallow tablets whole. Children age 12 and under should not exceed the recommended serving size. If pregnant, nursing or taking antibiotics or cardiovascular medication, consult your healthcare practitioner before use.",
  },

  {
    id: 4908852805763,
    title: "Laxablend",
    vendor: "Vitanica",
    image: "//drhyman.com/cdn/shop/files/image84_600x600.png?v=1705707197",
    short_desc:
      "An effective natural combination of minerals and botanicals, promoting quick relief from occasional constipation.Contains no preservatives, binders, artificial colorings or flavorings, sucrose, glucose, starch, lactose, salt, wheat, gluten, soy or dairy products.",
    delivery_form: "Capsules",
    directions:
      "One (1) to two (2) capsules up to twice daily. For temporary use only.",
  },

  {
    id: 4908854739075,
    title: "Ostera Supports Bone Health",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/104957_600x600.jpg?v=1742568315",
    short_desc:
      "Includes berberine, hops extract, vitamin K, D and iso-alpha acids to help post-menopausal women with bone repair, mineralization, metabolic process and overall integrity.",
    delivery_form: "Tablets",
    directions:
      "Take one tablet twice daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908930400387,
    title: "PurePaleo Protein Chocolate (Bone Broth Protein Isolate)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/PurePaleoProtein-Chocolate_600x600.png?v=1640033414",
    short_desc:
      "Features a highly concentrated, pure beef protein to provide beef-specific nutrients and promote healthy body composition.* Ideal for those on a Paleo-style diet.*",
    delivery_form: "Powder",
    directions:
      "Mix 27 grams (approximately one scoop) in 8 ounces of water or any other beverage per day, or as directed by your health-care practitioner. Use a blender or shaker bottle, and shake or mix well. For best blending results, the liquid should be at room temperature.",
  },

  {
    id: 4908932268163,
    title: "PurePaleo Protein Vanilla ((Bone Broth Protein Isolate))",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/PurePaleoProtein_40281de0-acb2-4791-93a1-86839cf53273_600x600.png?v=1709779673",
    short_desc:
      "Features a highly concentrated, pure beef protein to provide beef-specific nutrients and promote healthy body composition.* Ideal for those on a Paleo-style diet.*",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, mix 27 grams (approx. one scoop) in eight ounces of water or any other beverage per day, or as directed by your health care practitioner.",
  },

  {
    id: 4908992266371,
    title: "PurePea Vanilla",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/PurePeav_600x600.png?v=1709779865",
    short_desc:
      "PurePea™, a natural pea protein isolate, offers a high level of functionality and nutritional benefits. PurePea™ is a true vegan protein which has high bioavailability and excellent digestibility.* The raw materials, North American grown yellow peas, are not genetically modified (non-GMO) and are produced with a natural fermentation process which uses no chemical solvents.",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, mix 30 grams (approx. 2 heaping scoops) in eight ounces of water or any other beverage per day, or as directed by your health care practitioner.",
  },

  {
    id: 4908984893571,
    title: "Inflavonoid Intensive Care",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/102299_600x600.jpg?v=1742568197",
    short_desc:
      "NEW &  IMRPOVEDInflavonoid Intensive Care  features highly bioavailable CurQfen BSW (curcuminoids, AKBA from Boswellia, and fenugreek) and XNT ProMatrix (xanthohumol), which may help support the body's response to oxidative stress and offers ginger extract, which may help support the body's immune response.*",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules once daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908867518595,
    title: "Ther-biotic Saccharomyces Boulardii 120 ct.",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/V776-12_hires_web_600x600.png?v=1709777539",
    short_desc:
      "Highly effective probiotic that is not affected by antibiotics. Lactose-free and gluten-free. Available in vegetarian capsules.",
    delivery_form: "Capsules",
    directions:
      "1 capsule twice daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908775407747,
    title: "K+2 Potassium",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/K_2Potassium_600x600.png?v=1709777725",
    short_desc:
      "This uniquely formulated potassium provides alkalinizing properties and blood pressure support. Potassium deficiency symptoms include fatigue, lethargy, cramping or twitching, heavy legs, and the feeling of depression, and this product may help relieve these.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take one to four capsules per day with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908873547907,
    title: "PaleoGreens Powder Unflavored (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/PaleoGreensPowderUnflavored_600x600.png?v=1709777313",
    short_desc:
      "Delicious and potent greens formula made with over 90% organic vegetable, fruit and berry ingredients, with a paleo profile, free of grains, legumes, corn, and fillers. Uniquely harvested, processed and packaged to retain potency to support optimal health and vitality.",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, take 9 grams (approximately one tablespoon) mixed with water or as directed by your health care practitioner.",
  },

  {
    id: 4908827279491,
    title: "SpectraZyme Pan 9x ES (Formerly Azeo-Pangen Extra Strength)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/SpectraZymePan9xES_90T_LSP032H1_200cc_600x600.png?v=1706201649",
    short_desc:
      "A comprehensive enzyme complex that helps promote healthy digestive function. Azeo-Pangen Extra Strength has twice the digestive enzyme strength of regular Azeo-Pangen.90 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "One tablet with each meal or as directed by your healthcare practitioner.",
  },

  {
    id: 4908912443523,
    title: "Digestion GB",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/digestion-gb-180-s-dgb1_1_600x600.png?v=1719004801",
    short_desc:
      "Digestive enzymes, bile salts, taurine and herbal extracts (milk thistle and curcumin) for healthy gall bladder function and fat and lipid utilization, to support overall health in the  digestive system.",
    delivery_form: "Capsules",
    directions:
      "2 capsules, with each meal, or as directed by a health professional",
  },

  {
    id: 4908960284803,
    title: "PurePaleo Protein Unflavored (Bone Broth Protein Isolate)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/PurePaleoProtein_600x600.png?v=1709780241",
    short_desc:
      "Features a highly concentrated, pure beef protein to provide beef-specific nutrients and promote healthy body composition.* Ideal for those on a Paleo-style diet.*",
    delivery_form: "Powder",
    directions:
      "Mix 27 grams (approximately one scoop) in 8 ounces of water or any other beverage per day, or as directed by your health-care practitioner. Use a blender or shaker bottle, and shake or mix well. For best blending results, the liquid should be at room temperature.",
  },

  {
    id: 4908871811203,
    title: "CoQ10: Ubiquinol QH: 200 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_730da2e5-2f85-4c22-b892-1ffd0e67521e_600x600.png?v=1705622631",
    short_desc:
      "Active antioxidant form of CoQ10, and important for the elderly and anyone with greater risk of oxidative or physical stress. Supports healthy aging and heart health.",
    delivery_form: "Softgel Capsules",
    directions: "1 capsule, 1-4 times daily, with meals.",
  },

  {
    id: 4908824854659,
    title: "ProEPA with Concentrated GLA (RS)",
    vendor: "Nordic Naturals",
    image:
      "//drhyman.com/cdn/shop/files/03090RI-02-ProEPA_GLA_60P_600x600.webp?v=1724693411",
    short_desc:
      "Pharmaceutical grade omega-3 fish oils with borage oil for freshness. Designed to support joint flexibility, tissue and immune function, as well as overall health.60 ct. capsules",
    delivery_form: "Softgel Capsules",
    directions:
      "Two soft gels daily, with food, or as directed by your health care professional.",
  },

  {
    id: 4908829933699,
    title: "Magnesium Citrate Soluble Powder",
    vendor: "Kirkman",
    image: "//drhyman.com/cdn/shop/files/Untitled-21_600x600.png?v=1709663262",
    short_desc:
      "One of the highest quality (purest) and easiest to use magnesium supplements, easily dissolved in liquids and pleasant taste. Supports nerves, muscles, promotes relaxation and aids in restful sleep.  Good for bones and teeth.8 oz.",
    delivery_form: "Powder",
    directions:
      "Children: 2.5 grams or 1/2 teaspoon (rounded) daily or as directed by a physician. Adults: 1/2 teaspoon daily or as directed by a physician.",
  },

  {
    id: 4908860997763,
    title: "Organic ImmunoBerry Liquid (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/IBL4OZ_organic-immunoberry-liquid_4oz_watermark_product-image_600x600.jpg?v=1709779594",
    short_desc:
      "A super strong immune support and defense against colds, flu, sinusitis, viral hepatitis, respiratory tract infections and bacterial infections, in a pleasant tasting liquid. Contains herbs, mushrooms, elderberry, wild cherry bark, all with antiviral and antibacterial properties.",
    delivery_form: "Liquid",
    directions:
      "Take 2.5 mL (2.5 droppers) per day or as directed byyour health-care practitioner.",
  },

  {
    id: 4908833177731,
    title: "VitaSpectrum Capsules",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-VTSC_hires_web_600x600.png?v=1709779471",
    short_desc:
      "Multivitamin, mineral and trace element supplement for children with Autism Spectrum Disorder, 28 highly bioavailable nutrients in amounts and ratios specifically designed for gastrointestinal function, chronic diarrhea and malabsorption, and nutritionally deficiencies arising from this common symptom and food elimination diets.",
    delivery_form: "Capsules",
    directions:
      "Adults: 6 capsules daily with food or as directed by a healthcare professional.Children: 4 - 14 years of age: Take up to 3 capsules daily or as directed by a healthcare professional.Children less than 4 years of age: As directed by health practitioner.",
  },

  {
    id: 4908771803267,
    title: "Inflammatone",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/Inflammatone_600x600.png?v=1709780046",
    short_desc:
      "A powerful formula combining science, herbs and enzyme technology to help break down inflammation causing compounds. Gentle and effective. Helps fight free radicals and removes damaged tissue which improves lymphatic drainage.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take two capsules daily, between meals, or as directed by your health care practitioner.",
  },

  {
    id: 4908770394243,
    title: "Carnitine Synergy",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/CarnitineSynergy_600x600.png?v=1709779799",
    short_desc:
      "Carnitine helps with low energy, obesity and fatigue. Promotes heart health, balanced cholesterol levels, sports endurance and recovery. Enhances brain function. This is the highest quality and purest form, in one easy to take capsule.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule per day before meals or as directed by your health-care practitioner.",
  },

  {
    id: 4908769968259,
    title: "EGCg",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/EGCg500mg_600x600.png?v=1709781270",
    short_desc:
      "Active ingredient in green tea, with potent antioxidant and DNA protective properties. Low flouride and less than 2% caffeine.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take one capsule daily with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908887867523,
    title: "Vitamin E Mixed Tocopherols",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/eyJwYXRoIjoibWV0YWdlbmljc1wvZmlsZVwvOWZXeVlSNjZFRmhlNFdUdVVYOEMucG5nIn0_metagenics_H7C_Ovb2S3hISYMbxMZedDZfGWgMcmAPgQXaXhJo-b0_600x600.png?v=1742499554",
    short_desc:
      "Unique and all natural vitamin E and mixed tocopherol complex to closely approximate what's found in plants. Helps maintain proper circulation, blood vessel integrity and blood lipids. Supports prostate, nervous system, skin, and offers free-radical protection.",
    delivery_form: "Softgel Capsules",
    directions:
      "Two softgels daily with a meal or as directed by your healthcare practitioner.",
  },

  {
    id: 5114060439683,
    title: "GlucoSupreme Herbal",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/GSH120_GlucoSupreme-Herbal_300cc_watermarked_product-image_600x600.jpg?v=1742824102",
    short_desc:
      "GlucoSupreme™ Herbal is ideal for supporting healthy insulin and glucose levels. This unique, synergistic formula combines standardized herbs and other botanicals that are shown to support healthy blood sugar through various mechanisms, including cinnamon, corosolic acid from banaba, isoflavones from kudzu, and ginsenosides from ginseng. It also contains berberine (Berberis aristata), a compound highly regarded for its efficacy in supporting healthy blood glucose regulation and insulin sensitivity.**",
    delivery_form: "Capsules",
    directions:
      "Take 4 capsules per day with meals (divided dosing recommended) or as directed by your health-care practitioner.",
  },

  {
    id: 4908811878531,
    title: "DHEA (Micronized) 25 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_0f7d1197-90c8-45f6-ab27-c6dfbf751561_600x600.png?v=1705631203",
    short_desc:
      "180 ct. veg. capsules - 25 mg.Pure Encapsulations DHEA is micronized to increase absorption. It is made with 99% pure, pharmaceutical grade DHEA.",
    delivery_form: "Capsules",
    directions: "1 capsule daily with a meal.",
  },

  {
    id: 4908930695299,
    title: "HPA Adapt",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/wcdjuksdaflx2xkobg0s_600x600.webp?v=1709781641",
    short_desc:
      "HPA Adapt™ combines five powerful adaptogenic herbs to help the body better respond to both mental and physical stressors.",
    delivery_form: "Capsules",
    directions:
      "Adults take 2-4 capsuless daily on an empty stomach, or as recommended by a healthcare professional.",
  },

  {
    id: 4908784713859,
    title: "Trancor (RS)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/106857_600x600.jpg?v=1742568492",
    short_desc:
      "Trancoris formulated to support a sense of tranquility in those who may feel worried or nervous by beneficially modulating the balance between the calming influence of GABA and the excitatory effects of glutamate.",
    delivery_form: "Capsules",
    directions:
      "Take two capsules twice daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908779077763,
    title: "Ther-Biotic Vital-Zymes™ (Chewables) (RS)",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-VCH_hires_web_600x600.png?v=1709779948",
    short_desc:
      "Chewable multi-enzyme tablets, great for kids and adults. Broad-spectrum and super effective in breaking down carbs, sugars, proteins, and fiber and helps protect against gut inflammation.",
    delivery_form: "Chewable Tablets",
    directions:
      "As a dietary supplement chew 2 tablets at the beginning of each meal or as directed by your health care practitioner.",
  },

  {
    id: 4908945670275,
    title: "Prostate 5LX - 60 ct.",
    vendor: "New Chapter",
    image: "//drhyman.com/cdn/shop/files/prostate_600x600.webp?v=1723924694",
    short_desc:
      "Holistic prostate support, supporting normal urine flow, with saw palmetto, selenium, rosemary, green tea and pumpkin seed oil providing powerful antioxidants to the whole body, but especially the prostate.",
    delivery_form: "Capsules",
    directions:
      "Two capsules daily with food or as recommended by a health-care practitioner.",
  },

  {
    id: 4908860178563,
    title: "DGL Plus",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_925f2c75-49c8-4d9a-9b6f-b02bf7157ef1_600x600.png?v=1705714375",
    short_desc:
      "A potent combination of licorice and other herbal extracts such as marshmallow root and slippery elm bark provide crucial support and soothing protection to the intestinal lining and GI tract. The body's natural immunity is supported by stimulating the quality and quantity of the stomach's protective mucous lining.",
    delivery_form: "Capsules",
    directions:
      "1 capsule daily, before a meal, or as directed by healthare professional.",
  },

  {
    id: 7708022243459,
    title: "Vitamin D3 + K2",
    vendor: "Seeking Health",
    image:
      "//drhyman.com/cdn/shop/files/VITA-DK-CAP_1_Front_600x600.webp?v=1723738445",
    short_desc:
      "Vitamin D3 + K2 by Seeking Health contains 125 mcg (5000 IU) of D3 (as cholecalciferol) and 100 mcg of K2 (as menaquinone-7) in an easy-to-swallow capsule.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule daily with food any time of day or as directed by your healthcare professional.",
  },

  {
    id: 4908915359875,
    title: "Pro-Flora Women's Probiotic",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/srsrabserrbei3hjb4us_600x600.webp?v=1705617886",
    short_desc:
      "A combination of Lactobacillus reuteri, RC-14 and Lactobacillus rhamnosus, GR-1 to promote vaginal colonization.*",
    delivery_form: "Tablets",
    directions:
      "Take 1 capsule once or twice daily or as recommended by a healthcare professional. May be taken with or without food.",
  },

  {
    id: 4908855165059,
    title: "ALAmax CR",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011530_alamax-cr-60-tablets_600x600.png?v=1742235503",
    short_desc:
      "ALAmax™CR is a whole-body, multifunctional antioxidant that helps to maintain healthy, well-functioning cells. ALAmax CR is designed to neutralize free radicals. ALAmax CR has the ability to destroy free radicals in both the water-based and lipid-based portion of cells, making it the ideal whole-body antioxidant. In addition, ALAmax CR helps the body synthesize glutathione, the body's own master detoxifier. ALAmax CR also “recharges” other important antioxidants, such as vitamins C and E, and CoQ10, giving them the ability to continue fighting free radicals for extended periods of time. In addition, biotin supports the function of alpha-lipoic acid in regulating glucose metabolism.*",
    delivery_form: "Tablets",
    directions:
      "Take one tablet 30 minutes before breakfast and one tablet 30 minutes before dinner, or as directed by your healthcare professional.",
  },

  {
    id: 4908978667651,
    title: "NeuroMag",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/NeuroMag_600x600.png?v=1709783798",
    short_desc:
      "NeuroMag™ is superior to other forms of magnesium at getting through the blood brain barrier because it is able to transport magnesium ions across lipid membranes, including those of brain cells.",
    delivery_form: "Capsules",
    directions:
      "Take 3 capsules per day or as directed by a healthcare professional.",
  },

  {
    id: 4908830195843,
    title: "L-Lysine",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_29ef0b2f-d8ad-4e3f-82c3-8b2b2c87b416_600x600.png?v=1705631347",
    short_desc:
      "An amino acid that helps maintain healthy arginine levels and immune function, provides nutritional support for the body's immune system. and is helpful in maintaining healthy gum and lip tissue.",
    delivery_form: "Capsules",
    directions:
      "1 capsule, 2 times daily, between meals, or as directed by a health professional .",
  },

  {
    id: 4908826853507,
    title: "Memory Pro",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_f57cd4d3-ada5-4e24-8c27-f7d1bae05445_600x600.png?v=1705868574",
    short_desc:
      "Broad-spectrum memory support formula with amino acids, herbal extracts, curcumin, resveratrol and lemon balm to support the brain, especially in elderly individuals; now with lutein/zeaxanthin and soy-free.Supports increased cognitive function, memory, vascular integrity, blood flow and healthy blood cell function in the brain, as well as protection from oxidative stress and relaxation.",
    delivery_form: "Capsules",
    directions:
      "3 capsules daily, with or between meals, or as directed by a health professional.",
  },

  {
    id: 4908894683267,
    title: "Vitamin A 10,000 IU's",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_9edf8ccf-1141-42df-88a1-8436978b961b_600x600.png?v=1706586227",
    short_desc:
      "Vitamin A is essential supports vision, cell growth, reproductive function, immunity, and healthy maintenance of skin and mucous membranes.",
    delivery_form: "Softgel Capsules",
    directions: "1 capsule, daily with a meal.",
  },

  {
    id: 4908772032643,
    title: "ArthroSoothe (DC)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/ArthroSoothe_Image_600x600.png?v=1709780412",
    short_desc:
      "This synergistic formula contains powerful joint support compounds including glucosamine sulfate, type II collagen, cetyl myristoleate (CMO), green-lipped mussel, MSM, hyaluronic acid, and niacinamide. Supportive nutrients were added including zinc, copper, manganese, and selenium, along with herbal extracts including boswellia, turmeric and resveratrol.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take four capsules daily, or as directed by your health care practitioner.",
  },

  {
    id: 5194321035395,
    title: "Total Gut Probiotic",
    vendor: "BIOHM",
    image: "//drhyman.com/cdn/shop/files/Image_12_600x600.png?v=1719538198",
    short_desc: "Probiotic. Relieves occasional gas and bloating.",
    delivery_form: "Capsules",
    directions: "Take 1 capsule per day.",
  },

  {
    id: 4908866306179,
    title: "L-Carnitine 340mg 60 ct. (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_3d7a44bd-4b06-4508-969b-3da5adf45a86_600x600.png?v=1705864558",
    short_desc:
      "L-Carnitine is an amino acid found in skeletal and heart muscles and helps with the conversion of fat to energy. Wonderful for cardiovascular support.",
    delivery_form: "Capsules",
    directions:
      "1 tablet three times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908772720771,
    title: "Immunitone Plus",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/ImmunitonePlus_600x600.png?v=1709780181",
    short_desc:
      "A powerful immune support containing herbs with antiviral and antibacterial properties, safe for high dosing for acute needs but suitable for long term use in chronic conditions. Potent standardized green tea, echinacea and goldenseal for the most active compounds.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take four capsules per day with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908975063171,
    title: "GABA with L-Theanine 1.7 oz.",
    vendor: "Quicksilver Scientific",
    image: "//drhyman.com/cdn/shop/files/GABABottle_600x600.png?v=1708310824",
    short_desc:
      "GABA (gamma-aminobutyric acid) is an amino acid produced in the human body that functions as the principle inhibitory neurotransmitter in the central nervous system.",
    delivery_form: "Liquid",
    directions:
      "Take 4 pumps whenever needed, especially before bed. Take 2 pumps at a time directly by mouth, hold 30 seconds and then swallow.",
  },

  {
    id: 4908773802115,
    title: "Complete Mineral Complex",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/CompleteMineralComplex_600x600.png?v=1709781533",
    short_desc:
      "This iron-free mineral formula contains the finest chelated minerals from Albion Advanced Nutrition for optimal absorption and utilization. Complete Mineral Complex is ideal as a daily supplement, or for use in mineral replenishment during other medical therapies that may deplete mineral status.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take three capsules daily with food or as directed by your health care practitioner.",
  },

  {
    id: 4908809781379,
    title: "L-Carnitine 340mg 120 ct. (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_e01211b5-9f25-4862-b87c-38c46956d244_600x600.png?v=1705864458",
    short_desc:
      "L-Carnitine is an amino acid found in skeletal and heart muscles and helps with the conversion of fat to energy. Wonderful for cardiovascular support.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions: "2 capsules, twice daily, with or between meals.",
  },

  {
    id: 4908883869827,
    title: "Athletic Nutrients (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/AthleticNutrients_600x600.png?v=1704337796",
    short_desc:
      "Designed to support physical training and performance. Hypo-allergenic, nutrient rich, highly bioavailable multi-vitamin, multi-mineral and trace element supplement. Superior mineral cofactors, activated vitamins, antioxidants and pH balanced creatine to target endurance, energy and lesson muscle fatigue.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, twice daily, with meals, or as directed by a health professional.",
  },

  {
    id: 4908870860931,
    title: "DGL (Chewable) Sugar-Free Rhizinate",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/lsgecmssizyrpnmvmhiy_600x600.webp?v=1705618107",
    short_desc:
      "Sugar-free chewable licorice tablet for quick relief of occasional stomach discomfort, in chewable form for saliva to enhance the effects and provide quick and soothing relief.",
    delivery_form: "Chewable Tablets",
    directions:
      "Chew 3 tablets after food in the morning. Chew 3 tablets after food in the evening, or as recommended by your healthcare professional",
  },

  {
    id: 4908934037635,
    title: "Oil of Oregano 60 ct.",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/OilofOregano60ct._600x600.png?v=1709781714",
    short_desc:
      "Oil of Oregano has powerful antioxidant and intestinal cleansing benefits. It also helps to maintain a healthy microbial balance.",
    delivery_form: "Softgel Capsules",
    directions:
      "1 softgel per day with meals, or as directed by your health care practitioner.",
  },

  {
    id: 4908935118979,
    title: "Cal/Mag Butyrate (RS)",
    vendor: "Body Bio",
    image: "//drhyman.com/cdn/shop/files/cal_600x600.png?v=1707446089",
    short_desc:
      "Short chain fatty acid, potent detoxifier of neurotoxins, cleans the bowels and lowers inflammation in the body, while encouraging formation of friendly bacteria in the gut for overall health, especially important when we take antibiotics that wipe out all bacteria.",
    delivery_form: "Capsules",
    directions:
      "1-2 capsules with food, unless otherwise suggested by your Healthcare Professional.",
  },

  {
    id: 4908899598467,
    title: "Myomin",
    vendor: "Chi-Health",
    image: "//drhyman.com/cdn/shop/files/Myomin_600x600.png?v=1706736571",
    short_desc:
      "Myomin is an herbal supplement demonstrated to reduce arornatase expression and estrogen levels as well as improve estrogen-dominant conditions like cysts, fibroids, and endometriosis. lt can be safely taken with HRT to minimize its associated risks.",
    delivery_form: "Capsules",
    directions:
      "2-3 capsules, 3 times a day after meals or as directed by your healthcare practitioner.",
  },

  {
    id: 5138262392963,
    title: "Liposomal Vitamin C",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/lpovtc_liposomal-vitamin-c_4oz_ipsos-badge_600x600.png?v=1741628611",
    short_desc:
      "Each 5 mL serving (approximately 1 teaspoon) of this Liposomal Vitamin C lemon flavored formula provides 1000 mg vitamin C, as sodium ascorbate. The 130 mg sodium per serving helps to further facilitate absorption of vitamin C.",
    delivery_form: "Liquid",
    directions:
      "As a dietary supplement, take 5 mL (approx. 1 teaspoon) and hold in mouth for 30 seconds before swallowing, or as directed by your health care practitioner.",
  },

  {
    id: 4908791201923,
    title: "Vasotensin",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/107123_600x600.jpg?v=1742568662",
    short_desc:
      "Vasotensin provides peptides from bonito fish to support health blood pressure levels already in the normal range.",
    delivery_form: "Tablets",
    directions:
      "Two tablets twice daily with meals or as directed by your healthcare practitioner.",
  },

  {
    id: 6719292276867,
    title: "Homocysteine Supreme 120 ct",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/homo_600x600.png?v=1709862129",
    short_desc:
      "A powerful amino acid that naturally occurs in the body, needed for detoxification, joint and cartilage repair and brain health. This product helps keep levels at a safe level so toxic accumulation doesn't occur and helps support with diabetes, artery issues, hypertension, erectile dysfunction, Alzheimer's, MS, type 2 diabetes, and renal failure.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules per day with meals or as directed byyour health-care practitioner.",
  },

  {
    id: 4908794970243,
    title: "Black Cohosh Plus",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/eyJwYXRoIjoibWV0YWdlbmljc1wvZmlsZVwvYlFtTlVMeUx0b2Jqc0JxWUJlTnkucG5nIn0_metagenics_z0oZBdMksfQ3HwmSxHNiw1rbdVBz6xrQX1ya2dudqyE_600x600.png?v=1742499091",
    short_desc:
      "Black Cohosh with lemon balm and motherwort help ease tension and support relaxation, specifically during menopause. May help with hot flashes and night sweats, short menstrual cycles, occasional irritability, mild mood swings and sleep disturbances.  60 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "One tablet twice daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908932628611,
    title: "PolyResveratrol-SR",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/sb300-front_600x600.png?v=1709782679",
    short_desc:
      "Resveratrol to support blood vessel health, longevity, inflammation, liver function and overall detox, as well as healthy cell growth for overall wellness and vitality. Anti-aging, cardiovascular supportive, with synergestic plant extracts to help metabolize and utilize this nutrient in the body.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules one to two times daily or as recommended by a health-care practitioner",
  },

  {
    id: 4908990627971,
    title: "NeuroMood Pure Pack (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_eec3e6e2-de91-49e2-a1a2-4951cc586c45_600x600.png?v=1705970598",
    short_desc:
      "NeuroMood Pure Pack is designed to help support healthy neurotransmitter function as well as positive mood and emotional wellness. NeuroMood Pure Pack also helps to maintain proper immune function and promotes overall relaxation.",
    delivery_form: null,
    directions:
      "As a dietary supplement, take 1 packet daily (5 capsules), with a meal.",
  },

  {
    id: 4908940099715,
    title: "Zinc Liquid 15 mg. (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_d6834b75-9abb-4acf-9c87-eef19b5695b3_600x600.png?v=1706586070",
    short_desc:
      "Convenient liquid form of zinc for healthy immune function, prostate, normal fetal and reproductive development, collagen and healthy tissue formation, digestive and metabolic function and the storage and utilization of carbohydrates.",
    delivery_form: "Liquid",
    directions: "4ml (0.14 fl oz) 4 ful droppers",
  },

  {
    id: 4909015171203,
    title: "GI-Resolve",
    vendor: "Biotics",
    image:
      "//drhyman.com/cdn/shop/files/6417-web-NewLabel_0_900x_88150f28-3f05-4ea8-a4da-5bbd052348f6_600x600.webp?v=1717002144",
    short_desc:
      "GI-Resolve, a clean and great-tasting powder, contains ingredients carefully sourced for premium quality, including L-Glutamine, Zinc Carnosine, N-Acetyl Glucosamine, MSM, Aloe vera Leaf, Okra and DGL",
    delivery_form: "Powder",
    directions:
      "Two (2) teaspoons each day as a dietary supplement or as otherwise directed by a healthcare professional.",
  },

  {
    id: 8066635235459,
    title: "MT. Capra Grass-Fed Goat Milk Protein Powder",
    vendor: "MT. Capra",
    image: "//drhyman.com/cdn/shop/files/cwp_600x600.png?v=1709607716",
    short_desc:
      "The cleanest protein on the planet! Mt. Capra's CLEAN grass-fed, goat milk protein encompasses everything that a clean food should be; no sweeteners, no flavors, no gums, no stevia, no hormones, no GMO's, no chemicals…you get the idea. For ingredients and nutritional data, please view the alternate product images.",
    delivery_form: "Powder",
    directions: "",
  },

  {
    id: 4909002195075,
    title: "Mitochondrial NRG",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/MitochondrialNRG_600x600.png?v=1709782611",
    short_desc:
      "Mitochondrial NRG™ was designed to support the function of the mitochondria, “the powerhouse of the cell.”",
    delivery_form: "Capsules",
    directions:
      "Take 4 capsules per day with meals or as directed by your health-care practitioner. (Divided dosing recommended.)",
  },

  {
    id: 4908841533571,
    title: "Zyflamend Whole Body (RS)",
    vendor: "New Chapter",
    image:
      "//drhyman.com/cdn/shop/products/zyflammend_600x600.png?v=1618245982",
    short_desc:
      "Helps to balance and increase the body's natural healthy inflammation process to benefit the whole body, including joints, heart, lungs, immune system, breasts, prostate and skin. Whole food antioxidant blend (non-isolated form) including ginger, turmeric, green tea and rosemary fight oxidative stress and support healthy aging.",
    delivery_form: "Softgel Capsules",
    directions:
      "One softgel two times daily with meals, or as directed by your health care provider. Taking with a meal and a full glass of water may reduce stomach upset.",
  },

  {
    id: 4908984270979,
    title: "Metabolic Synergy 360ct",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/MetabolicSynergy360_600x600.png?v=1742311204",
    short_desc:
      "This highly potent multivitamin and mineral formula was designed by a doctor specializing in blood sugar and endocrine health, for superior magnesium, chromium, zinc, manganese and vanadium chelates and their absorption into the body. 360 ct. capsules",
    delivery_form: "Capsules",
    directions:
      "Three soft gels daily, with food, or as directed by your health care professional or pharmacist.",
  },

  {
    id: 4908854968451,
    title: "G.I. Benefits",
    vendor: "DaVinci Labs",
    image: "//drhyman.com/cdn/shop/files/davinci_1_600x600.png?v=1705616692",
    short_desc:
      "Great-tasting drink mix supplement blends amino acids, herbal extracts and a proprietary form of zinc to support digestive and immune health, GI comfort and regularity.*",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, mix one scoop with cold water or juice once or twice daily, or as directed by your health care practitioner.",
  },

  {
    id: 4908934889603,
    title: "GI Detox+ - Zeolite (G-PUR), Charcoal \u0026 Herbal Formula",
    vendor: "Bio-Botanical Research",
    image:
      "//drhyman.com/cdn/shop/files/GI-Detox-Plus_1400x_df23611d-0f33-4595-9a3a-e1e35b3652a0_600x600.webp?v=1715979762",
    short_desc:
      "Helps Remove Debris, and Mops Up Toxins and Supports Microbial Balance",
    delivery_form: "Powder",
    directions:
      "1 capsule on an empty stomach with a full glass of water or as directed by a healthcare professional. Take 1 hour apart from other medications and supplements.",
  },

  {
    id: 4908858441859,
    title: "Muscle Cramp-Tension Formula (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_41c53f22-ab46-4421-a0dc-850fb52e4a67_600x600.png?v=1705968594",
    short_desc:
      "Magnesium, calcium and potassium plus electrolytes and soothing herbs help relax muscles, lessen nighttime leg cramps and promote overall relaxation and restful sleep.",
    delivery_form: "Capsules",
    directions: "2 capsules 1-2 times daily, with or between meals.",
  },

  {
    id: 4908883017859,
    title: "Athletic Pure Packs",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/athlete_600x600.png?v=1723924677",
    short_desc:
      "Supports energy, muscle recovery and immune function for healthy athletic activity.Helps to support health of connective tissues and muscles.",
    delivery_form: "Packet",
    directions: "Take 1 packet daily (9 capsules), with a meal.",
  },

  {
    id: 4908819054723,
    title: "Olivirex",
    vendor: "Bio-Botanical Research",
    image: "//drhyman.com/cdn/shop/files/Olivirex_600x600.png?v=1705081429",
    short_desc:
      "Highest Potency Olive Leaf Extract Synergistic Blend of Additional Botanicals Assist Detoxification",
    delivery_form: "Capsules",
    directions: "",
  },

  {
    id: 4908836290691,
    title: "BiotaGen Powder (RS)",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-BTG.8oz_hires_web_600x600.png?v=1709781832",
    short_desc:
      "Versatile prebiotic formula to optimize gut microflora, improve bowel function and support the immune system with chicory inulin and oligofructose, larch and purified yeast beta-glucan.",
    delivery_form: "Powder",
    directions:
      "1 to 2 scoops daily with food or as directed by your health care practitioner.",
  },

  {
    id: 4908795723907,
    title: "Testralin",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/106860_600x600.jpg?v=1742568443",
    short_desc:
      "Designed for men 40 and over to support healthy hormone balance to maintain male reproductive health. Includes green tea, flax, plant sterols and antioxidants.  60 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "Take two tablets daily with a meal or as directed by your healthcare practitioner.",
  },

  {
    id: 4908892291203,
    title: "PerioBiotic Silver Toothpaste",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/PBSSPM_periobiotic-silver-toothpaste_spearmint_watermark_product-image_600x600.jpg?v=1709782424",
    short_desc:
      "Flouride-free, great tasting toothpaste with probiotics for optimal oral health, starting with teeth and gums.",
    delivery_form: "Paste",
    directions:
      "Brush thoroughly after meals for at least 1 minute. Brush 2 to 3 times per day or as directed by your health care professional.",
  },

  {
    id: 4908941410435,
    title: "Quercetin-Ascorbate (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/Quercetin-Ascorbate_600x600.png?v=1709781450",
    short_desc:
      "Quercetin Ascorbate powder is a powerful flavonoid and antioxidant blend. Quercetin is one of several flavonoids that have effects on mast cells and basophils. Vitamin C helps regulate histamine levels and helps control inflammatory responses.",
    delivery_form: "Powder",
    directions:
      "Take 1 gram (approx. one quarter teaspoon) per day with a meal, or as directed by your health care practitioner.",
  },

  {
    id: 4908983222403,
    title: "ProButyrate",
    vendor: "Tesseract",
    image:
      "//drhyman.com/cdn/shop/products/tmr-probutyratelbl_3d-600w_600x600.png?v=1709782855",
    short_desc:
      "Prior to ProButyrate™, the accepted method of increasing short chain fatty acids such as butyrate was sodium butyrate enema or oral supplementation by butyrate mineral salts, which for most patients are intolerable in taste and smell.",
    delivery_form: "Capsules",
    directions:
      "Take 1-3 capsules, two times daily or as recommended by your health-care practitioner.",
  },

  {
    id: 4908865716355,
    title: "Cardiogenics Intensive Care",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/CardiogenicsIntensiveCare_90T_LCA072V4_200cc_600x600.png?v=1706108903",
    short_desc:
      "A well rounded formula to help heart muscle health and function, with extracts of hawthorn and arjuna (traditional for heart support), amino acids, phytonutrients, antioxidants, and minerals including magnesium, potassium, selenium and calcium. Helps support cardiac relaxation and nerve function, promotes arterial blood flow, and healthy blood pressure.",
    delivery_form: "Tablets",
    directions:
      "Take three tablets once daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908859490435,
    title: "GastroMend-HP",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/output.GastroMend-HPauto_600x600.png?v=1709782180",
    short_desc:
      "GastroMend-HP is a blend of botanical extracts and nutrient complexes with specific antimicrobial and mucosal healing properties.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, twice daily, on an empty stomach or as directed by a health care practitioner.",
  },

  {
    id: 7722611933315,
    title: "AlgaeCal Plus",
    vendor: "AlgaeCal",
    image: "//drhyman.com/cdn/shop/products/algacell_600x600.webp?v=1657733246",
    short_desc:
      "Rock-based calcium can only slow bone loss. But AlgaeCal's plant-based calcium does what others can't — actually stops bone loss. And builds new bone!",
    delivery_form: "Capsules",
    directions:
      "For those seeking to increase bone density, 2 capsules with breakfast and dinner (4 capsules daily) To maintain current healthy bone density, take three capsules per day (1 capsule/meal).",
  },

  {
    id: 4908823019651,
    title: "Amino Acid Synergy",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/AAS120_600x600.png?v=1709782253",
    short_desc:
      "Provides easy to absorb and metabolize, high quality protein for athletes to achieve and maintain greater lean body mass, for people who suffer from chronic illness, or those recovering from surgery and tissue trauma, healthier hair and nails or those with amino acid deficiencies.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take four capsules daily, between meals, or as directed by your health care practitioner.",
  },

  {
    id: 4908974243971,
    title: "Magnesium Glycinate Liquid",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_6060662d-7571-489f-896d-aeb720f5bb54_600x600.png?v=1705867129",
    short_desc:
      "Magnesium Glycinate liquid supports musculoskeletal, cardiometabolic and emotional health in a highly bioavailable form that is less likely to cause loose stools than other forms of magnesium.",
    delivery_form: "Liquid",
    directions:
      "2 teaspoons daily, with a meal, or as directed by your health professional.",
  },

  {
    id: 4908783927427,
    title: "Ceralin Forte (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/CeralinForte_90C_LCE011Q4_200cc_600x600.png?v=1706109034",
    short_desc:
      "Well-rounded brain, nerve and circulatory support, for healthy cognitive function, enhanced cellular energy, antioxidant protection for the nervous system and helps protect cells from oxidative stress.",
    delivery_form: "Capsules",
    directions:
      "Three capsules daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908895862915,
    title: "Similase GFCF",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/ev6rlhpjubcolmriwolq_600x600.webp?v=1705618212",
    short_desc:
      "Formulated to defend against hidden gluten with a specific enzyme as part of a complete range to help digest carbs, fats, and proteins. Note: Celiac patients should still refrain from gluten overall.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules with each meal or as recommended by your healthcare professional.",
  },

  {
    id: 4908922110083,
    title: "Amino Complex powder berry",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/sp641-front_600x600.png?v=1705979424",
    short_desc:
      "Essential amino acid supplement to help support lean muscle mass and muscle strength development, and support the musculoskeletal system. A delicious stevia sweetened berry flavor powder to mix easily into warm or cold liquids.",
    delivery_form: "Powder",
    directions:
      "Mix 1 scoop with 6 oz of water one to two times daily or as recommended by your health-care practitioner.",
  },

  {
    id: 4908922404995,
    title: "MagneGel - Transdermal Magnesium (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/MagneGel-TransdermalMagnesium_600x600.png?v=1709782330",
    short_desc:
      "Uniquely pure and potent topical magnesium gel which is assimilated faster, helps decrease aches, pains and spasms, elevates mood and decreases stress, promotes healthy skin tissue, muscle function, immunity and increased energy levels.",
    delivery_form: "Gel",
    directions:
      "Massage into the arms and/or legs as needed to provide a large area for absorption. 1 tsp will provide approximately 354 mg of elemental magnesium.",
  },

  {
    id: 4908834422915,
    title: "Cenitol (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/Cenitol_1530300N1_16oz_600x600.png?v=1706109000",
    short_desc:
      "Cenitol supports a healthy mood and overall nervous system function by featuring inositol—an important, naturally occurring component of cell membranes. Cenitol also supplies magnesium in the form of a fully reacted amino acid chelate designed for enhanced nervous system support.",
    delivery_form: "Powder",
    directions:
      "Mix one scoop in water or juice one to three times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908909297795,
    title: "BCAA capsules 250 ct. (RS)",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/BCAACapsules_600x600.png?v=1705366795",
    short_desc:
      "BCAA promotes healthy muscle mass by boosting energy metabolism in working muscle and by inhibiting protein breakdown during exercise. Safe nutritional support for athletes and those seeking lean muscle mass.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, 1-2 times daily, between meals.",
  },

  {
    id: 4908965789827,
    title: "CollaGelatin 16 Oz.",
    vendor: "Bulletproof Digital",
    image: "//drhyman.com/cdn/shop/files/front_600x600.png?v=1707420867",
    short_desc:
      "CollaGelatin is on being repackaged. Grass-fed CollaGelatin™ provides twice as much collagen protein as plain gelatin, Adding collagen and gelatin to meals adds necessary amino acids often missing in the Western diet, which are essential to supporting the body's ability to repair and maintain healthy skin, joints and bones.",
    delivery_form: "Powder",
    directions:
      "Mix 1 tablespoon (or more, as desired) into your favorite hot liquid or foods.",
  },

  {
    id: 4908816302211,
    title: "Polyphenol Nutrients 360ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_c3845989-2a72-4d8d-bcb8-d084a61d552e_600x600.png?v=1706583986",
    short_desc:
      "A unique and powerful polyphenol rich multivitamin/mineral formula packed with flavonoids for potent cellular protection. Supports neural, cognitive, cardiovascular, liver and skin health.360 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "4–6 capsules per day, in divided doses, with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908977193091,
    title: "Argentyn 23 Bio-Active Silver Nasal Spray/Sinus Relief 2 oz.",
    vendor: "Natural Immunogenics",
    image: "//drhyman.com/cdn/shop/products/argen23_600x600.png?v=1666037689",
    short_desc:
      "Argentyn 23 in the 2 oz. Vertical (nasal) spray form is a professional grade of silver hydrosol which represents the ultimate refinement and most significant breakthrough in colloidal technology, having consistently produced the smallest particles ever seen in colloidal silver products, with the most unique charge attributes (98% positively charged).",
    delivery_form: "Spray",
    directions: "Adults: 5 sprays in each nostril up to 7 times a day.",
  },

  {
    id: 4908940689539,
    title: "OmegAvail TG1000",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/OV1000_omegavail-tg1000_250cc_watermark_product-image_822cce64-fb8b-42fe-9eb1-25fa1b90ccd3_600x600.jpg?v=1709782529",
    short_desc:
      "OmegAvail™ TG1000 is a highly potent, non-GMO fish oil, containing an impressive 1,000 mg omega-3 oils per softgel, making it an ideal choice for therapeutic dosing.",
    delivery_form: "Softgel Capsules",
    directions:
      "Take one softgel per day, or as directed by your health care practitioner",
  },

  {
    id: 4908766363779,
    title: "Culturelle with Lactobacillus GG (RS)",
    vendor: "Amerifit Nutrition",
    image:
      "//drhyman.com/cdn/shop/products/culturelle_600x600.png?v=1587239278",
    short_desc:
      "The only probiotic that contains exclusively Lactobascillus GG, cultured on milk proteins and then washed and freeze-dried to be free of lactose. (Serious allergies may still need to checked with your doctor) A high dose in extra stable packaging.",
    delivery_form: "Capsules",
    directions:
      "For daily use, take one (1) capsule per day. For optimal results, daily use is suggested.",
  },

  {
    id: 4908944588931,
    title: "Adenosyl-Hydroxy B12",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/Adenosyl_HydroxyB1290_s_600x600.png?v=1704337318",
    short_desc:
      "Vitamin B12 for nerve and mitochondrial support, energy production and overall wellness. Many vegetarians can be deficient in this key nutrient so supplementation is often needed.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-3 times daily, with meals.",
  },

  {
    id: 4908821872771,
    title: "DIMPRO 100",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_2f320b64-e00f-4721-8e78-5c2ab29007f3_600x600.png?v=1705631572",
    short_desc:
      "Found naturally in cruciferous vegetables, this blend helps support healthy cell function, especially for breast, cervical and prostate cells. Specifically targets enhanced absorption, especially in cases of low gastric function and acidity.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "1–3 capsules per day, in divided doses, with or between mealsor as directed by your health care practitioner.",
  },

  {
    id: 4908867092611,
    title: "L-Arginine 700mg. 90 ct. (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_ea51a87c-ddb1-4a98-94b5-84d627b59a8c_600x600.png?v=1705864124",
    short_desc:
      "A safe and versatile amino acid that helps promote cardiovascular, immune and sexual health, along with cognitive function and memory. May increase sperm motility, insulin and hormone metabolism and healthy circulation. Note: should be avoided by those with migraines, depression, autoimmune diseases, kidney and liver disease.",
    delivery_form: "Capsules",
    directions: "2 capsules 1-3 times daily, between meals.",
  },

  {
    id: 4908802605187,
    title: "Chromium Picolinate",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/ChromiumPicolinate_60T_LCH009V2_60cc_600x600.png?v=1706109121",
    short_desc:
      "Chromium Picolinate is an easily absorbable form of chromium for those needing extra of this important mineral in their diet to help assist in the regulation of fat, carbohydrate and protein metabolism and support healthy insulin levels and cell/tissue membrane fluidity.60 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "One to three tablets two times daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908792676483,
    title: "SuperGarlic 6000",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/SuperGarlic6000_90T_LSU018N2_200cc_600x600.png?v=1706201717",
    short_desc: "Super Concentrated 6000 mcg Allicin Per Tablet",
    delivery_form: "Tablets",
    directions:
      "One tablet daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908810207363,
    title: "R-Lipoic acid 100 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_d1467e77-878d-41c5-adcf-443aa1053c8d_600x600.png?v=1705631467",
    short_desc:
      "Highly stable form of Potassium-R-lipoate, effective against oxidative stress damage in the liver and enhances antioxidant activity, energy production and general metabolic function for overall health, glucose metabolism and musculosketal support.  120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions: "1 capsule, 1-2 times daly, with meals.",
  },

  {
    id: 6720041615491,
    title: "Nanoemulsified D3/K2",
    vendor: "Quicksilver Scientific",
    image: "//drhyman.com/cdn/shop/files/D3k2Bottle_600x600.png?v=1708310686",
    short_desc:
      "The Quicksilver Delivery Systems signature trademark sets our liposomal products apart from other companies and ensures an unsurpassed experience. By virtue of our smaller, stable, single-layer spheres, made from the highest quality ingredients available, our liposomal delivery systems improve upon basic liposomal technology. The difference is literally clear; our liposomal products have a clarity that only can be achieved with liposomes that are small enough to pass between cells and enter the bloodstream after ingestion, allowing for optimal bioavailability.",
    delivery_form: "Liquid",
    directions:
      "Take 1 pump by mouth 1-2 times daily. Hold in mouth 30 seconds before swallowing. Repeat to desired dosage or as directed by a healthcare professional. Take on an empty stomach, at least 10 minutes before meals",
  },

  {
    id: 4909008420995,
    title: "BCAAs",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/BCAAs_OrangeMango_1530260F1_16oz_600x600.png?v=1706039786",
    short_desc:
      "Muscle Up! Complement your workout lineup with Metagenics BCAAs, featuring clean, high quality branched-chain amino acids.",
    delivery_form: "Powder",
    directions:
      "Blend, shake, or briskly stir 1 scoop (7.3 g) into 8 oz of chilled water before and after exercise or with a meal as directed by your healthcare practitioner.",
  },

  {
    id: 4908933087363,
    title: "OsteoVantiv (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/OsteoVantiv_60T_LST048L3_150cc_600x600.png?v=1706130258",
    short_desc:
      "OsteoVantiv is designed to comfort sore joints and promote joint flexibility in healthy people. It features a clinically effective dose of UC-II, which has been shown in research to support healthy joint function.",
    delivery_form: "Tablets",
    directions:
      "Take 1 tablet two times daily or as recommended by your health-care practitioner.",
  },

  {
    id: 5072775217283,
    title: "SPM Supreme",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/spm_600x600.png?v=1709784167",
    short_desc:
      "SPMs work to facilitate the body's natural resolutionresponse to challenges presented in the inflammatorypathway. These challenges can be caused by aging,physical stressors, injury, infection, and nutrient-poor diets.",
    delivery_form: "Softgel Capsules",
    directions:
      "Take one softgels once daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908936888451,
    title: "Lion's Mane 60 ct.",
    vendor: "Host Defense",
    image: "//drhyman.com/cdn/shop/files/Untitled-23_600x600.png?v=1709663624",
    short_desc:
      "60 countHost Defense Lion's Mane uses activated, freeze-dried, Certified Organic mycelium, with a full spectrum of constituents: polysaccharides (beta glucans, arabinoxylane, glucose, xylose, galactose and mannose), glycoproteins, ergosterols, triterpenoids and other myco-nutrients,which are essential for Supporting Natural Immunity. Lion's Mane is renowned for providing support to the brain and nervous system.",
    delivery_form: "Capsules",
    directions:
      "2 capsules daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 7821026164867,
    title: "Active B-Complex",
    vendor: "Integrative Therapeutics",
    image: "//drhyman.com/cdn/shop/products/B-12_600x600.png?v=1673647270",
    short_desc:
      "B-Vitamins play essential roles in many functions of the body.",
    delivery_form: "Capsules",
    directions:
      "Adults take 1 or 2 capsules daily, or as recommended by a healthcare professional.",
  },

  {
    id: 4908924338307,
    title: "SeroSyn 90 ct. (RS)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/107099_600x600.jpg?v=1742568427",
    short_desc:
      "SeroSyn™ is designed to support a positive mood and a restful, relaxed state through beneficially modulating the metabolism of serotonin.",
    delivery_form: "Capsules",
    directions:
      "Take one capsule three times daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 4908853592195,
    title: "CoQ10 (Vitaline) 100mg,Tropical Fruit",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/kaiqhcvsiatgx0ov9djk_600x600.webp?v=1705618345",
    short_desc:
      "CoQ10 in it's pure and natural form, essential for cellular energy production and for supporting heart health, since natural levels decline with age.",
    delivery_form: "Chewable Tablets",
    directions:
      "Adults chew 1 tablet once or twice daily, or as recommended by a healthcare professional.",
  },

  {
    id: 4908901138563,
    title: "Saw Palmetto 320 (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_4c5dd495-a15f-4756-ab8b-b07d5a0d26a8_600x600.png?v=1706585633",
    short_desc:
      "Saw Palmetto has been used for decades to support healthy prostate and urinary function in men.",
    delivery_form: "Softgel Capsules",
    directions: "1 capsule, 1-2 times daily, between meals.",
  },

  {
    id: 7707588657283,
    title: "Magnesium Glycinate",
    vendor: "Douglas Labs",
    image:
      "//drhyman.com/cdn/shop/files/Douglas_Laboratories_Magnesium_Glycinate_600x600.webp?v=1709579868",
    short_desc: "Magnesium from Magnesium Glycinate Amino acid chelate.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, adults take 1 capsule, 1-4 times daily or as directed by your health professional.",
  },

  {
    id: 4908915949699,
    title: "5-MTHF 5mg",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/b132-front_600x600.png?v=1709783997",
    short_desc:
      "The most biologically active form of folate.5-MTHF is an essential cofactor in the metabolism of the amino acid metabolite homocysteine. 5-MTHF also must be present in sufficient quantity for normal production of the neurotransmitters serotonin, melatonin, dopamine, epinephrine, and norepinephrine. These functions make 5-MTHF critical for both cardiovascular function and mood support.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule one to two times daily or as recommended by your health professional.",
  },

  {
    id: 7995139981443,
    title: "Microbiome Rejuvenate",
    vendor: "Big Bold Health",
    image:
      "//drhyman.com/cdn/shop/files/MicrobiomeRejuvenate_600x600.png?v=1704424012",
    short_desc:
      "Himalayan Tartary Buckwheat -Nuture the vital connections between your gut, your immune system and the natural world.If replacing the traditional GUT FOOD we recommend the SEED probiotic in combination.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules every day, with or without food. One bottle contains 120 capsules for 60 servings or a 2 month supply. We recommend daily usage on an ongoing basis to support gut and immune function and promote rejuvenation of your immune response.*",
  },

  {
    id: 4908884492419,
    title: "VitaSpectrum (Berry)",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-VTS-BP_hires_web_600x600.png?v=1706735923",
    short_desc:
      "Great tasting berry flavored multivitamin/mineral powder for children with Autism Spectrum Disorders. Packed with highly bioavailable nutrients designed to help malabsorption, chronic diarrhea and other gut issues associated with deficiencies from poor nutrition or elimination diets often linked to autism treatments and symptoms.",
    delivery_form: "Powder",
    directions:
      "1 scoop daily with food or as directed by your health care practitioner.",
  },

  {
    id: 4909011075203,
    title: "BDNF Essentials",
    vendor: "Researched Nutritionals",
    image:
      "//drhyman.com/cdn/shop/files/BDNFEssentials_600x600.png?v=1709784077",
    short_desc:
      "BDNF Essentials is a clinically researched, comprehensive formula designed to support neurological health and cognitive function. This unique formula leverages ingredients that have been shown to aid in the formation of nerve growth factors, such as brain-derived neurotrophic factor (BDNF). BDNF is essential in supporting neuron health, neuroplasticity (the ability of the brain to rewire and create new connections), and neurogenesis (the growth of new neurons).",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules twice daily with or without meals, or as directed by your health care professional.",
  },

  {
    id: 7828092027011,
    title: "Renual",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_e09fd46c-65f3-4eed-84e9-5c5df617aa96_600x600.png?v=1706585081",
    short_desc:
      "Mitochondrial renewal featuring Mitopure™ Urolithin A to power muscle function, increase cellular energy and promote healthy aging‡",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, 1-2 times daily, with or between meals.",
  },

  {
    id: 4908826001539,
    title: "Nutrient 950 with NAC",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_303d552c-7cc1-429c-9657-7960ee83d6f8_600x600.png?v=1705972084",
    short_desc:
      "Nutrient 950 is a complete hypo-allergenic, high-nutrient, bioavailable multivitamin, multimineral and trace element supplement. It offers an advanced mineral delivery system, and the highly desirable coenzyme forms of B vitamins to promote optimal absorption of the nutrients.",
    delivery_form: "Capsules",
    directions:
      "4–8 capsules per day, in divided doses, with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908798705795,
    title: "Perimine",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/107120_600x600.jpg?v=1742568325",
    short_desc:
      "Perimine is a patented extract of perilla seed (Perilla frutescens), an herb that supports a healthy respiratory and immune response.",
    delivery_form: "Tablets",
    directions:
      "One tablet twice daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 8049727701123,
    title: "Turiva",
    vendor: "Ortho Molecular",
    image: "//drhyman.com/cdn/shop/files/172-Turiva_600x600.png?v=1707941201",
    short_desc: "Unlock the Benefitsof the Whole Turmeric Root.",
    delivery_form: null,
    directions:
      "1 capsule per day or as recommended by your health practitioner.",
  },

  {
    id: 4908885966979,
    title: "CraveArrest 120 ct. (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/CraveArrest120ct._600x600.png?v=1709783630",
    short_desc:
      "Designed to balance the production of the major neurotransmitters, serotonin and dopamine, that affect cravings of all kinds. The Tyrosine and 5HTP found in CraveArrest are in an ideal 10:1 ratio for superior results. The adaptogenic herb Rhodiola Rosea and Taurine are added to support and balance the stress response.",
    delivery_form: null,
    directions:
      "Take 2 or more capsules per day on an empty stomach or as directed by your health care practitioner.",
  },

  {
    id: 4908985745539,
    title: "ActivNutrients Chewable",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011512_activnutrients-chewable-mixed-berry-120-tablets_600x600.png?v=1742235371",
    short_desc:
      "ActivNutrients Chewable is formulated to address children's unique nutritional needs for growth, development, and vitality.",
    delivery_form: "Chewable Tablets",
    directions:
      "Children 1-3 years: one to two tablets twice daily; children 4 years or more: two to four tablets twice daily, or take as directed by your healthcare practitioner.",
  },

  {
    id: 4908819873923,
    title: "Macular Support Formula",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_093eb5fa-af9e-49b4-a4b0-76b822f13093_600x600.png?v=1705866294",
    short_desc:
      "Helps protect and promote eye health* May protect eyes from free radicals* Made with hypoallergenic ingredients Macular Support Formula is a blend of powerful antioxidants and botanicals formulated to protect and support the retina. 120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "2–4 capsules per day, in divided doses, with meals or as directed by your health care practitioner.",
  },

  {
    id: 7774465818755,
    title: "AnxiaEase",
    vendor: "Researched Nutritionals",
    image: "//drhyman.com/cdn/shop/files/AnxiaEase_600x600.png?v=1709866964",
    short_desc:
      "Researched Nutritionals aims to improve your stress and anxiety response with AnxiaEase. This product blends various adaptogenic herbs, calming herbs and psychobiotics (probiotics) to support a healthy emotional and physical response to stress and anxiety.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules twice daily, with food, or as directed by your healthcare professional.",
  },

  {
    id: 7731551207555,
    title: "Senolytic Synergy",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/SenolyticSynergy_600x600.png?v=1709866603",
    short_desc:
      "Senolytic Synergy is uniquely formulated to enhance overall cellular health and support healthy aging.",
    delivery_form: "Capsules",
    directions: "Take 2 capsules daily",
  },

  {
    id: 4909021134979,
    title: "UltraVir-X (RS)",
    vendor: "Biotics",
    image:
      "//drhyman.com/cdn/shop/products/ultra_vir-x_6360-web-newlabel_600x600.png?v=1587241678",
    short_desc:
      "UltraVir-X provides key vitamins and specific minerals, combined with a proprietary complement of botanical compounds possessing immuno-modulating properties. It offers unique supplemental support for normal, healthy immune function.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule 3 times each day as a dietary supplement or as otherwisedirected by a healthcare professional.",
  },

  {
    id: 4908964544643,
    title: "Melatonin .5 Mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_7e1f0bef-a2d0-4364-b3e9-85900c59e5b6_600x600.png?v=1705868111",
    short_desc:
      "Promotes Natural Sleep Cycles: Melatonin nutritionally augments the functioning of the pineal gland, supporting the body's natural sleep cycle. In one study, melatonin supported sleep onset when taken in the evening and did not cause morning drowsiness.",
    delivery_form: "Capsules",
    directions:
      "1 capsule 1/2 to 1 hour before bedtime, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908996788355,
    title: "Target GB-X",
    vendor: "SFI Klaire/Prothera",
    image: "//drhyman.com/cdn/shop/products/gbx_600x600.png?v=1587241442",
    short_desc:
      "Target gb-X is a probiotic supplement specifically designed to support positive mood by influencing the gut-brain axis through the microbiome. It is powered by Ecologic BARRIER, a 5B CFU blend of 9 probiotic strains, that has been clinically shown to decrease overall cognitive reactivity to sad mood, rumination, negative thoughts, and aggressive thoughts.Heightened cognitive reactivity to sad mood is an established risk factor for more serious mood alterations in otherwise healthy individuals, and is therefore considered an important target for interventions.",
    delivery_form: "Packet",
    directions:
      "Dissolve the content of 1 sachet daily in water (3-4 oz.), preferably lukewarm, and stir before consumption. Take on an empty stomach in the morning, before bed, or as directed by a healthcare professional. Suitable for children from the age of 1 year.",
  },

  {
    id: 4909017825411,
    title: "PaleoFiber",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/PaleoFiberRS_600x600.png?v=1709865871",
    short_desc:
      "PaleoFiber RS benefi ts GI health through its ability to support microbial balance and proper intestinal permeability and integrity. Additionally, this formula may help support optimal blood sugar and insulin levels, appetite control, and cardiovascular health.*",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, take 10 grams (approx. one scoop) per day, or as directed by your health care practitioner.",
  },

  {
    id: 4908884230275,
    title: "Electrolyte-Energy Formula (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_4fc9f68a-8530-4060-87d8-2e239a842adb_600x600.png?v=1705717837",
    short_desc:
      "A balanced mix of electrolytes and carbohydrates for optimal physical and mental stamina.Delays fatigue and replenishes glycogen post exercise, and may also promote mental focus under stressful conditions. Easy to use lemon-lime powder.",
    delivery_form: "Powder",
    directions:
      "1 scoop mixed in 8-10 oz water, 20 minutes before exercise, or as directed by a health professional.",
  },

  {
    id: 4908995969155,
    title: "Activated Charcoal",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/shebsyxrm2qs8pyeyygt_600x600.webp?v=1705618553",
    short_desc:
      "Activated Charcoal is highly porous and can adsorb unwanted substances, carrying them out of the digestive system.",
    delivery_form: "Capsules",
    directions: "Take as recommended by your healthcare professional.",
  },

  {
    id: 4909013106819,
    title: "Melatonin 3mg (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_c319a4fc-34c7-4dec-8dc1-4bbdcbf807d2_600x600.png?v=1705868272",
    short_desc: "Supports the body's natural sleep cycle.",
    delivery_form: "Capsules",
    directions: "1 capsule daily, 1/2 to 1 hour before bedtime",
  },

  {
    id: 4908882264195,
    title: "SpectraZyme Metagest (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/SpectraZymeMetagest_270T_LSP036F4_400cc_CAN_600x600.png?v=1706201674",
    short_desc:
      "SpectraZyme Metagestfeatures betaine HCl combined with pepsin—a proteolytic enzyme—to complement the natural production of digestive agents in the stomach.",
    delivery_form: "Tablets",
    directions:
      "Take two tablets with each meal or as directed by your healthcare practitioner.",
  },

  {
    id: 4908971360387,
    title: "Blood Sugar Solution Show (Digital Download)",
    vendor: "Dr. Hyman Store",
    image: "//drhyman.com/cdn/shop/products/bss_show_600x600.png?v=1587241203",
    short_desc:
      "A groundbreaking, science-based, easy to follow prescription for figuring out insulin resistance which is at the root of weight gain, diabetes and a host of deadly diseases. Preventable and curable no matter what your family history is. Includes a 4-step plan to help you overcome diabesity and take back your life.",
    delivery_form: "Course",
    directions: "",
  },

  {
    id: 4908947734659,
    title: "Insomnitol Chewable Tablets",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/Insomnitol_600x600.png?v=1709783932",
    short_desc:
      "Insomnitol™ Chewables are great tasting, lemon-flavored tablets formulated to support quality sleep and the promotion of calming brain activity.",
    delivery_form: "Chewable Tablets",
    directions:
      "Take 2 tablets per day or as directed by your healthcare practitioner.",
  },

  {
    id: 4908823740547,
    title: "VitaSpectrum (citrus) (RS)",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-VTS_hires_web_600x600.png?v=1706735994",
    short_desc:
      "Great tasting multivitamin/mineral powder for children with Autism Spectrum Disorders. Packed with highly bioavailable nutrients designed to help malabsorption, chronic diarrhea and other gut issues associated with deficiencies from poor nutrition or elimination diets often linked to autism treatments and symptoms.",
    delivery_form: "Powder",
    directions:
      "Adults or Children 4 or more years of age: 1 scoop daily with food. Children less than 4 years of age: As directed by health practitioner. Mix powder directly into room temperature or cold foods or beverages just before serving.",
  },

  {
    id: 4908961104003,
    title: "Whey Cool™ Unflavored-Unsweetened 900",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/whey_600x600.png?v=1709854870",
    short_desc:
      "Whey Cool™ is a great-tasting high protein, low carbohydrate functional food powder. It is made with a proprietary native whey protein concentrate from grass fed dairy cows.",
    delivery_form: "Powder",
    directions:
      "Mix 1 scoop (approx. 30 grams) to 8 oz water or other beverage, or as directed by your healthcare practitioner.",
  },

  {
    id: 6645071118467,
    title: "Arterosil HP",
    vendor: "Calroy Health Sciences",
    image:
      "//drhyman.com/cdn/shop/files/CURRENTArterosil-HP-bottle-FRONTcopy_600x600.png?v=1710264104",
    short_desc:
      "Arterosil is clinically proven to protect and restore the endothelial glycocalyx.",
    delivery_form: "Capsules",
    directions:
      "Take 2 daily.Each 60-capsule bottle is a 1-month supply at recommended dosing levels.",
  },

  {
    id: 4909007339651,
    title: "Calcium D-Glucarate",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/CalciumD-Glucarate_600x600.png?v=1719524991",
    short_desc:
      "Calcium-D-Glucarate is calcium bound to d-glucaric acid, which is a natural compound produced in small amounts by the human body and is abundantly found in various plant foods such as broccoli, cabbage, kale, apples, oranges, and grapefruit.",
    delivery_form: "Capsules",
    directions: "Take 2 daily, as recommended by your health professional.",
  },

  {
    id: 4908946063491,
    title: "Electrolyte Synergy Powder",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/ElectrolyteSynergyPowder_600x600.png?v=1639764663",
    short_desc:
      "Electrolyte Synergy™ is a complete and balanced electrolyte formula to help promote optimal hydration, especially after excessive sweating.",
    delivery_form: "Powder",
    directions:
      "8 grams (approximately 2 teaspoons) or as recommended by a health-care practitioner",
  },

  {
    id: 4908954419331,
    title: "7 Big Ideas on Fat Video Series",
    vendor: "Dr. Hyman Store",
    image:
      "//drhyman.com/cdn/shop/products/downsell-image_600x600.jpg?v=1587241044",
    short_desc:
      "In this series of seven videos (digital download), Dr. Mark Hyman will debunk the top myths about fat and weight loss. In 80 minutes, Dr. Hyman presents groundbreaking ideas that are the perfect support to hisEat Fat, Get Thin21-Day plan. Additionally get theThe Fat Bible E-Book.",
    delivery_form: "Course",
    directions: "",
  },

  {
    id: 4908999737475,
    title: "Cyto-Quel (GMO Free)",
    vendor: "Researched Nutritionals",
    image: "//drhyman.com/cdn/shop/files/Untitled-27_600x600.png?v=1709667513",
    short_desc:
      "CytoQuel has been developed to promote healthy cytokine activity.",
    delivery_form: "Capsules",
    directions:
      "Take one capsule per day with a meal for the first week, and three capsules per day with a meal in week two and beyond, or use as directed by your healthcare professional. They may be taken at the same meal or spread amongst your meals. For best results take away from Vitamin E (tocopherol).",
  },

  {
    id: 5023522455683,
    title: "Zinc-Carnosine",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/ianxlbtx9bi29i8nesgp_600x600.webp?v=1705619081",
    short_desc:
      "Zinc-Carnosine contains the PepZin GI brand of zinc-carnosine to support a healthy gastrointestinal lining and relieve mild gastric discomforts.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule twice daily, or as recommended by your healthcare professional.",
  },

  {
    id: 4908854182019,
    title: "CoQ10 (Vitaline) 200mg, Chocolate",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/rll8qjptzpvaiwzqfgr8_600x600.webp?v=1705618802",
    short_desc:
      "Pure and natural form of CoQ10 to support cardiovascular health, cellular energy production and overall health, replenishing the levels that naturally decline with age.",
    delivery_form: "Chewable Wafers",
    directions:
      "Adults chew 1 tablet once or twice daily, or as recommended by a healthcare professional.",
  },

  {
    id: 4908786122883,
    title: "Renagen DTX",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/RenagenDTX_60C_LRE015W6_150cc_600x600.png?v=1706201201",
    short_desc:
      "Renagen DTX is a specific blend of nutrients and traditional herbs to promote healthy detoxification and protect against free radical damage.",
    delivery_form: "Capsules",
    directions:
      "One capsule one to two times daily or as directed by your healthcare practition",
  },

  {
    id: 5151964659843,
    title: "ADK EVAIL™",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/ADKEVAIL_600x600.png?v=1709866163",
    short_desc:
      "This formula is designed to help support the balance of fat-soluble vitamins in the body, and to help promote bone, heart, and immune health.",
    delivery_form: "Softgel Capsules",
    directions:
      "As a dietary supplement, take one softgel per day, or as directed by your health-care practitioner",
  },

  {
    id: 4908816531587,
    title: "Riboflavin 400mg",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/qroamfwtank8a6hpjp1w_600x600.webp?v=1705618693",
    short_desc:
      "An essential vitamin for the production of energy,Riboflavin helps support our DNA.",
    delivery_form: "Tablets",
    directions:
      "Adults take 1 tablet daily or as recommended by a healthcare professional",
  },

  {
    id: 4908822200451,
    title: "FolaPro",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/105926_600x600.jpg?v=1742568165",
    short_desc:
      "Provides an active and preferred form of folate for highest nutritional benefits, supportive of metabolic processes in the body, including hormone metabolism, DNA synthesis and proper nervous system function.120 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "One tablet daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4909018218627,
    title: "Metabolic Xtra (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_57809eb4-156e-46d1-a5cd-497c84a6acb0_600x600.png?v=1705868871",
    short_desc: "Supports healthy insulin function and glucose homeostasis.",
    delivery_form: "Capsules",
    directions: "1 capsule 1-3 times daily, with meals",
  },

  {
    id: 4909000130691,
    title: "H2 Absorb",
    vendor: "Researched Nutritionals",
    image: "//drhyman.com/cdn/shop/files/H2Absorb_600x600.png?v=1696248495",
    short_desc:
      "The healthy body creates free radicals as a result of normal activity & metabolism. These free radicals, known as ROS (reactive oxygen species) or RNS (reactive nitrogen species) are kept in check by the healthy body, maintaining normal mitochondrial function and minimizing oxidative stress.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, place one tablet in approximately 8 oz of non-carbonated water, wait for tablet to dissolve and drink immediately. Repeat twice daily or as directed by your healthcare professional.Product may be taken with or without food.",
  },

  {
    id: 6648920899715,
    title: "Tudca",
    vendor: "Body Bio",
    image: "//drhyman.com/cdn/shop/files/tudca_600x600.png?v=1707446812",
    short_desc:
      "TUDCA is a bile acid naturally formed in the body that supports the digestion and utilization of fats and oils and demonstrates neuroprotective benefits",
    delivery_form: "Capsules",
    directions:
      "Recommended dosage is take 2 capsules per day or use as directed. 1750 mg is the tolerable upper limit for most and can be used as a therapeutic dose for as long as one month. Its recommend one to three times daily with meals. It may be taken with or without food. We recommend taking it with food to support absorption. If your gallbladder has been removed, taking it with food may aid in digestion.",
  },

  {
    id: 4908991348867,
    title: "G.I. Fortify Powder",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_32400912-9021-49ec-ac37-d6feb610c74f_600x600.png?v=1705718416",
    short_desc:
      "Supports gastrointestinal health. Promotes healthy bowel movement frequency. Made with hypoallergenic, vegan ingredients. Convenient powder formula for easy dispensing. G.I. Fortify is a blend of high-impact fiber, herbs and nutrients to support overall gastrointestinal function and health. G.I. Fortify specifically supports the function, microflora balance, cellular health and detoxification of the G.I. tract.",
    delivery_form: "Powder",
    directions:
      "Add 1 serving to 8–12 oz water. Shake, stir or blend briskly and drink immediately. Drink an additional 8-12 oz serving of water following. Daily water intake should be increased when consuming this product. Take 1–3 times per day.",
  },

  {
    id: 4908897599619,
    title: "CM Core",
    vendor: "Ortho Molecular",
    image: "//drhyman.com/cdn/shop/products/cmcore_600x600.jpg?v=1587240481",
    short_desc:
      "CM Core provides multidimensional support for cardiovascular health by maintaining healthy cholesterol levels and supporting blood sugar balance already within normal levels.",
    delivery_form: "Capsules",
    directions:
      "3 capsules per day or as recommended by your health care professional",
  },

  {
    id: 4908936102019,
    title: "Stamets 7 Capsules - 60 ct.",
    vendor: "Host Defense",
    image: "//drhyman.com/cdn/shop/files/Untitled-5_600x600.png?v=1709689421",
    short_desc:
      "60 ct.Paul Stamets designed this blend of seven mushroom species to support general immunity. Many use Stamets 7 as a functional food multiple for maintaining peak performance and health.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules once per day. Can be taken with food or on an empty stomach or as recommended by your healthcare professional.",
  },

  {
    id: 4908794347651,
    title: "Fem EstroPlex",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/100398_2c44c203-f765-46aa-bf9f-eef883baa026_600x600.jpg?v=1742567894",
    short_desc:
      "Targeted herbal and vitamin nourishment for early menopause support. Helps support cardiovascular health, circulation, relaxation and adrenal response to stress.90 ct. tablets",
    delivery_form: "Tablets",
    directions:
      "Three tablets daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908808372355,
    title: "LVR Formula",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_f974665f-6e1e-4f8d-8107-630faecd6577_600x600.png?v=1705866124",
    short_desc:
      "A broad-spectrum, synergistic combination of concentrated herbal extracts to nutritionally support liver function. The ingredients rejuvenate hepatic cells and promote the flow of bile. They also combine to support glutathione production, antioxidant protection, and protein synthesis in hepatocytes, promoting liver health.",
    delivery_form: "Capsules",
    directions:
      "2 capsules per day, in divided doses, between meals or as directed by your health care practitioner.",
  },

  {
    id: 6724472602755,
    title: "Quercetin 60ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/products/2e804ea7-e9d3-4cd2-9023-1ea656ec0fcc-2000-2000_600x600.png?v=1643038976",
    short_desc:
      "Quercetin has been shown to be one of the most bioactive flavonoids, and helps maintain healthy histimine production by supporting healthy enzyme activity.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, 1-2 times daily, between meals, or as directed by a health professiona",
  },

  {
    id: 4908891635843,
    title: "MediClear Plus (RS)",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/sp645-front_600x600.png?v=1705592894",
    short_desc:
      "Unflavored medical powdered food from low-allergen rice and pea protein to support poor digestion, imbalances in intestinal flora and overall fatigue. Liver support, aids in detoxification and provides many nutrients along with high-quality protein.",
    delivery_form: "Powder",
    directions:
      "For adults and children 12 or more years of age. Mix one serving (two scoops) with at least 8 ounces of cold water, juice, rice milk, or nut milk, or as recommended by your health professional.",
  },

  {
    id: 4908893044867,
    title: "Glutathione Cell Defense (Formally Recancostat 400)",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/u1q2yshmnl7bjnkehgrl_600x600.webp?v=1705616866",
    short_desc:
      "Glutathione Cell Defense, formerly Recancostat 400, is a patented combination of clinically studied ingredients including stabilized reduced glutathione (GSH), anthocyanins, and L-cysteine, to support cell apoptosis and healthy cell development.*",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule with 12 to 16 ounces of water one to three times daily, or as recommended by your healthcare professional.",
  },

  {
    id: 4908872204419,
    title: "Boron Glycinate: 2 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_272f20b9-b31e-4617-afac-87c522c1aab2_600x600.png?v=1705620831",
    short_desc:
      "Boron nutritionally promotes the proper utilization of many vitamins, minerals, and hormones, which are crucial to the optimal functioning of the human body, helps synthesize estrogen, vitamin D, and other steroidal hormones and protects these hormones from rapid breakdown, while strengthening the connective structure of bones.",
    delivery_form: null,
    directions: "1 capsule, 1-3 times daily, with meals.",
  },

  {
    id: 7828954382467,
    title: "OncoPLEX Plus Myrosinase",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011692_oncoplex-plus-myrosinase-30-capsules_600x600.png?v=1742309724",
    short_desc: "Enhanced Conversion to Sulforaphane*",
    delivery_form: "Capsules",
    directions:
      "Take one capsule daily, or use as directed by your healthcareprofessional.",
  },

  {
    id: 4908879347843,
    title: "Glycine",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image79_d33e4b66-f493-46d8-8129-7aa528fcd99c_600x600.png?v=1705692259",
    short_desc:
      "Amino acid support for healthy memory and detoxification. Supports the liver and kidney along with the nervous system. Supports memory and mental function and has been shown to help the body during metabolic stress and may be useful for those recovering from a stroke.",
    delivery_form: "Capsules",
    directions: "Take 3 capsules, 1-2 times daily, between meals.",
  },

  {
    id: 5079932469379,
    title: "ProBiota HistaminX (DC)",
    vendor: "Seeking Health",
    image:
      "//drhyman.com/cdn/shop/files/PB-HIS-CAP_1_Front_600x600.webp?v=1723738886",
    short_desc:
      "ProBiota HistaminX contains probiotic species that have been carefully selected to exclude those that are known to increase histamine in the gut.",
    delivery_form: "Capsules",
    directions:
      "As needed, take 1 capsule after dinner. Capsule may be opened and contents emptied into a bite of food or drink. Use as directed by your healthcare professional.",
  },

  {
    id: 4908903334019,
    title: "L-carnitine fumerate 120 ct.",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_ab8a248c-ceb0-4d50-aa2f-00085f7f47dd_600x600.png?v=1705864863",
    short_desc:
      "May help promote cardiovascular health, energy, enhance endurance training, maintain a healthy blood lipid metabolism and supports overall muscle and heart function.",
    delivery_form: "Capsules",
    directions: "2 capsules, 1-2 times daily, between meals.",
  },

  {
    id: 4908767150211,
    title: "EndoTrim (RS)",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/EndoTrim_600x600.png?v=1709861816",
    short_desc:
      "EndoTrim™ is a comprehensive endocrine balancing formula designed to promote optimal insulin, leptin and cortisol balance. This formula is for anyone wishing to improve body composition.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take two capsules twice daily on a full stomach, between meals, or as directed by your health care practitioner.",
  },

  {
    id: 7834110492803,
    title: "Vegan DHA-EPA 500 mg",
    vendor: "Deva",
    image: "//drhyman.com/cdn/shop/products/deva_600x600.png?v=1674231464",
    short_desc:
      "DEVA Omega-3 DHA &  EPA is 100% vegan, vegetarian and is registered by the Vegan Society, the non-profit organization that actually invented the word &quot;vegan&quot;.",
    delivery_form: "Softgel Capsules",
    directions:
      "For adults, take one (1) vegan softgel daily with food or as directed by a doctor.",
  },

  {
    id: 4908976930947,
    title: "Argentyn 23 Bio-Active Silver Hydrosol Liquid 16 oz.",
    vendor: "Natural Immunogenics",
    image: "//drhyman.com/cdn/shop/files/161_600x600.jpg?v=1709138108",
    short_desc:
      "Argentyn 23 in the 16 oz. liquid form is a professional grade of silver hydrosol representing the ultimate refinement and most significant breakthrough in colloidal technology, having consistently produced the smallest particles ever seen in colloidal silver products, with the most unique charge attributes (98% positively charged).",
    delivery_form: "Liquid",
    directions:
      "Adults: 1 teaspoon, hold under tongue for 30 seconds, then swallow. Children 4 years and older: 1/2 teaspoon or drink or as directed by a health professional.",
  },

  {
    id: 7875930128515,
    title: "CoQnol 200",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/files/CoQ_600x600.webp?v=1709578023",
    short_desc:
      "CoQnolTM 200 features a unique combination of ubiquinol, also known as coenzyme Q10 (CoQ10), and geranylgeraniol (GG) to support mitochondrial and cellular health.*",
    delivery_form: "Softgel Capsules",
    directions:
      "Take 1 softgel per day with a meal or as directed by your health-care practitioner.",
  },

  {
    id: 4908982468739,
    title: "AllQlear",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/hnj1qqe4mwreavbgicje_600x600.webp?v=1705618959",
    short_desc: "AllQlear for fast-acting seasonal support.",
    delivery_form: "Chewable Tablets",
    directions:
      "Take 2 tablets once or twice daily between meals for seasonal use. May repeat as needed. Do not exceed 10 tablets per day.",
  },

  {
    id: 4908812959875,
    title: "L-Arginine 700mg. 180 ct. (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_27c18571-d812-4259-92b2-440721fb24aa_600x600.png?v=1705863968",
    short_desc:
      "Arginine is crucial for healthy circulation and blood flow, especially in males and important for sexual function, sperm motility, hormone synthesis and enhanced exercise tolerance. Note: should be avoided by those with migraines, depression, autoimmune disorders and kidney or liver disease because of its effect on nitric oxide production.180 ct. veg. capsules",
    delivery_form: "Capsules",
    directions: "2 capsules, 1-3 times daily, between meals.",
  },

  {
    id: 4908812468355,
    title: "Cranberry-d-Mannose",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_d09ab4b0-92ce-446b-930f-ee2b26758ced_600x600.png?v=1705713339",
    short_desc:
      "Cranberry/d-Mannose combines cranberry extract made from 100% cranberry fruit solids and d-mannose for both time-tested and concentrated support of urinary tract comfort.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, 1-3 times daily, with or between meals.",
  },

  {
    id: 4908979257475,
    title: "ProbioMax 350 DF",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011730_probiomax-350-df-15-servings_600x600.png?v=1742316470",
    short_desc:
      "With the 18 different strains of health-promoting bacteria provided in ProbioMax 350 DF, the impact on multiple body systems and functions (such as on immunity, digestion, metabolism, and cytokine production) is maximized because different strains have slightly different functions and are concentrated in various places along the digestive tract.",
    delivery_form: "Packet",
    directions:
      "Dissolve the contents of 1 stick pack into 1-2 oz of pure water and consume once daily, or take as directed by your healthcare professional.",
  },

  {
    id: 7940363190403,
    title: "Organic Pumpkin Seed Protein",
    vendor: "Sprout Living",
    image: "//drhyman.com/cdn/shop/files/pump_600x600.webp?v=1709577747",
    short_desc:
      "Pure and hypoallergenic, Simple Pumpkin Seed Protein is a great option for those looking to keep it, well, simple. Neutral in flavory with a slight hint of nut, it blends well into anything imaginable - from a green smoothie to a stack of banana pancakes.",
    delivery_form: "Powder",
    directions:
      "While it can be enjoyed at any time of the day, we recommend adding it to your post-workout routine (30-60 minutes after) to maximize those fitness results.",
  },

  {
    id: 7865411698819,
    title: "LyteShow Electrolyte Concentrate - 50 Single Serving Rip Packs",
    vendor: "LYTELINE",
    image: "//drhyman.com/cdn/shop/files/lyte_600x600.png?v=1709578209",
    short_desc:
      "At LyteLine, we're all about BETTER hydration. Your body will Thank You.",
    delivery_form: "Packet",
    directions:
      "Mix 3 mL of LyteShow with 32 ounces of water and enjoy. If desired, decrease the amount of water for a more concentrated mixture. Take as needed for hydration, but do not exceed 8 servings in a 24 hour period.",
  },

  {
    id: 4908948717699,
    title: "Iron Liquid 120 ml",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_d7c21e96-997a-4440-b5ac-06d00e72dbe4_600x600.png?v=1705720746",
    short_desc:
      "Iron liquid offers a convenient liquid iron formula with high bioavailability to support hemoglobin and myoglobin function.",
    delivery_form: "Liquid",
    directions:
      "Take 1–2 servings per day, in divided doses, with meals or as directed by your healthcare practitioner.",
  },

  {
    id: 5080370053251,
    title: "Atrantil",
    vendor: "KBS Research",
    image: "//drhyman.com/cdn/shop/files/Untitled-39_600x600.png?v=1709674965",
    short_desc: "Bloating Relief and Everyday Digestive Health",
    delivery_form: "Capsules",
    directions: "One (2) capsule per day up to 3 x&#39;s a day with food.",
  },

  {
    id: 4908841828483,
    title: "Alginate Plus 400 mg",
    vendor: "RX Vitamins",
    image: "//drhyman.com/cdn/shop/files/Untitled-36_600x600.png?v=1709672599",
    short_desc:
      "Alginate Plus provides optimum levels of high-binding alginate and standardized milk thistle in vegetarian capsules. Studies have demonstrated that alginates bind tightly to certain heavy metals and is thus beneficial for those individuals exposed to environmental pollutants or toxins.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take one capsule three times daily with a full glass of water, or as directed by your health care professional.",
  },

  {
    id: 4908947374211,
    title: "Sensitol",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/Sensitol_600x600.png?v=1709866401",
    short_desc:
      "Sensitol™ is designed to support normal insulin function and cellular metabolism.",
    delivery_form: "Capsules",
    directions:
      "Take two capsules two times per day or as directed by your healthcare practitioner.",
  },

  {
    id: 4908993118339,
    title: "Amino Complex powder lemon",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/sp637-front_600x600.png?v=1705979503",
    short_desc:
      "Essential amino acid supplement to help support lean muscle mass and muscle strength development, and support the musculoskeletal system. A delicious stevia sweetened lemon flavor powder to mix easily into warm or cold liquids.",
    delivery_form: "Powder",
    directions:
      "Mix 1 scoop with 6 oz of water one to two times daily or as recommended by your health-care practitioner.",
  },

  {
    id: 6645454930051,
    title: "VitaPrime 120 ct",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/VTP1_hires_web_600x600.png?v=1709866772",
    short_desc:
      "Just twice daily multi for those looking for less supplements, and iron-free. A strong core of vitamins and minerals with enhanced antioxidant protection, broader trace mineral nutrition and heightened B vitamin support.",
    delivery_form: "Tablets",
    directions:
      "Adults: 2 tablets daily with food. Children 4 to 14: Take 1 tablet daily with food or as directed by healthcare professional. Children less than 4 years of age: As directed by healthcare professional.",
  },

  {
    id: 4908914180227,
    title: "Lavela WS 1265 (RS)",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/tkfiri2e8se2hwsbmcxy_600x600.webp?v=1705619281",
    short_desc:
      "An exclusive and potent lavender oil used for occasional anxiety, this may help promote relaxation and calm nervousness without any side effects.",
    delivery_form: "Softgel Capsules",
    directions:
      "Take 1 softgel once or twice daily with a full glass of water, or as recommended by your healthcare professional.",
  },

  {
    id: 5138328027267,
    title: "Lauricidin",
    vendor: "Med-Chem Labs",
    image:
      "//drhyman.com/cdn/shop/files/Artboard2copy5_600x600.webp?v=1709866335",
    short_desc:
      "Lauricidin is intended to be taken for long-term support of general health and wellness.",
    delivery_form: null,
    directions:
      "Children (3-10 years old) - Do not chew pellets. To be taken with meals. The mini-pellets can be placed in the mouth and swallowed with water or juice. Do not take with hot liquids. For difficult situations try placing the pellets (whole or powdered) into applesauce, pudding, peanut butter, etc. Adults- Take with or after meals. The mini-pellets can be placed in the mouth and swallowed with water or juice. Do not take with hot liquids. Do not chew or take as a powder. The recommended initial level of Lauricidin is ~0.75 gram (1/4 blue scoop) or less two or three times daily for a week before increasing the amount.",
  },

  {
    id: 7940232708227,
    title: "Organic Pea Protein",
    vendor: "Sprout Living",
    image: "//drhyman.com/cdn/shop/files/pea_600x600.png?v=1709577833",
    short_desc:
      "Pure and hypoallergenic, Simple Pea Protein is a great option for those looking to keep it, well, simple. Neutral in flavor with a slight hint of sweetness, it blends well into anything imaginable - from a very berry smoothie to a dish of baked oatmeal.",
    delivery_form: "Powder",
    directions:
      "We love just shaking it up with 12oz of cold water, but feel free to add it to your favorite smoothie recipe or incorporate it as a boost to baking or snack recipe",
  },

  {
    id: 4908812173443,
    title: "DHEA (Micronized) 10mg 180 ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_cdfa8094-09e9-46d4-81dd-ae408575ecfb_600x600.png?v=1705716503",
    short_desc:
      "180 ct. veg. capsules - 10 mg.Pure Encapsulations DHEA is micronized to increase absorption. It is made with 99% pure, pharmaceutical grade DHEA.",
    delivery_form: "Capsules",
    directions: "1 capsule daily with a meal.",
  },

  {
    id: 4908913557635,
    title: "ArginCor (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/ArginCor_1539314L3_32oz_600x600.png?v=1706039645",
    short_desc:
      "ArginCor™ is a medical food formulated to provide specialized nutritional support for patients with peripheral artery disease. It provides high quality L-arginine, magnesium, folate, and beet powder to increase nitric oxide production to support circulation and heart muscle function.",
    delivery_form: "Powder",
    directions:
      "Take about two scoops (25 grams) with 8 fluid ounces of water daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908985188483,
    title: "AuRx",
    vendor: "Tesseract",
    image:
      "//drhyman.com/cdn/shop/products/tessmed-aurx-600w_600x600.png?v=1709866531",
    short_desc:
      "This product is designed to provide specific nutritional requirements for ASD patients with SCFA gut microbiome deficiencies as evaluated by a medical professional.",
    delivery_form: "Powder",
    directions:
      "Mix 1-2 scoops in water, juice or applesauce two times daily as directed by your physician.",
  },

  {
    id: 4908879970435,
    title: "Inositol Powder (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_f4f77252-4a8a-4cc3-bfc7-b2ea56146966_600x600.png?v=1710175190",
    short_desc:
      "Inositol, part of the B-complex family, supports emotional wellness, behavior and mood, promotes healthy ovarian function and the central nervous system. May help reduce nervous tension and supports the whole reproductive system, especially in women.",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, take 2 scoops, 1-2 times daily, mixed with water, with or between meals, or as directed by a health professional.",
  },

  {
    id: 8507259420803,
    title: "Long COVID Recovery Guide",
    vendor: "Mark Hyman, MD",
    image:
      "//drhyman.com/cdn/shop/files/recovery_guide_600x600.jpg?v=1730847790",
    short_desc:
      "This comprehensive Long COVID Recovery guide is a 61-page PDF designed to help you better understand and manage the lingering symptoms that persist after COVID-19. Drawing on the latest research and Dr. Hyman's expertise, this guide offers practical strategies to support your recovery through nutrition, lifestyle adjustments, and advanced therapeutics.What You'll Learn:How Long COVID can cause a wide range of symptoms—from brain fog and fatigue to digestive issues and heart problems—and why it feels like your whole body is struggling to recoverEffective nutrition strategies and carefully selected supplements designed to strengthen your immune system, reduce inflammation, and support your recoveryLifestyle changes, including guidance on exercise, sleep, and stress reduction, to help you manage and navigate your symptoms and improve your well-beingAdvanced treatments and therapies that offer new options to explore, especially for the toughest cases where other approaches haven't workedSpecific Insights Include:Why even light physical activity can leave you feeling exhausted and how to gradually rebuild your fitness levels without overdoing itHow hidden, lingering infections (like those that cause cold sores or mono) might flare up after COVID and make your symptoms worse—and what you can do about itThe role of chronic inflammation in ongoing fatigue, brain fog, and other symptoms—and practical steps to reduce itLab tests that can uncover underlying problems like clotting issues, nutrient deficiencies, or gut imbalances so you can target the right treatmentsA step-by-step guide to using supplements—like quercetin, vitamin D, and omega-3 fatty acids—to support recovery and tackle specific symptomsHow to restore gut health and ease symptoms like bloating and digestive discomfort that often come with Long COVIDIn-depth explanations of advanced therapies like peptide therapy, ozone therapy, and plasmapheresis—and how they may help when other treatments haven't workedTips to improve sleep quality and manage stress for better energy and mental clarityA quiz to help you identify which supplement stack to start with, based on your symptoms—so you can create a plan that's tailored to your needsOnce you order, we'll immediately email you a downloadable link to this PDF guide.",
    delivery_form: null,
    directions: "",
  },

  {
    id: 4908965003395,
    title: "Zapper (Everyday Throat Spray) 1 oz.",
    vendor: "Your Health Solutions",
    image: "//drhyman.com/cdn/shop/files/Untitled-4_600x600.png?v=1709689266",
    short_desc:
      "The name has been updated to Zapper Throat Spray. Same great formula. An all natural, great-tasting herbal throat spray that provides immunity support and promotes fresh breath.",
    delivery_form: "Spray",
    directions:
      "Spray 1-2 times into the throat and swallow, or as directed by your healthcare practitioner.",
  },

  {
    id: 5070230945923,
    title: "Buffered C Powder",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/c155-front_600x600.png?v=1705980631",
    short_desc:
      "Vitamin C that's buffered, so it's easier on the stomach.Buffered C Powder makes it easier for individuals with a sensitive or compromised digestive system to take a higher amount of vitamin C. It also provides calcium, magnesium, and potassium.",
    delivery_form: "Powder",
    directions:
      "Mix 1 scoop with at least 8 ounces of water one to two times daily or as recommended by your health professional.",
  },

  {
    id: 4908785795203,
    title: "Lipo-Gen (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/Lipo-Gen_90T_LLP003Y4_150cc_600x600.png?v=1706120840",
    short_desc:
      "Lipo-Gen is a highly specialized formula that features a broad-spectrum and unique blend of lipotropic nutrients combined with select amino acids, vitamins, and herbs to support healthy liver and gallbladder function.",
    delivery_form: "Tablets",
    directions:
      "Two tablets at mealtime or as directed by your healthcare practitioner",
  },

  {
    id: 6648901927043,
    title: "Liquid Vitamin D3 with K2",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/870-LIQUIDVitaminD3withK2_600x600.png?v=1705958317",
    short_desc:
      "Research shows that vitamin K2 and D3 work together for healthy bones and hearts. Vitamin K2 helps use calcium for bones by activating osteocalcin and prevents bone breakdown. It also protects the heart by activating a protein that stops calcium buildup in arteries. Liquid Vitamin D3 with K2 uses a special fat called medium-chain triglyceride (MCT) for easy absorption. Each serving provides 10 mcg of MenaQ7 PRO (K2) and 1,000 IU of D3. MCTs make it easy to mix into drinks without any extra taste or smell.",
    delivery_form: "Liquid",
    directions:
      "1 or more drops per day (can be taken directly on the tongue or mixed with the beverage of your choice) or as recommended by your health care professional.",
  },

  {
    id: 4908948357251,
    title: "SpectraZyme Gluten Digest",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/106910_600x600.jpg?v=1742568465",
    short_desc:
      "SpectraZyme Gluten Digest, featuring Tolerase G, is a targeted protease enzyme supplement that has been clinically shown to digest gluten proteins in humans, in vitro, and in a gastrointestinal model.",
    delivery_form: "Capsules",
    directions:
      "Take 1-2 capsules with each meal or as directed by your healthcare practitioner.",
  },

  {
    id: 5194124427395,
    title: "Polyphenol Nutrients 180ct",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/pn_600x600.png?v=1709662061",
    short_desc:
      "A unique and powerful polyphenol rich multivitamin/mineral formula packed with flavonoids for potent cellular protection. Supports neural, cognitive, cardiovascular, liver and skin health.",
    delivery_form: "Capsules",
    directions: "3 capsules, 1-2 times daily, with meals",
  },

  {
    id: 4908978831491,
    title: "Omega MonoPure 1300 EC",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011678_omega-monopure-1300-ec-60-softgels_600x600.png?v=1742237730",
    short_desc:
      "Omega MonoPure 1300 EC features natural enzymatically enhanced MaxSimil monoglyceride fish oil that has a three times greater EPA/DHA absorption rate than an equivalent dose of ethyl ester fish oil.",
    delivery_form: "Softgel Capsules",
    directions:
      "Take 1 softgel daily, or use as directed by your healthcare professional.",
  },

  {
    id: 4908825378947,
    title: "P5P 50 (RS)",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/image105_600x600.png?v=1706582914",
    short_desc:
      "Required for the proper absorption of B12 and magnesium and for the production of HCL, important for healthy digestion and the metabolism of fats, carbs and proteins. Required for antibody and red blood cell production and helps with energy production in the liver and muscles. Balances the nervous and musculoskeletal systems.180 ct. capsules",
    delivery_form: "Capsules",
    directions: "1 capsule, 1-2 times daily, with meals.",
  },

  {
    id: 4908999245955,
    title: "TruFiber",
    vendor: "Master Supplements/US ENZYMES",
    image:
      "//drhyman.com/cdn/shop/files/TRUFIBERFront_600x600.png?v=1717072247",
    short_desc:
      "A prebiotic fiber that helps probiotics proliferate and improves digestive regularity.",
    delivery_form: "Powder",
    directions:
      "Mix one scoop into 8-12 ounces of non-carbonated beverage. Additional mixing may be needed depending on beverage and temperature.",
  },

  {
    id: 4908975325315,
    title: "Probiophage DF 60 ct. (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/ProbiophageDF60ct._8564e35b-60ae-4850-bc37-20e61921f5d1_600x600.png?v=1709866683",
    short_desc:
      "Probiophage DF is designed to support the proliferation of beneficial bacteria throughout the small and large intestines in order to promote healthy GI and immune function.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule daily, or as directed by your health professional.",
  },

  {
    id: 4909004357763,
    title: "Motility Activator",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/jlge8sjqdwi5lwiaklaq_600x600.webp?v=1705619450",
    short_desc:
      "Motility Activator consists of standardized extracts of Cynara cardunculus and Zingiber officinale and supports gastrointestinal motility and transport.This patented combination has been the subject of two human randomized controlled trials.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule twice daily or as recommended by a heathcare professional.",
  },

  {
    id: 5079936598147,
    title: "BIOMEGA-3 LIQUID",
    vendor: "Biotics",
    image: "//drhyman.com/cdn/shop/products/BioLiq_600x600.png?v=1593462407",
    short_desc:
      "EPA and DHA, as well as 405 mg of other omega-3 fatty acids.  Natural lemon flavoring makes this product easy to enjoy.",
    delivery_form: "Liquid",
    directions:
      "One (1) teaspoon each day as a dietary supplement or as otherwise directed by a healthcare professional",
  },

  {
    id: 4908938788995,
    title: "PC (Phosphatidyl choline) - 100 softgels",
    vendor: "Body Bio",
    image: "//drhyman.com/cdn/shop/files/pc_600x600.png?v=1707447389",
    short_desc:
      "BodyBio PC combines four forms of pure phospholipids for quick absorption to rebuild every cell in your body, benefitting every key system.",
    delivery_form: "Softgel Capsules",
    directions:
      "To enhance and rebuild the integrity of your cells, simply take 2 softgels. If you are struggling with a health concern, we recommend working with a healthcare practitioner that is knowledgeable in lipid replacement therapy. May be taken on an empty stomach or with a meal as desired.",
  },

  {
    id: 4908998852739,
    title: "Enzalase (RS)",
    vendor: "Master Supplements/US ENZYMES",
    image: "//drhyman.com/cdn/shop/products/enzelase_600x600.jpg?v=1587241461",
    short_desc:
      "Enzalase contains twelve different enzymes which aid your body in breaking down carbohydrates, fiber, proteins, and fats, helping you and the probiotics in your gut derive more nutrition from the food you eat as well as providing relief from daily gas and bloating.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement for adults, take one capsule with water at the start of a meal. For systemic use, take one capsule a day on an empty stomach.",
  },

  {
    id: 7917396099203,
    title: "HistDAO TAB",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011612_histdao-60-tablets_600x600.png?v=1742237362",
    short_desc:
      "» Supports Healthy Degradation of Food-Derived Histamine*» Enhances the Presence of Diamine Oxidase in the Digestive Tract*HistDAOTM provides a concentrated source of diamine oxidase (DAO)— the main enzyme responsible for the degradation of ingested histamine. This formula delivers the clinically researched dose of DAO in an easy-to-swallow, gastro-resistant mini-tablet, which is essential for releasing DAO in the small intestine, where it breaks down food-derived histamine.*",
    delivery_form: "Tablets",
    directions:
      "Take one tablet no more than 15 minutes before the consumption of histamine-rich foods, or take as directed by your healthcare professional.",
  },

  {
    id: 4908978339971,
    title: "DIM Nanoemulsified",
    vendor: "Quicksilver Scientific",
    image: "//drhyman.com/cdn/shop/files/DIMBottle_600x600.png?v=1708310725",
    short_desc:
      "Diindolylmethane (DIM)supports a healthy immune response, normal hormone metabolism, and natural detoxification pathways. Quicksilver Delivery Systems™optimizes bioavailability of DIM with the nanoemulsified delivery format, with DIM absorbing orally and via the lymphatics, circumventing issues with poor absorption and rapid clearance that exist for other oral-based DIM supplements.",
    delivery_form: "Liquid",
    directions:
      "Take 2-4 pumps at a time twice a day or as directed by a healthcare professional. Hold in month 30 seconds before swallowing.Best taken on an empty stomach.",
  },

  {
    id: 4908995117187,
    title: "Super Liquid Folate 1 fl oz (30 mL) (RS)",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/super_600x600.png?v=1709866878",
    short_desc:
      "Research suggests that folate is an important nutrient for maintaining healthy homocysteine levels.The liquid form is easy to use, allowing for easy titration and rapid absorption.",
    delivery_form: "Liquid",
    directions:
      "As a dietary supplement, take one drop per day; or as directed by your health care practitioner.",
  },

  {
    id: 4908880167043,
    title: "Niatain",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/Niatain_60T_LNA010N2_100cc_600x600.png?v=1706128679",
    short_desc:
      "Niatain™ offers clinically evaluated, extended niacin delivery for a more comfortable approach to healthy lipid metabolism support with reduced flushing potential.",
    delivery_form: "Tablets",
    directions:
      "Take 1 to 2 daily with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908970410115,
    title: "Ionic Iodine from Potassium Iodide",
    vendor: "Trace Minerals Research",
    image: "//drhyman.com/cdn/shop/files/POTPIC_600x600.png?v=1704732451",
    short_desc:
      "Ionic Iodine is a rich, concentrated liquid dietary supplement that provides 225 mcg of iodine from potassium iodide per serving, plus over 72 ionic trace minerals from ConcenTrace,",
    delivery_form: "Liquid",
    directions: "",
  },

  {
    id: 7865399902339,
    title:
      "LyteShow 4 oz. Bottle- Electrolyte Concentrate For Rapid Rehydration",
    vendor: "LYTELINE",
    image: "//drhyman.com/cdn/shop/files/lyteshow_600x600.png?v=1709578517",
    short_desc:
      "At LyteLine, we're all about BETTER hydration. Your body will Thank You.",
    delivery_form: "Liquid",
    directions: "",
  },

  {
    id: 7828392149123,
    title: "SunFiber",
    vendor: "Master Supplements/US ENZYMES",
    image:
      "//drhyman.com/cdn/shop/files/sunfiber-TNP_main_1copy_600x600.png?v=1709578669",
    short_desc:
      "SunFiber is true regulating, all-natural prebiotic fiber supplement that delivers six grams of proven, clear, grit free, 100% soluble fiber.",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, mix approximately one scoop (7 g) into 6-8 ounces of water or any non-carbonated beverage.",
  },

  {
    id: 7722650108035,
    title: "Strontium Boost",
    vendor: "AlgaeCal",
    image:
      "//drhyman.com/cdn/shop/products/StroniumBoost_600x600.webp?v=1657740813",
    short_desc:
      "Strontium is the only material on earth— natural or otherwise— shown to stimulate bone-building cells while slowing down overactive bone-resorbing cells. Combine with AlgaeCal Plus to triple your bone density increases.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules before bed, with or without food, but separate from calcium by at least 2 hours.",
  },

  {
    id: 4909015466115,
    title: "Bergamot",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/598-120-Bergamot_600x600.png?v=1709059830",
    short_desc:
      "Optimizing cardiovascular health is a leading concern for many adults, and maintaining balanced cholesterol levels are an important part of that process.",
    delivery_form: "Capsules",
    directions:
      "2 capsules per day or as recommended by your health care professional.",
  },

  {
    id: 5004942803075,
    title: "Chlorella 180 ct caps (RS)",
    vendor: "Biotics",
    image:
      "//drhyman.com/cdn/shop/files/1109_ChlorellaCaps_01FEB24_large_ad48d53a-eacc-452a-b9a8-bc8f3f163208_600x600.webp?v=1718652761",
    short_desc:
      "Chlorella Caps™ supplies high quality Chlorella, a single-cell algae.",
    delivery_form: "Capsules",
    directions:
      "Take 3 capsules each day as a dietary supplement or as otherwise directed by a healthcare professional.",
  },

  {
    id: 4908937576579,
    title: "MyCommunity 60 ct.",
    vendor: "Host Defense",
    image:
      "//drhyman.com/cdn/shop/products/HostDefense-NCMC60-MyCommunityCapsules-60ct-RightFacing-00_590x_1_600x600.webp?v=1709867542",
    short_desc:
      "Host Defense MyCommunity uses Certified Organic mycelium and fruitbodies, with a full spectrum of constituents: polysaccharides (beta glucans, arabinoxylane, glucose, xylose, galactose and cordycepic acid), glycoproteins, ergosterols, triterpenoids and other myconutrients, which are essential for Supporting Natural Immunity.",
    delivery_form: "Capsules",
    directions:
      "2 capsules daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908880822403,
    title: "V Clear EPs 7630 Syrup",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/w9g5wvjnrs1xeqpil7vb_600x600.webp?v=1705619369",
    short_desc:
      "An herbal extract long used to treat cough and respiratory ailments. Part of your winter medicine tool kit, this can help speed recovery and shorten duration of upper respiratory tract infections, works for children and adults alike.",
    delivery_form: "Liquid",
    directions:
      "For best results, use at the first sign of symptoms and continue to use for an additional 48 hours after symptoms cease. Adults &amp; children 12 years of age and older: Take 1.5 mL three times daily. Children under 12 years of age: Consult a physician.",
  },

  {
    id: 4908951797891,
    title: "HM Complex 90  ct. (formally HM Chelate)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/hm-complex-90-s-improved-hmc9_600x600.png?v=1714765914",
    short_desc:
      "New & Improved Formulareplacing HM Chelate. HM Complex promotes the body's natural, healthy detoxification reaction to common, mild environmental heavy metal exposure while supporting antioxidant and immune defenses.",
    delivery_form: "Capsules",
    directions:
      "3 capsules daily, between meals, or as directed by a health professional.",
  },

  {
    id: 4908930891907,
    title: "Ox Bile 125 mg",
    vendor: "Allergy Research Group",
    image: "//drhyman.com/cdn/shop/files/oxbile125_600x600.png?v=1708301967",
    short_desc:
      "Derived from a bovine source and freeze-dried (lyophilized) to maintain its biological activity, Ox Bile is a suitable supplement to the liver's production of bile.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, 1 capsule three times daily with meals, or as directed by a healthcare practitioner.",
  },

  {
    id: 4909001703555,
    title: "Dentalcidin Oral Microbiome Toothpaste",
    vendor: "Bio-Botanical Research",
    image:
      "//drhyman.com/cdn/shop/files/Dentalcidin_3oz_Tube_38174535-d8c6-4455-b2ab-1e3cf86271b0_600x600.png?v=1709945711",
    short_desc:
      "Assists in Removing Biofilms and Plaque for Healthy Teeth and Gum with Essential Oils - Tea Tree, Spearmint, Peppermint, Cinnamon, Lavender, Oregano, Galbanum, Clove.",
    delivery_form: "Paste",
    directions: "Brush with Dentalcidin 2-3 times daily.",
  },

  {
    id: 4908977913987,
    title: "Argentyn 23 Bio-Active Silver Hydrosol Fine Mist 2 oz. (RS)",
    vendor: "Natural Immunogenics",
    image: "//drhyman.com/cdn/shop/files/Untitled-44_600x600.png?v=1709675526",
    short_desc:
      "Argentyn 23 in the 2 oz. Fine Mist spray form is a professional grade of silver hydrosol which represents the ultimate refinement and most significant breakthrough in colloidal technology, having consistently produced the smallest particles ever seen in colloidal silver products, with the most unique charge attributes (98% positively charged).",
    delivery_form: "Spray",
    directions:
      "Adults: 30 sprays, hold under tongue for 30 seconds, then swallow. Children 4 years and older: 15 sprays or as directed by a health professional. Maintenance: Once daily. Immune-Building: 3 times daily. Long-Term Immune Support: 5 times daily. Short-Term Immune Support: 7 times daily.",
  },

  {
    id: 4909001244803,
    title: "Female Support Formula (Womens Balance)",
    vendor: "Gaia Herbs",
    image:
      "//drhyman.com/cdn/shop/files/Gaia-Herbs-Professional-Solutions-Female-Support-Formula_LAP17060_104_PDP_600x600.png?v=1706023219",
    short_desc:
      "Helps to keep the body and mind balanced through the hormonal fluctuations of PMS and menopause is vital to maintaining an optimal quality of life.",
    delivery_form: "Softgel Capsules",
    directions:
      "Adults take 1 capsule 3 times daily between meals or as directed by your health care provider.",
  },

  {
    id: 6623548080259,
    title: "Taurine 500 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_1b8117eb-4019-4e4f-b048-db2da8e87369_600x600.png?v=1706585654",
    short_desc:
      "Taurine is designed to provide support for cardiovascular, brain and gallbladder health. Taurine promotes healthy heart contractibility as well as supports the body's natural detoxification process.",
    delivery_form: "Capsules",
    directions: "1 capsule, 1-4 times daily, between meals",
  },

  {
    id: 4908990922883,
    title: "MotilPro (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_be75bddd-afcb-4b21-8f19-ec2115878242_600x600.png?v=1705869105",
    short_desc:
      "Supports G.I. motility. Stimulates gut signaling neurons. Made with hypoallergenic, vegan ingredients. MotilPro promotes advanced gut signaling for healthy gut motility.",
    delivery_form: "Capsules",
    directions: "3 capsules, 1-2 times daily, between meals.",
  },

  {
    id: 4908920569987,
    title: "Vital Adapt 60s",
    vendor: "Natura",
    image:
      "//drhyman.com/cdn/shop/products/VA60_source_1635435932_600x600.png?v=1709867459",
    short_desc:
      "Vital Adapt is a nourishing broad spectrum herbal tonic designed to optimize the body's natural resistance and adaptation to stressful influences, while promoting health, longevity and total well-being.",
    delivery_form: "Capsules",
    directions:
      "2 capsules, 2-3x daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908933415043,
    title: "Ceriva 30 ct. (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/Ceriva_30T_LCE049E1_60cc_600x600.png?v=1706109068",
    short_desc:
      "Ceriva is formulated to support healthy brain aging, cognition , and memory by beneficially modulating the metabolism of the neurotransmitter acetylcholine and providing neuroprotection.",
    delivery_form: "Tablets",
    directions:
      "Take 1 tablet daily with food or as recommended by your health-care practitioner.",
  },

  {
    id: 7712022429827,
    title: "PureLut",
    vendor: "Algonot",
    image:
      "//drhyman.com/cdn/shop/files/3_5b1e4b79-8343-4684-b381-8e4e2af91f03_600x600.png?v=1739891592",
    short_desc: "Reduces hyperactivity due to absorption issues",
    delivery_form: "Softgel Capsules",
    directions:
      "As a dietary supplement, take (one) 1 softgel capsule up to 4 times daily, or as recommended by your healthcare professional. May be taken with or without food.",
  },

  {
    id: 4908806635651,
    title: "Cognitive Aminos (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_118ef2ae-8dd0-4218-87fa-4f5b556f36a4_600x600.png?v=1705622035",
    short_desc:
      "Cognitive Aminos provides amino acid precursors for healthy neurotransmitter activity, supporting optimal mental function and healthy mood.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules, 1-2 times daily, between meals",
  },

  {
    id: 7828251345027,
    title: "MITO- PQQ",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/mitopqq_600x600.png?v=1709913109",
    short_desc:
      "Mito-PQQ™ is designed to help support optimal mitochondrial biogenesis, which involves the formation of new mitochondria, a critical process for the promotion of healthy aging, energy production, and antioxidative status.*",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules per day or as directed by your health-care practitioner.",
  },

  {
    id: 4908969394307,
    title: "Arthroben Unflavored-Unsweetened (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/ArthrobenUnflavored-Unsweetened_600x600.png?v=1709867118",
    short_desc:
      "Arthroben is a safe, effective, non-NSAID, anti-inflammatory formula offered in a highly absorbable powder free of flavorings and sweeteners. Its combination of nutrients work to reduce inflammation, stimulate connective tissue repair and increase joint mobility and function.",
    delivery_form: "Powder",
    directions:
      "Mix 11 grams (approximately one scoop) in 8 ounces of water per day or as directed by your health-care practitioner.",
  },

  {
    id: 7822472806531,
    title: "Methyl-Guard Plus",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/sf789-front_600x600.png?v=1709921697",
    short_desc:
      "Supports heart, blood vessel, brain, and bone health by enhancing healthy methylation",
    delivery_form: "Capsules",
    directions:
      "Take 1-3 capsules daily or as recommended by your health professional.",
  },

  {
    id: 4908773408899,
    title: "UT Synergy (RS)",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/ut_600x600.png?v=1709867400",
    short_desc:
      "UT Synergy is designed to help maintain optimal urinary tract function. A blend of nutrients, botanicals, and nutraceuticals have been combined in order to limit inflammation and tissue irritation, and it can provide a natural alternative or complimentary therapy for mild acute and chronic urinary tract infections",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take one capsule two times daily or as directed by your health care practitioner.",
  },

  {
    id: 7911087440003,
    title: "CoQnol 100",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/COQ100_coqnol-100_100cc_watermark_product-image_600x600.webp?v=1709860137",
    short_desc:
      "CoQnolTM 100 and CoQnolTM 200 features a unique combination of ubiquinol, also known as coenzyme Q10 (CoQ10), and geranylgeraniol (GG) to support mitochondrial and cellular health.*",
    delivery_form: "Capsules",
    directions:
      "Take 1 softgel per day with a meal or as directed by your health-care practitioner.",
  },

  {
    id: 4908991905923,
    title: "ImmunoKinoko 750",
    vendor: "QOL Labs",
    image:
      "//drhyman.com/cdn/shop/files/Immunokinoko750150cc_600x600.png?v=1709867247",
    short_desc:
      "A highly effective immune modulator used in over 1,000 medical clinics worldwide* Japan's top-selling immune-supporting specialty dietary supplement.",
    delivery_form: "Capsules",
    directions: "Daily dose: 2–6 vegicaps.",
  },

  {
    id: 4908879741059,
    title: "Calcium-d-Glucarate",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/Untitled-46_600x600.png?v=1709675901",
    short_desc:
      "Greatly enhances the body's natural ability to detox, and promotes lipid metabolism and healthy cells, especially in the liver, prostate, lung, breast and colon.",
    delivery_form: "Capsules",
    directions:
      "Take 1 to 6 capsules daily, in divided doses with meals or as directed by your health care practitioner.",
  },

  {
    id: 6623591104643,
    title: "MitoCORE 120",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/products/MitoCORE-1171202c5a94b0-8f39-416a-84a4-c52968297c98_600x600.png?v=1629477484",
    short_desc:
      "MitoCORE is a supplement that boosts mitochondrial reserves and recharges cellular energy production with antioxidants, micronutrients and phytonutrients. It supports immune function, antioxidant protection, detoxification capacity and more.",
    delivery_form: "Capsules",
    directions:
      "2-4 capsules per day or as recommended by your health care professional.",
  },

  {
    id: 6608354836611,
    title: "MegaMucosa (RS)",
    vendor: "MICROBIOME LABS",
    image:
      "//drhyman.com/cdn/shop/files/image79_d5d718c9-6604-469a-bf2d-310013a2de13_600x600.png?v=1705692655",
    short_desc:
      "MegaMucosa is the first complete mucosal support supplement of its kind, formulated to support a healthy mucosal barrier.",
    delivery_form: "Powder",
    directions:
      "Take 1 scoop daily with or without food, or as directed by your healthcare practitioner. Mix into 16 oz of cold water or liquid of your choice.",
  },

  {
    id: 7822442299523,
    title: "Zinc Picolinate 30mg",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/m220-front_600x600.png?v=1709921822",
    short_desc:
      "From supporting immune function to reproductive health, zinc is an essential nutrient that plays a key role in your health*",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule daily or as recommended by your health professional.",
  },

  {
    id: 4909021954179,
    title: "Pro Som (RS)",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/ojhptxsijcsg5i4gpzye_600x600.webp?v=1705619551",
    short_desc:
      "This formula supports restful sleep and relaxation without melatonin, reducing the known concerns regarding melatonin intolerance in certain people and melatonin-related morning grogginess.",
    delivery_form: "Capsules",
    directions:
      "Take 2-4 capsules beofre bedtime, or as recommended by your health care professional",
  },

  {
    id: 4908974047363,
    title: "BenfoMax 90ct.",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/benfomax_600x600.png?v=1705367189",
    short_desc:
      "BenfoMax helps maintain healthy advanced glycation end (AGE) activity to support vascular, nerve, retinal and kidney cellular health.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 1-3 times daily, with meals.",
  },

  {
    id: 5140766589059,
    title: "OptiMag Neuro Unflavored",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011709_optimag-neuro-unflavored-60-servings_600x600.png?v=1742313469",
    short_desc: "Patented Magnesium for the Brain*",
    delivery_form: "Powder",
    directions:
      "Dissolve one level scoop in 4 oz water. First week: one serving per day immediately before dinner or one hour before bedtime. Thereafter: one serving during the day, preferably mid-afternoon, and a second serving before bedtime; or use as directed by your healthcare practitioner.",
  },

  {
    id: 4908769706115,
    title: "Amino-D-Tox (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/AMT180_8ec289a0-6e26-41ce-850a-404f89e4e9d4_600x600.png?v=1709867179",
    short_desc:
      "Amino-D-Tox™ was designed by clinicians to biochemically upregulate phase II detoxification. It is free of herbals, minerals and B vitamins which would also upregulate phase I detoxification.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take six capsules per day with meals or as directed by your health care practitioner.",
  },

  {
    id: 4908870631555,
    title: "RegeneMax Plus",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011751_regenemax-plus-60-capsules_600x600.png?v=1742327065",
    short_desc:
      "New &Improved Formula. RegeneMax Plus is a patented choline-stabilized formulation of orthosilicic acid (OSA) whichhelps nourish your body's beauty proteins by supporting and activating enzymes used by collagen-generating cells to make collagen.",
    delivery_form: "Capsules",
    directions:
      "Take one capsule two times per day, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908790677635,
    title: "Mg-K Aspartate",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/Mg_KAspartate_60T_LMG001W1_120cc_600x600.png?v=1706121080",
    short_desc:
      "Mg/K Aspartate™features magnesium and potassium in the form of true Minerals are essential elements in the diet that are required for making hormones, regulating body functions such as your heartbeat, building bones, and are necessary for numerous enzymatic reactions mineral aspartates to enhance absorption",
    delivery_form: "Tablets",
    directions:
      "Two tablets daily or as directed by your healthcare practitioner.",
  },

  {
    id: 7766801121411,
    title: "Metal-X-Synergy",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/mxs060-metal-x-synergy-60capsules_600x600.png?v=1709912442",
    short_desc:
      "Metal-X-Synergy™ is a natural formula designed to support the body's natural clearance of toxic metals, including aluminum, arsenic, cadmium, lead, and mercury, without many of the common side effects found with the use of harsh synthetic chelating agents",
    delivery_form: "Capsules",
    directions:
      "Take 4 capsules per day with meals or as directed by your health-care practitioner. (Divided dosing recommended.) It is recommended that Metal-X-Synergy™ be taken 2 hours before or after any medications or other supplements.",
  },

  {
    id: 4908964806787,
    title: "Olive Leaf Extract 120 ct. (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_b200799e-7801-4e8f-ae77-7a835e305dbb_600x600.png?v=1706583073",
    short_desc:
      "This pharmaceutical grade olive leaf extract contains the highest concentration (20%) of oleuropein available, and provides natural protection and a healthy environment for cells, without suppressing immune system function or harming beneficial microflora.",
    delivery_form: "Capsules",
    directions: "1 capsule, 1-2 times daily, with meals.",
  },

  {
    id: 5140977713283,
    title: "Leptin Manager",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011641_leptin-manager-30-capsules_600x600.png?v=1742237590",
    short_desc:
      "Healthy leptin activity helps balance energy intake and expenditure by influencing appetite, food cravings, and metabolism.*",
    delivery_form: "Capsules",
    directions:
      "Take one capsule in the morning, or as directed by your healthcare practitioner.",
  },

  {
    id: 7821001293955,
    title: "RegenerLife Powder (RS)",
    vendor: "Natural Factors",
    image:
      "//drhyman.com/cdn/shop/files/1900-0U_RegenerLife_BOT250W_600x600.png?v=1709867322",
    short_desc: "Optimize Mitochondrial Function",
    delivery_form: "Powder",
    directions:
      "Dissolve 1 heaping scoop (2.7 g) per day in 8 oz. of water or as directed by a health professional. Use for a minimum of 4 weeks to see beneficial effects.",
  },

  {
    id: 7865411469443,
    title: "Lemon-lime Electrolytes",
    vendor: "LYTELINE",
    image: "//drhyman.com/cdn/shop/files/pow_600x600.png?v=1709578419",
    short_desc:
      "At LyteLine, we're all about BETTER hydration. Your body will Thank You.",
    delivery_form: "Powder",
    directions:
      "Mix 1 heaping scoop (2.6 grams) with 16 oz. of water to create an isotonic electrolyte drink that rapidly replaces essential electrolytes, including magnesium. If desired, decrease the amount of water for a more concentrated mix. Take as needed, but do not exceed 8 servings in a 24-hour period.",
  },

  {
    id: 8071779156099,
    title: "Multigenics Chewable (RS)",
    vendor: "Metagenics",
    image: "//drhyman.com/cdn/shop/files/Untitled-11_600x600.png?v=1709859297",
    short_desc:
      "MultigenicsChewableis a great-tasting vitamin and mineral supplement, designed specifically for children and for adults who prefer a chewable tablet. Ouartgeous orange flavor",
    delivery_form: "Chewable Tablets",
    directions:
      "Children 3 to 7 years: Chew one tablet daily. Children over 7 and adults: Chew one tablet one to two times daily or as directed by your healthcare practitioner. Chew or crush tablets completely before swallowing. Do not swallow tablets whole.",
  },

  {
    id: 4908939214979,
    title: "BodyBio Balance Oil 16 oz. (RS)",
    vendor: "Body Bio",
    image: "//drhyman.com/cdn/shop/files/oil_600x600.png?v=1707448069",
    short_desc:
      "A daily-use blend of the most essential building blocks for cellular health designed to optimize and protect your brain and body.",
    delivery_form: "Oil",
    directions:
      "Shake well. Take 1-2 tbsp. daily, or as directed by your physician, in blender drinks or food dressings. Best with protein foods.",
  },

  {
    id: 4909015957635,
    title: "Melatonin Liquid",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_df0f7a44-1970-4847-a1c1-56889d401913_600x600.png?v=1705867919",
    short_desc:
      "Nutritionally augments the natural functioning of the pineal gland supporting the body's natural sleep cycle",
    delivery_form: "Liquid",
    directions:
      "1 dropper daily, 1/2 to 1 hour before bedtime, or as directed by a health professional.",
  },

  {
    id: 4908936560771,
    title: "Lion's Mane 30 ct.",
    vendor: "Host Defense",
    image:
      "//drhyman.com/cdn/shop/products/HostDefense-NCHE30-Lion_sManeCapsules-30ct-RightFacing-00_590x_534ecc84-0fea-4d09-9208-520178b90895_600x600.webp?v=1663268036",
    short_desc:
      "30 countHost Defense Lion's Mane uses activated, freeze-dried, Certified Organic mycelium, with a full spectrum of constituents: polysaccharides (beta glucans, arabinoxylane, glucose, xylose, galactose and mannose), glycoproteins, ergosterols, triterpenoids and other myco-nutrients,which are essential for Supporting Natural Immunity. Lion's Mane is renowned for providing support to the brain and nervous system.",
    delivery_form: "Capsules",
    directions:
      "2 capsules daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908984631427,
    title: "ProOmega Liquid (RS)",
    vendor: "Nordic Naturals",
    image: "//drhyman.com/cdn/shop/files/Untitled-34_600x600.png?v=1709671996",
    short_desc:
      "EPA and DHA are essential nutrients for growth and development throughout the human life cycle.",
    delivery_form: "Liquid",
    directions:
      "1/2 to 1 teaspoon daily, or as directed by your healthcare professional.",
  },

  {
    id: 4908936233091,
    title: "Cordychi 60 ct.",
    vendor: "Host Defense",
    image: "//drhyman.com/cdn/shop/files/Untitled-48_600x600.png?v=1709676276",
    short_desc:
      "60 ct. A uniquely balanced blend of Cordyceps and Reishi, CordyChi brings the benefit of supporting energy and oxygen uptake with cellular nutrients. Adults with activelifestyles and those who seek balance in a stressful world will breathe easy with CordyChi.",
    delivery_form: "Capsules",
    directions:
      "2 capsules daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908944294019,
    title: "Turkey Tail 60 ct.",
    vendor: "Host Defense",
    image:
      "//drhyman.com/cdn/shop/products/HostDefense-NCTV60-TurkeyTailCapsules-60ct-RightFacing-00_590x_26844402-3c95-486b-a37f-29c8ee2be797_600x600.webp?v=1663271596",
    short_desc:
      "Turkey Tail shows much promise in supporting the immune system with its protein-bound and unique polysaccharides and is anexcellent source of cellular nutrients.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules once per day. Can be taken with food or on an empty stomach or as recommended by your healthcare professional.",
  },

  {
    id: 7875925606531,
    title: "Annatto-E™ GG",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/ANTEG6_annatto-e-gg_100cc_watermark_product-image_medium_c3d543ac-69a7-4983-8ba9-4fa04409a360_600x600.png?v=1709922341",
    short_desc:
      "Annatto-ETM GG combines tocotrienols and geranylgeraniol, two powerful ingredients that support healthy aging, cellular energy generation and maintenance of muscle and bone mass during the aging process.*",
    delivery_form: "Softgel Capsules",
    directions:
      "Take 1 softgel per day or as directed by your health-care practitioner.",
  },

  {
    id: 4908936003715,
    title: "Stamets 7 Capsules - 30 ct.",
    vendor: "Host Defense",
    image:
      "//drhyman.com/cdn/shop/products/HostDefense-NCS730-Stamets7Capsules-30ct-RightFacing-00_590x_640d2f37-d17e-44c9-9946-bed6c02f556f_600x600.webp?v=1663270960",
    short_desc:
      "30 ct.Paul Stamets designed this blend of seven mushroom species to support general immunity. Many use Stamets 7 as a functional food multiple for maintaining peak performance and health.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 2 capsules once per day. Can be taken with food or on an empty stomach or as recommended by your healthcare professional.",
  },

  {
    id: 5137945034883,
    title: "SBI Protect",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/266-60-SBIProtect_600x600.png?v=1705958439",
    short_desc:
      "SBI Protectis the only purified, dairy-free source of immunoglobulin G (IgG) available as a dietary supplement. Pure IgG helps to maintain a healthy intestinal immune system by binding a broad ranges of microbes and toxins within the gut lumen.",
    delivery_form: "Powder",
    directions:
      "1 scoop (2.5 grams) in 4 ounces of water or the beverage of your choice 2 times daily or as recommended by your health care professional.",
  },

  {
    id: 6611445284995,
    title: "SBI Protect capsules",
    vendor: "Ortho Molecular",
    image: "//drhyman.com/cdn/shop/files/SBIcaps_600x600.png?v=1706025453",
    short_desc:
      "SBI Protectis the only purified, dairy-free source of immunoglobulin G (IgG) available as a dietary supplement. Pure IgG helps to maintain a healthy intestinal immune system by binding a broad ranges of microbes and toxins within the gut lumen.",
    delivery_form: "Capsules",
    directions:
      "4 capsules per day or as recommended by your health care professional.",
  },

  {
    id: 4909019496579,
    title: "Dentalcidin™LS - Liposomal Oral Care Solution",
    vendor: "Bio-Botanical Research",
    image:
      "//drhyman.com/cdn/shop/products/Dentalcidin-LS_600x600.jpg?v=1709945744",
    short_desc:
      "Assists in Removing Biofilms and Plaque for Healthy Teeth and Gums*",
    delivery_form: "Liquid",
    directions: "Swish with 2 pumps for 1-2 minutes, then spit.",
  },

  {
    id: 5037687275651,
    title: "Coconut Charcoal (RS)",
    vendor: "Bulletproof Digital",
    image: "//drhyman.com/cdn/shop/files/coconut_600x600.png?v=1708302902",
    short_desc: "Helps remove heavy metals, bacteria and gas.",
    delivery_form: "Capsules",
    directions: "",
  },

  {
    id: 6645053456515,
    title: "ImmunoG PRP Powder Chocolate (DC)",
    vendor: "NuMedica",
    image:
      "//drhyman.com/cdn/shop/files/NM525_2048x2048_b81a9fa8-d7ac-49be-aab6-df1512c3bbd5_600x600.webp?v=1709921959",
    short_desc:
      "ImmunoG PRP™ is a pure bovine colostrum and is collected within the first 24 hours after birthing. It is a natural whole food that provides a rich source of IgG and PRPs (Proline-Rich Polypeptides). It also supplies protein, immune factors, growth factors, vitamins and minerals to ensure health and vitality naturally.",
    delivery_form: "Powder",
    directions: "",
  },

  {
    id: 4908993249411,
    title: "MyCommunity 120ct",
    vendor: "Host Defense",
    image: "//drhyman.com/cdn/shop/files/Untitled-47_600x600.png?v=1709676118",
    short_desc:
      "Host Defense MyCommunity uses Certified Organic mycelium and fruitbodies, with a full spectrum of constituents: polysaccharides (beta glucans, arabinoxylane, glucose, xylose, galactose and cordycepic acid), glycoproteins, ergosterols, triterpenoids and other myconutrients, which are essential for Supporting Natural Immunity.",
    delivery_form: "Capsules",
    directions:
      "2 capsules daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4909016481923,
    title: "Eat Fat, Get Thin Book",
    vendor: "Hyman Enterprises",
    image:
      "//drhyman.com/cdn/shop/products/eatfatgetthin_front_2_600x600.jpg?v=1587241632",
    short_desc:
      "A revolutionary new diet program based on the latest science showing the importance of fat in weight loss and overall health, from # 1 bestselling author Dr. Mark Hyman.&quot;Dr. Mark Hyman has helped thousands of people lose weight and lead happier, more energetic lives. His powerful insights on the dynamics of dietary fat will change the way you think about everyday eating, and show you how easy it is to enjoy a healthier, more satisfying diet.&quot;―Toby Cosgrove,CEO of Cleveland Clinic",
    delivery_form: "Book",
    directions: "",
  },

  {
    id: 4908918243459,
    title: "PS 100 - 120s (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_666cb37d-fad2-4a1c-afb4-f6c5049298b7_600x600.png?v=1706584479",
    short_desc:
      "Phosphatidylserine (PS), also known as the &quot;brain nutrient&quot; promotes cognitive function, emotional well-being and behavioral performance by supporting cell membrane composition. PS 100 may help support daily performance that involve memory related tasks.‡",
    delivery_form: "Capsules",
    directions:
      "3 capsules per day, in divided doses, with meals or as directed by your healthcare practitioner.",
  },

  {
    id: 4908919816323,
    title: "Artemis Plus (RS)",
    vendor: "Natura",
    image:
      "//drhyman.com/cdn/shop/products/Artemis_Plus__20771.1634492152_600x600.png?v=1643057859",
    short_desc:
      "Artemis Plus encourages the excretion of unhealthy cellular debris, restores cell nutrient exchange and uptake, and inhibits the proliferation and viability of certain organisms.",
    delivery_form: "Capsules",
    directions: "2 capsules as directed by your healthcare practitioner.",
  },

  {
    id: 7896307826819,
    title: "Circadian PM",
    vendor: "Researched Nutritionals",
    image: "//drhyman.com/cdn/shop/files/circ_600x600.png?v=1709577963",
    short_desc:
      "A multifaceted approach is needed to support falling asleep faster, staying asleep longer, and achieving higher quality, more restful sleep. Circadian PM™ utilizes a blend of 10 ingredients, promoting multiple mechanisms of action to nurture healthy sleep.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 3 capsules once daily before bed, or as directed by your healthcare professional.",
  },

  {
    id: 4908939018371,
    title: "PC (Phosphatidyl choline) 8 oz.",
    vendor: "Body Bio",
    image: "//drhyman.com/cdn/shop/files/pc_phos_600x600.png?v=1707448464",
    short_desc:
      "BodyBio PC combines four forms of pure phospholipids for quick absorption to rebuild every cell in your body, benefitting every key system.",
    delivery_form: "Liquid",
    directions:
      "To enhance and rebuild the integrity of your cells, simply take 2 softgels or ½ tsp daily. If you are struggling with a health concern, we recommend working with a healthcare practitioner that is knowledgeable in lipid replacement therapy. May be taken on an empty stomach or with a meal as desired.",
  },

  {
    id: 7994887798915,
    title: "BPC + PEA 500",
    vendor: "Healthgevity",
    image:
      "//drhyman.com/cdn/shop/files/BPC_PEA-500-_30-Capsules_-healthgevity-1658983746_1080x_f0b21ac6-e3bb-4eff-b772-e8ce14c5eabb_600x600.webp?v=1701703059",
    short_desc:
      "An ideal formula for anyone looking to support full body repair and regeneration.",
    delivery_form: "Capsules",
    directions:
      "Take one capsule a day or use as directed by your healthcare practitioner.",
  },

  {
    id: 4908980142211,
    title: "Carb-Lipo Control™ (formerly ProtectZyme™)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/PTZ060_Carb-Lipo-Control_150cc_watermark_product-image_medium_32dd393d-4ef2-4191-9185-5ce554c16792_600x600.png?v=1725972951",
    short_desc:
      "Carb-Lipo Control™ (formerly ProtectZyme™) is a unique combination of digestive support compounds designed to minimize the adverse effects from occasional consumption of gluten, dairy, soy, and egg proteins in individuals who are sensitive to them.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules per day with a meal or as directed by a healthcare professional.",
  },

  {
    id: 4908957401219,
    title: "Crypto-Plus (RS)",
    vendor: "Researched Nutritionals",
    image: "//drhyman.com/cdn/shop/files/Crypto-Plus_600x600.png?v=1709912647",
    short_desc:
      "Balanced Organ Support – developed to promote healing and multi-organ support",
    delivery_form: "Liquid",
    directions:
      "3-20 drops per day taken away from meals and added to 1-3 ounces of water, or as recommended by your healthcare professional.",
  },

  {
    id: 5079900618883,
    title: "CardioLux HDL",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/eyJwYXRoIjoibWV0YWdlbmljc1wvZmlsZVwvbTRMRnRXbjlOcjV4QUFZY0VoZUEucG5nIn0_metagenics__6Kqh-3-eLMI4lmfZqghY03pPTLfgTeaxWXMjdPbkbs_600x600.png?v=1742499324",
    short_desc: "Targeted support for HDL function and cardiovascular health",
    delivery_form: "Capsules",
    directions:
      "Take two capsules twice daily with food or as directed by your healthcare practitioner.",
  },

  {
    id: 5140213137539,
    title: "ProbioMax DF 30 Capsules",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011732_probiomax-df-30-capsules_600x600.png?v=1742316869",
    short_desc:
      "100 billion CFUs per capsule, four-strain probiotic sealed to protect against heat, moisture, air and low pH. These live organisms are designed and extensively tested to have a more targeted release in the small intestines and help support proper gut flora and function.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule with water daily, or as directed by your healthcare professional.",
  },

  {
    id: 4908976603267,
    title: "Medi-Clay-FX",
    vendor: "Premier Research Labs",
    image:
      "//drhyman.com/cdn/shop/files/prl52839_1024x1024_f46b9e79-ae9e-443f-9552-b143b9c5c5f6_600x600.webp?v=1709913180",
    short_desc:
      "Medi-Clay-FX™ provides a rare source of calcium bentonite clay that promotes whole body detoxification.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule, 2 times daily with 4 oz. or more of purified water or as directed by a health professional.",
  },

  {
    id: 5023522062467,
    title: "Heartburn Advantage™",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/uigfg4btwqzen7bprfrt_600x600.webp?v=1705619784",
    short_desc:
      "Heartburn Advantage's multi-mechanistic approach combines several clinically studied ingredients at researched doses to help reduce occasional heartburn, bloating, nausea, and epigastric discomfort. The ingredients in Heartburn Advantage support the natural protective mechanisms in the gastrointestinal tract without interfering in the normal digestive process.",
    delivery_form: "Capsules",
    directions:
      "Adults take 1 capsule in the morning after food and 1 capsule in the evening aftr food or as recommended by healthcare professional. Do not exceed recommended dose.",
  },

  {
    id: 4908994691203,
    title: "SAMe 90ct",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/SAMewithVitaminsB-6_B-12and5-MTHF90_600x600.png?v=1709912927",
    short_desc:
      "SAMe is a naturally occurring metabolite found in the human body as well as in plant and animal foods. It is the most active of all methyl donors and has been compared to ATP in its importance for the body. SAMe is naturally synthesized in humans from the amino acid methionine in the presence of the cofactors B12 and folate.",
    delivery_form: "Capsules",
    directions:
      "Take 1 tablet one to two times a day, preferably on an empty stomach or as directed by your health care practitioner",
  },

  {
    id: 4908811518083,
    title: "NSK-SD (Nattokinase) 100 mg",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_de53d947-e595-420e-81cf-9e938e6073de_600x600.png?v=1705971711",
    short_desc:
      "An enzyme isolated from Japanese natto, this helps maintain natural clotting and blood flow in the body. Promotes healthy blood vessel and cardiovascular health.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "1 capsule, 2 times daily, 12 hours apart, with or between meals.",
  },

  {
    id: 7875931996291,
    title: "D-Hist Jr",
    vendor: "Ortho Molecular",
    image: "//drhyman.com/cdn/shop/files/855-DHistJr_600x600.png?v=1705958184",
    short_desc:
      "D-Hist Jr.™ promotes healthy nasal and sinus passages for children with elevated histamine and respiratory irritation.",
    delivery_form: "Chewable Tablets",
    directions:
      "1 tablet as needed or as recommended by your health care professional.",
  },

  {
    id: 4908938231939,
    title: "MycoShield Spray - Cinnamon 2 oz.(RS)",
    vendor: "Host Defense",
    image: "//drhyman.com/cdn/shop/files/Untitled-45_600x600.png?v=1709675752",
    short_desc:
      "Cinnamon 2 oz.Host Defense MycoShield spray combines five powerful polypore mushroom species: Agarikon, Red Reishi, Chaga, Birch Polypore and Turkey Tail. These five mushrooms provide a unique “shield” of immune support, available in a perfect traveler's size.",
    delivery_form: "Spray",
    directions:
      "3 sprays daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 7822605615235,
    title: "ProDHA 1000",
    vendor: "Nordic Naturals",
    image:
      "//drhyman.com/cdn/shop/products/ProDHA1000_600x600.png?v=1674069958",
    short_desc:
      "Intensity DHA Formula for Neurological Health, Mood &  Memory - Non-GMO",
    delivery_form: "Softgel Capsules",
    directions:
      "Two soft gels daily, with food, or as directed by your health care professional or pharmacist.",
  },

  {
    id: 4908872532099,
    title: "Lithium (orotate), 5mg 90ct (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_367ba556-c8d9-4d52-aa87-ab99822e0c21_600x600.png?v=1705865725",
    short_desc:
      "Supports healthy mood, emotional wellness, behavior and memory.",
    delivery_form: "Capsules",
    directions:
      "1 capsule per day, with a meal or as directed by a healthcare practitioner",
  },

  {
    id: 5080349147267,
    title: "Ultra Binder Stick Packs",
    vendor: "Quicksilver Scientific",
    image:
      "//drhyman.com/cdn/shop/products/Product-Pictures_Ultra-Binder_Stick-Pack-Box_062419-820x1201-ded28c6-e1562696026669_600x600.png?v=1593535616",
    short_desc:
      "Ultra Binder stick packs are Ultra-Binder in a convenient, travel-friendly packaging. This comprehensive blend of natural materials can effectively bind the wide array of environmental contaminants we encounter in everyday life. This allows our body to detoxify safely and naturally.",
    delivery_form: "Packet",
    directions:
      "1 stick pack into 8 ounces of water once daily or as directed by healthcare professional. Take 30 minutes before or 2 hours after meals or medications. If pregnant. consult physician before use.",
  },

  {
    id: 5185538523267,
    title: "MSM Powder (RD)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_8b26a8f9-db6b-4dd7-ab3e-74bdb8bafce0_600x600.png?v=1705967820",
    short_desc:
      "Unsweetened, unflavored powder to support joint, immune, and respiratory health.",
    delivery_form: "Powder",
    directions: "1 scoop, 1-2 tims daily, in a beverage with meals.",
  },

  {
    id: 7707609301123,
    title: "Liposomal Glutathione",
    vendor: "Body Bio",
    image:
      "//drhyman.com/cdn/shop/products/LG60-Front_400x_84c18f20-6a48-48de-b2c7-151efe7c6622_600x600.webp?v=1654803117",
    short_desc:
      "Levels of glutathione decrease as we age, glutathione is the body's most powerful antioxidant protecting us from environmental toxins and pollutants.",
    delivery_form: "Capsules",
    directions:
      "1 capsule a day with or without food. Or as directed by your health care provider.",
  },

  {
    id: 4908974637187,
    title: "Serrapeptase Pro (Formally SerraGold) (RS)",
    vendor: "Enzymedica",
    image:
      "//drhyman.com/cdn/shop/files/0011196_serrapeptase-pro-120-capsules_600x600.png?v=1730921600",
    short_desc:
      "Serrapeptase Pro is for the support of systemic health and stress.",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule daily on an empty stomach, one hour before or two hours after a meal.",
  },

  {
    id: 4908780880003,
    title: "Alpha-Ketoglutaric acid (RS)",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/V135-06_hires_web_600x600.png?v=1709913004",
    short_desc:
      "Alpha-ketoglutaric acid (AKG) is a ketone derivative of the organic compound glutaric acid. It is important for the proper metabolism of all essential amino acids and the transfer of cellular energy in the citric acid, or Krebs cycle. Individuals with high protein intake or gastrointestinal microbiota imbalance may benefit from supplemental AKG to help balance ammonia levels and support tissue health.†",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement take one capsule daily or as directed by a physician.",
  },

  {
    id: 5065967206531,
    title: "Argentyn 23 Bio-Active Silver Hydrosol Liquid 4 oz.",
    vendor: "Natural Immunogenics",
    image:
      "//drhyman.com/cdn/shop/files/71RyaET9GWL._AC_SL1500_600x600.jpg?v=1709138019",
    short_desc:
      "Argentyn 23 in the 4 oz. liquid form is a professional grade of silver hydrosol representing the ultimate refinement and most significant breakthrough in colloidal technology, having consistently produced the smallest particles ever seen in colloidal silver products, with the most unique charge attributes (98% positively charged).",
    delivery_form: "Liquid",
    directions:
      "Adults: 1 teaspoon, hold under tongue for 30 seconds, then swallow. Children 4 years and older: 1/2 teaspoon or drink or as directed by a health professional.Maintenance: Once daily. Immune-Building: 3 times daily. Long-Term Immune Support: 5 times daily. Short-Term Immune Support: 7 times daily.",
  },

  {
    id: 4908971458691,
    title: "Pure PC 4 oz. (RS)",
    vendor: "Quicksilver Scientific",
    image:
      "//drhyman.com/cdn/shop/files/PPCBackgroundRemoved2_600x600.png?v=1709922098",
    short_desc:
      "Phosphatidylcholine (PC) is the most predominant phospholipid building block of animal and plant cell membranes and it's vital to the structure of circulating lipoproteins. It's an integral component for both membrane integrity and structure and helps detox heavy metals from the body.",
    delivery_form: "Liquid",
    directions:
      "Take 1 teaspoon by mouth twice daily. Hold in mouth 30 seconds before swallowing. Repeat to desired dosage or as directed by a healthcare professional. Take on an empty stomach, at least 10 minutes before meals",
  },

  {
    id: 4908993511555,
    title: "A-RMS-4B (RS)",
    vendor: "Byron White Formulas",
    image:
      "//drhyman.com/cdn/shop/products/a-rms_4b_thumbnail_600x600.jpg?v=1587241414",
    short_desc:
      "Designed to support immune system and has herbs to provide strong antioxidant, antiviral, antibacterial and anti-parasitic effect.",
    delivery_form: "Liquid",
    directions:
      "Acute: start with 3 drops 2 times daily. Titrate up to 20 drop 2 times daily as tolerated and needed. (If no other chronic infections in this family are present, otherwise follow dosing below.) Chronic: 1-2 drops 2 times daily, 2- 7 days a week and titrate up as tolerated/needed. Support formulas: Begin with A-INFLAM and DETOX 2 to lower inflammation and toxicity. Use NT-DETOX for neurological symptoms and BT-DETOX for lymph support and toxicity.",
  },

  {
    id: 6754803548291,
    title: "Hi-Po Emulsi-A (RS)",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/Hi-PO_600x600.png?v=1709925753",
    short_desc:
      "Hi-Po Emulsi-A™ is a high-potency formula that delivers concentrated vitamin A in a convenient liquid form. Just one drop of this unique product provides 5,000 IU of vitamin A, as retinol palmitate (1,500 mcg retinol activity equivalents [RAE]), allowing for flexibility in titration and ease of use. Vitamin A plays a critical role in immune function and is well known for promoting eye health, thyroid function, and red blood cell function.",
    delivery_form: "Liquid",
    directions:
      "Take 1 drop (5,000 IU) per day or as directed by your health-care practitioner. &lt;P&gt; Not for long term use.",
  },

  {
    id: 4908934758531,
    title: "Biocidin Liquid - Broad-Spectrum Liquid Formula",
    vendor: "Bio-Botanical Research",
    image:
      "//drhyman.com/cdn/shop/files/Biocidin_Liquid_46ca11d7-3bae-47a0-a038-9a4bd95776de_600x600.png?v=1709944613",
    short_desc:
      "Advanced Formula Biocidin is a potent broad-spectrum combination of botanicals for systemic use and for addressing the gastrointestinal tract.",
    delivery_form: "Liquid",
    directions:
      "Begin with 1 drop and gradually increase up to 5 drops 3 times per day or as directed by your healthcare professional. Children may use 1 drop per 10 lbs. of body weight per day, divided into 2 doses.",
  },

  {
    id: 4909001048195,
    title: "MitoThera Capsules",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/MTOC_hires_web_600x600.png?v=1709913431",
    short_desc:
      "This multivitamin and mineral supplement supports energy metabolism, helps those with chronic illness and the elderly who need specialized nutritional support. Helps the mitochondria with energy production and overall function in the brain, liver, heart, muscles, endocrine glands and other body tissues.120 CT Capsules",
    delivery_form: "Capsules",
    directions:
      "4 capsules daily with food or as directed by a healthcare professional.",
  },

  {
    id: 7925236596867,
    title: "FemGuard + Balance",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/FGB120_femguard-balance_250cc_watermark_product-image_64854961-debb-41f5-9d8c-7feaf40c00cd_600x600.png?v=1709860104",
    short_desc:
      "FemGuard + Balance™ supports hormonal balancing by providing vitex, polygonum, and black cohosh, along with diindolymethane (DIM) and chrysin to help promote beneficial estrogen aromatase activity.",
    delivery_form: "Capsules",
    directions:
      "Take 4 capsules per day or as directed by your health-care practitioner",
  },

  {
    id: 7992435671171,
    title: "GI Revive capsules",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/grv210_gi-revive_500cc_ipsos-badge_600x600.png?v=1741628347",
    short_desc:
      "GI Revive offers comprehensive support for optimum gastrointestinal health and function.",
    delivery_form: "Capsules",
    directions:
      "Take 7 capsules per day or as directed by your health-care practitioner.",
  },

  {
    id: 4908889178243,
    title: "Cytokine Balance 30 Capsules",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011573_cytokine-balance-30-capsules_600x600.png?v=1742237137",
    short_desc:
      "Cytokine Balance is an exclusive formula designed to activate the Nrf2 genetic pathway.",
    delivery_form: "Capsules",
    directions:
      "Take one to two capsules daily, or as directed by your healthcare professional.",
  },

  {
    id: 4908935446659,
    title: "RelaxMax Unflavored powder",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011754_relaxmax-unflavored-60-servings_600x600.png?v=1742327676",
    short_desc:
      "RelaxMax aims to promote a calm, relaxed, well-balanced emotional and physiological state.",
    delivery_form: "Powder",
    directions:
      "Dissolve one scoop of RelaxMax into 6 fl ounces of cool, purewater. Drink one to two times daily, or as directed by your healthcare professional.",
  },

  {
    id: 7861945630851,
    title: "RegenerLife Capsules (RS)",
    vendor: "Natural Factors",
    image: "//drhyman.com/cdn/shop/files/1901U_r0_600x600.png?v=1706131042",
    short_desc:
      "RegenerLife is formulated to optimize mitochondrial function with powerful, targeted nutritional compounds.",
    delivery_form: "Capsules",
    directions:
      "2 vegetarian capsules twice per day or as directed by a health professional.",
  },

  {
    id: 5038202650755,
    title: "Buffered Ascorbic Acid Powder (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_0c841611-167e-414e-b03f-1e873bcf4bb3_600x600.png?v=1705621463",
    short_desc:
      "Buffered ascorbic acid combines calcium ascorbate, magnesium ascorbate, and potassium ascorbate to create a neutral pH vitamin C.",
    delivery_form: "Powder",
    directions:
      "1 rounded scoop (2.2g) daily or as directed by a health professional.",
  },

  {
    id: 8060252520579,
    title: "WeNatal HER (pouch)",
    vendor: "WeNatal",
    image: "//drhyman.com/cdn/shop/files/wenatal_600x600.png?v=1709159971",
    short_desc:
      "This prenatal supplement for women contains 24 essential nutrients in their most absorbable forms and at the right doses. Includes clinically-proven ingredients (often left out in other prenatals) that support women from preconception, through pregnancy to breastfeeding and beyond.",
    delivery_form: "Capsules",
    directions:
      "3 capsules a day. Nutrient density of 6-8 capsules packed into just 3 a day.",
  },

  {
    id: 4908921159811,
    title: "Vital Adapt 4 oz. (RS)",
    vendor: "Natura",
    image: "//drhyman.com/cdn/shop/files/Untitled-49_600x600.png?v=1709676438",
    short_desc:
      "Vital Adapt is a nourishing broad spectrum herbal tonic designed to optimize the body's natural resistance and adaptation to stressful influences, while promoting health, longevity and total well-being.",
    delivery_form: "Liquid",
    directions:
      "2 ml (2.5 drops), 2-3x daily or as directed by your healthcare practitioner.",
  },

  {
    id: 4908980830339,
    title: "OSAplex MK-7 60 ct.",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011716_osaplex-mk-7-60-packets_600x600.png?v=1742313969",
    short_desc:
      "OSAplex MK-7™ is a comprehensive, convenient, and cost-effective dietary supplement that supports healthy bones, cartilage, and ligaments.",
    delivery_form: "Capsules",
    directions:
      "Consume the contents of one packet with a meal, one to two times daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 4908949962883,
    title: "Triphala 500 mg (RS)",
    vendor: "Banyan Botanicals",
    image:
      "//drhyman.com/cdn/shop/files/a7c1e6e2-4766-468e-92ad-f941f1850413-358-358_600x600.png?v=1721834261",
    short_desc:
      "Triphala is recommended and used more than any other Ayurvedic herbal formulation. Popular for its unique ability to gently cleanse and detoxify the system while simultaneously replenishing and nourishing it, this traditional formula supports the proper functions of the digestive, circulatory, respiratory and genitourinary systems.",
    delivery_form: "Tablets",
    directions:
      "For gentle daily cleansing, take 1-4 tabletson an empty stomach at bedtime or upon waking, or asdirected by your health practitioner.",
  },

  {
    id: 7712017186947,
    title: "GentleDerm",
    vendor: "Algonot",
    image:
      "//drhyman.com/cdn/shop/products/design-f29178e2-9421-47a6-baa0-d37b23e2ebac_600x600.png?v=1655835250",
    short_desc:
      "GentleDerm – A unique, antioxidant lotion containing a novel flavonoid, tetramethoxyflavon, for skin sensitivities.GentleDerm is a natural lotion that hydrates, nourishes, and soothes. GentleDerm uses an exclusive combination of ingredients for skin sensitivities. Unique to the AlgonotTM family of formulations is olive pomace oil and flavonoids.",
    delivery_form: "Cream",
    directions: "Apply liberally to your skin as often as needed",
  },

  {
    id: 5140229128323,
    title: "XenoProtX",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011783_xenoprotx-120-capsules_600x600.png?v=1742327757",
    short_desc: "",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules one to two times daily or as recommended by your health professional",
  },

  {
    id: 4908919095427,
    title: "Caprylic Acid 240s",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image1_584fd21b-9dfb-49f2-88fa-1730fbfcecfb_600x600.png?v=1705621688",
    short_desc:
      "Gradual release, buffered caprylic acid, providing optimal support for healthy candida balance.",
    delivery_form: "Capsules",
    directions:
      "2 capsules, 30 minutes before each meal, or as directed by a health professional.",
  },

  {
    id: 6572168347779,
    title: "MycoPul",
    vendor: "Researched Nutritionals",
    image: "//drhyman.com/cdn/shop/files/MycoPul_600x600.png?v=1708311305",
    short_desc: "Exceptionally Pure, Vigorous Mycotoxin Binder",
    delivery_form: "Softgel Capsules",
    directions:
      "As a dietary supplement, take 1 capsule once daily on an empty stomach (at least 2 hours after eating or 1 hour before eating) or as directed by your healthcare professional. It is recommended to take a multi-mineral such as Core Minerals™ at the opposite time of day while using MycoPul.",
  },

  {
    id: 5140712685699,
    title: "Cogniquil",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011560_cogniquil-60-capsules_600x600.png?v=1742236310",
    short_desc:
      "Cogniquil provides a unique blend of patented, stimulant-free, non-habit-forming ingredients. Methylcobalamin supports cognition and contributes to healthy energy metabolism; magnesium L-threonate supplies highly bioavailable magnesium to the brain, which is vital to cognitive function; and theacrine promotes mental and physical energy, focus, and motivation.*",
    delivery_form: "Capsules",
    directions:
      "Begin with 2 capsules daily to determine response. Increase to a maximum of 2 capsules twice daily, or as directed by your healthcare practitioner.",
  },

  {
    id: 7707577516163,
    title: "Neem",
    vendor: "Banyan Botanicals",
    image: "//drhyman.com/cdn/shop/files/neem_600x600.webp?v=1709579926",
    short_desc:
      "Neem is widely used in Ayurveda because of its effectiveness in dealing with nearly all types of pitta and kapha imbalances.",
    delivery_form: "Tablets",
    directions:
      "Take 1-2 tablets, once or twice daily, or as directed by your health practitioner. Not for use by pregnant women.",
  },

  {
    id: 4908986466435,
    title: "Stevia- Liquid Extract (RS)",
    vendor: "Protocol for Life Balance",
    image:
      "//drhyman.com/cdn/shop/files/6ff824d7-b1c7-43ad-97c1-d632d041b364-2000-2000_600x600.png?v=1704810921",
    short_desc:
      "Protocol for Life Balance Stevia Extract utilizes Glucosyl Stevioside, an enzymatically-enhanced Stevia leaf (Stevia rebaudiana) extract with improved taste and sweetening properties. Our natural proprietary processing method improves taste and sweetness",
    delivery_form: "Liquid",
    directions:
      "Use 1 to 4 drops as desired daily. Sweeten to taste. Sedimentation may occur. Shake well before using.",
  },

  {
    id: 4908766068867,
    title: "Pyridoxine P5P 275mg (RS)",
    vendor: "Allergy Research Group",
    image: "//drhyman.com/cdn/shop/files/p5p_600x600.png?v=1708302222",
    short_desc:
      "This formula is a combination of pyridoxine hydrochloride and pyridoxal-5-phosphate (P-5-P, the coenzyme or &quot;activated&quot; form of B6). Supplementation with vitamin B6 as P5P can be helpful for those unable to produce it efficiently from pyridoxine in the liver.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, 1 capsule daily with a meal, or as directed by a healthcare practitioner.",
  },

  {
    id: 4908949078147,
    title: "D-Mannose powder 100 grams (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image85_b30465c1-f9ca-4435-b7d7-9184e1c2e86b_600x600.png?v=1705713982",
    short_desc:
      "d-Mannose, the active urinary tract support ingredient of cranberries, provides concentrated support for proper urinary function.",
    delivery_form: "Powder",
    directions: "1 scoop, 3 times daily, mixed with water or between meals.",
  },

  {
    id: 8015116304515,
    title: "Wonderfeel Youngr NMN",
    vendor: "Wonderfeel",
    image:
      "//drhyman.com/cdn/shop/files/nmn_d625973f-d970-4d2e-9bab-f9f8d0c1c661_600x600.png?v=1709576445",
    short_desc:
      "Wonderfeel Youngr NMN formula is engineered by Professor Andrew Salzman, a Harvard MD, and it includes 900mg NMN per day, a dose that is backed by the latest and largest human clinical trial to date.  In addition to 900mg NMN per serving, the Youngr™ formula contains the following ingredients that work synergistically with NMN inside the cell and activates enzymes that are critical in cell survival, senescence, proliferation, and cell metabolism. 4 mg of Ergothioneine (Ergo) - Dubbed the “longevity vitamin”, it's the most effectual element in mushrooms, notably in porcinis and lion's manes. A unique therapeutic agent, ergo accumulates in the body wherever it's needed. Continued scientific evidence suggests it has tremendous cognitive benefits and prevents our brains from aging. 50 mg of Olive fruit Extract (40% hydroxytyrosol)- A potent polyphenol with metabolistic, anti-inflammatory and antitumor properties. This compound is derived from the leaves and fruit of the olive plant, and is among the strongest antioxidants, 10X more than green tea and 2X more than CoQ10. It also has neuroprotective benefits. 100 mg of Trans Resveratrol - Working jointly with NMN as a sirtuin activator, it's designed to boost mitochondrial activity, and allay metabolic disease. Studies have shown that resveratrol at a lower dose acts as an anti-apoptotic agent, thus increasing protein production for cell survival.20 mcg Vitamin D3, also known as cholecalciferol, is a type of vitamin D that's actually made by your skin when exposed to sunlight. A crucial vitamin that most people lack, D3 contributes to many important functions in the body. It plays a role in insulin production and immune function, as well as generating stem cells in the gut, one of the foundations of good health.",
    delivery_form: "Capsules",
    directions: "Take two capsules every day in the morning.",
  },

  {
    id: 8003008594051,
    title: "PurO3 Ozonated Olive Oil",
    vendor: "PurO3",
    image: "//drhyman.com/cdn/shop/files/pur03_600x600.png?v=1709576662",
    short_desc:
      "PurO3 Ozonated Olive Oil combines organic, cold pressed, extra virgin olive oil and ozone, giving you an oxygen-rich, soothing salve.",
    delivery_form: "Oil",
    directions:
      "Apply a good dab to the affected area two to three times daily or as needed. When the salve is applied it will melt and absorb into your skin. To speed up the melting process, rub the oil into the affected area.",
  },

  {
    id: 6728856731779,
    title: "Prostect (RS)",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/products/Prostect_600x600.png?v=1709922407",
    short_desc:
      "Prostect™ is uniquely formulated to support a healthy prostate and urinary function in men.*",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules per day with a meal or as directed by your health-care practitioner.",
  },

  {
    id: 4908981813379,
    title: "A-Inflam (RS)",
    vendor: "Byron White Formulas",
    image:
      "//drhyman.com/cdn/shop/products/screen_shot_2017-05-25_at_9.29.09_am_600x600.png?v=1587241300",
    short_desc: "Designed to decrease inflammation and cytokine storms.",
    delivery_form: "Liquid",
    directions:
      "Acute: 1-2 droppers, 2-3 times daily.Chronic: start low 1-2 drops 2 x a day and increasing as needed up to 20 drops 2-3 times daily.Support: To handle the dumping of toxins please use DETOX 2, and NT or BT DETOX for neurological or lymph involvement.Topical use: Patients and practitioners report that A-INFLAM is also helpful with injuries internally and externally.",
  },

  {
    id: 7847053557891,
    title: "Naked Goat - Goat Whey Protein Powder",
    vendor: "Naked Goat",
    image:
      "//drhyman.com/cdn/shop/products/best_goay_whey_protein_powder_1024x1024_4deceff4-8618-4948-853a-c4381d777fd3_600x600.webp?v=1676576153",
    short_desc:
      "Naked Goat has only one ingredient: Goat whey protein sourced from pasture-raised goats on small-herd Wisconsin dairies. We use cold processing to create non-denatured goat whey so you get clean protein loaded with essential amino acids and other beneficial nutrients.Naked Goat is free of additives and artificial sweeteners. We are committed to shortening the steps between our farms and you. Don't let the supplement industry fool you; additives are for their bottom line, not your health.Naked Nutrition is trusted by Dr. Mark Hyman. Click the button below to purchase the Naked Nutrition website.",
    delivery_form: "Powder",
    directions:
      "Mix two scoops into 6-10oz of milk, water or your favorite beverage. Add fruits and vegetables for taste as Naked Whey is unflavored.",
  },

  {
    id: 5160777220227,
    title: "Lithium (orotate), 5mg 180ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image88_deeaee8e-d1dd-4987-ab8f-7e5dff5fe450_600x600.png?v=1705865798",
    short_desc:
      "Lithium is designed to support healthy mental function, including mood, emotion, memory and behavior. Lithium may support healthy brain receptor function and brain signaling cascades to maintain healthy mental function.*",
    delivery_form: "Capsules",
    directions:
      "1 capsule per day, with a meal or as directed by a healthcare practitione",
  },

  {
    id: 5134967668867,
    title: "TMG 100 Vegetarian Capsules (RS)",
    vendor: "Allergy Research Group",
    image: "//drhyman.com/cdn/shop/files/tmg_600x600.png?v=1708302328",
    short_desc: "Protects cells under stress and as a methyl-group donor.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, 1 capsule one to three times daily before meals, or as directed by a healthcare practitioner.",
  },

  {
    id: 4908895568003,
    title: "Super Echinacea 4 oz (RS)",
    vendor: "Herb Pharm",
    image:
      "//drhyman.com/cdn/shop/files/6f4aa688-680c-4ece-b99b-b78d1be4f3a0-358-358_600x600.png?v=1704811090",
    short_desc:
      "Super Echinacea supports healthy function of the immune system and uses only freshly harvested Echinacea purpurea plants which are Certified Organically Cultivated on the manufacturer's own farm without the use of chemical fertilizers, pesticides or herbicides, and are never fumigated or irradiated.",
    delivery_form: "Liquid",
    directions:
      "Shake well before using. Dilute drops in 2 oz. of water or juice. For standard use, take 1 full squeeze of thedropper bulb (0.7 ml), 2 to 5 times per day.",
  },

  {
    id: 7822428635267,
    title: "Ashwagandha Standardized (Vitality Tonic) (RS)",
    vendor: "Integrative Therapeutics",
    image: "//drhyman.com/cdn/shop/products/image005_600x600.png?v=1673981544",
    short_desc: "Reduces Stress",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule, two to three times daily, preferably with food or water.",
  },

  {
    id: 7819474796675,
    title: "CitraNox",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/720-120-CitraNOX_600x600.png?v=1705958058",
    short_desc:
      "CitraNOX provides a powerful formula for those seeking to optimize several mechanisms of cardiovascular health.",
    delivery_form: "Capsules",
    directions:
      "Take 4 capsules per day or as recommended by your health care professional.",
  },

  {
    id: 7766794174595,
    title: "Biocidin Capsules - Broad-Spectrum Liquid Capsule",
    vendor: "Bio-Botanical Research",
    image:
      "//drhyman.com/cdn/shop/files/Biocidin_Capsules_600x600.png?v=1705081340",
    short_desc: "SUPPORTS MICROBIAL BALANCE* DISRUPTS BIOFILMS*",
    delivery_form: "Softgel Capsules",
    directions:
      "Take one capsule per day and gradually increase to one capsule two times per day or as directed by your healthcare professional. May be taken on an empty stomach or with a small meal as desired.",
  },

  {
    id: 8025179619459,
    title: "Tricobalamin",
    vendor: "Designs for Health",
    image: "//drhyman.com/cdn/shop/files/trico_600x600.png?v=1709577355",
    short_desc:
      "Tricobalamin™ lozenges provide a synergistic combination of the three bioavailable forms of vitamin B12, as methylcobalamin, hydroxycobalamin, and adenosylcobalamin",
    delivery_form: "Lozenges",
    directions:
      "Take 1 lozenge per day or as directed by your health-care practitioner. Allow lozenge to dissolve slowly and completely in mouth and swallow",
  },

  {
    id: 7777882112131,
    title: "Andrographis Plus Lung Health Supplement",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/AndrographisPlus_30T_LAN004W4_75cc_600x600.png?v=1706039581",
    short_desc:
      "Andrographis Plus is a concentrated blend of Ayurvedic and Chinese herbs designed to enhance immune health and support healthy respiratory function.*",
    delivery_form: "Tablets",
    directions:
      "Take one tablet daily or as directed by your healthcare practitioner.",
  },

  {
    id: 7877899550851,
    title: "UA-X Pro (RS)",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/164-90-UAXPro_600x600.png?v=1705958720",
    short_desc:
      "UA-X Pro provides a powerful formula for those seeking to minimize uric acid and optimize cardiovascular wellness.",
    delivery_form: "Capsules",
    directions:
      "3 capsules per day or as recommended by your health care professional.",
  },

  {
    id: 5112366792835,
    title: "MitoCORE",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/products/MITOCORE60_600x600.png?v=1596558832",
    short_desc:
      "MitoCOREsupplies key mitochondrial micronutrients and a smart combination of alpha lipoic acid, N-acetyl cysteine, and acetyl L-carnitine to boost cellular energy production.",
    delivery_form: "Capsules",
    directions:
      "2-4 capsules per day or as recommended by your health care professional.",
  },

  {
    id: 8339952828547,
    title: "NAC + Glycine Powder",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image256_f658a813-268b-4ae3-9151-db38ed268d46_600x600.png?v=1717774922",
    short_desc:
      "N-Acetyl-L-Cysteine and Glycine combination to support glutathione production, immune defense, and detoxification‡",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, take 1 scoop daily, mixed with 8 oz water, between meals, or as directed by a health professional.",
  },

  {
    id: 7766789095555,
    title: "Pancreatic Enzyme Formula 60 ct",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_35033653-49a4-4024-8efa-f984dc480521_600x600.png?v=1706583576",
    short_desc: "Enzyme support for digestive function",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule, 3 times daily, with each meal, or as directed by a health professional.",
  },

  {
    id: 5140761706627,
    title: "IgG 2000 CWP Capsules (RS)",
    vendor: "Xymogen",
    image: "//drhyman.com/cdn/shop/products/IGG_600x600.png?v=1602707782",
    short_desc:
      "Super high quality colostral whey peptides to support immunity, cellular and gut function, gastrointestinal health, and overall tissue repair.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules twice daily, or as recommended by your healthcare professional.",
  },

  {
    id: 6734283702403,
    title: "ColonX (RS)",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/Untitled-3_7a8e2bf3-01f8-4742-b9b7-a89085712f8e_600x600.png?v=1709689044",
    short_desc:
      "ColonX addresses an issue of universal importance: gastrointestinal(GI) health. GI regularity and function is vital to physiological balanceand overall well-being.",
    delivery_form: "Capsules",
    directions:
      "Take one to two capsules at bedtime with 8 oz of water, or as directed by your healthcare practitioner.",
  },

  {
    id: 7993528320131,
    title: "Liposomal Iron",
    vendor: "NuMedica",
    image: "//drhyman.com/cdn/shop/files/NM317_600x600.png?v=1709146364",
    short_desc:
      "Liposomal Iron is an encapsulated powder liposomal assisting in the body's production of healthy red blood cells.*",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule once per day or as directed by your healthcare practitioner.",
  },

  {
    id: 4908964249731,
    title: "Biocidin Broad Spectrum LSF 1.7 oz. (RS)",
    vendor: "Bio-Botanical Research",
    image: "//drhyman.com/cdn/shop/files/Biocidin_LSF_600x600.png?v=1705081554",
    short_desc:
      "Biocidin LSF is a potent Broad-Spectrum Botanical Combination which addresses the G.I tract and supports a healthy and balanced intestinal ecology.",
    delivery_form: "Liquid",
    directions:
      "Start with 1 pump per day and gradually increase to three times per day or as directed by your healthcare professional. Hold under tongue 30 seconds before swallowing. May be added to water. Best taken on an empty stomach 10 minutes before meals. Best if used within 60 days of opening.",
  },

  {
    id: 7818021470339,
    title: "Adapten-All (RS)",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/918-120-Adapten-All_600x600.png?v=1705957892",
    short_desc:
      "Adapten-All contains a combination of micronutrients that are crucial for buffering the effects of stress and supporting adrenal gland function.",
    delivery_form: "Capsules",
    directions:
      "2 capsules one to two times per day or as recommended by your health care professional.",
  },

  {
    id: 7822390820995,
    title: "NOVA Complete Monk Fruit",
    vendor: "NuMedica",
    image: "//drhyman.com/cdn/shop/products/NM593_600x600.png?v=1709925841",
    short_desc:
      "Boosts Nitric Oxide Production for Enhanced Circulation in Men &  Women*",
    delivery_form: "Powder",
    directions:
      "Mix 1 scoop (6.33 g) into 6-8 oz of water or juice. Increase or decrease water to taste. Take once per day or as directed by your healthcare practitioner.",
  },

  {
    id: 7994456440963,
    title: "Brain Boost+",
    vendor: "Healthgevity",
    image:
      "//drhyman.com/cdn/shop/files/bb_66fb1003-9f43-4f03-88c8-243a5f069b70_600x600.png?v=1731439915",
    short_desc:
      "The ingredients included in Brain Boost+ have shown positive changes in brain wave activity specifically delta and theta waves which are associated with focus and decision making under pressure, making it the ideal formula to utilize when needing a desired edge.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules daily or use as directed by a healthcare practitioner.",
  },

  {
    id: 4908878725251,
    title: "SAMe 30 ct (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/products/SAMewithVitaminsB-6_B-12and5-MTHF30_600x600.png?v=1709925628",
    short_desc:
      "SAMe is a naturally occurring metabolite found in the human body as well as in plant and animal foods. It is the most active of all methyl donors and has been compared to ATP in its importance for the body. SAMe is naturally synthesized in humans from the amino acid methionine in the presence of the cofactors B12 and folate.",
    delivery_form: "Capsules",
    directions:
      "Take 1 tablet one to two times a day, preferably on an empty stomach or as directed by your health care practitioner",
  },

  {
    id: 7818021699715,
    title: "Ortho Biotic Capsules (RS)",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/527-30-OrthoBiotic_600x600.png?v=1705958247",
    short_desc:
      "Ortho Biotic is a unique probiotic formula designed to deliver active organisms shown to promote healthy gut microflora, protect intestinal integrity and boost immune function.",
    delivery_form: "Capsules",
    directions:
      "1 capsule per day or as recommended by your health care professional.",
  },

  {
    id: 7829014282371,
    title: "Inflavonoid Rapid (RS)",
    vendor: "Metagenics",
    image:
      "//drhyman.com/cdn/shop/files/InflavonoidRapid_30SG_LNF061A1_75cc_INFLR30_600x600.png?v=1706120283",
    short_desc: "Relief of acute minor pain &  occasional discomfort*",
    delivery_form: "Softgel Capsules",
    directions:
      "Take two softgels daily or as directed by your healthcare practitioner.",
  },

  {
    id: 7983149187203,
    title: "FIT Food Lean Collagen Vanilla (RS)",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0010873_fit-food-lean-collagen-vanilla-14-servings_600x600.png?v=1720451534",
    short_desc:
      "FIT Food Lean Collagen features bovine collagen peptides complemented with beta-hydroxy-beta-methylbutyrate (HMB) andvitamin D3, making it an optimal choice for supporting collagen production, the integrity of connective tissues, and muscle health. Anatural metabolite of leucine, HMB increases lean muscle mass through dual mechanisms: inhibiting protein degradation and promoting protein synthesis. This versatile formula rapidly disperses in water and is ideal for athletes or for individuals who need an easily digested protein source.*",
    delivery_form: "Powder",
    directions:
      "Mix one level scoop (28 g) with 6-8 oz of cold water and consume daily, or use as directed by your healthcare professional. Adjust the amount of water according to thickness desired.",
  },

  {
    id: 6748672491651,
    title: "Sibb-Zymes",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/K-SIB_hires_web_600x600.png?v=1706716626",
    short_desc:
      "SIBB-Zymes™ is a Small Intestine Brush Border (SIBB) enzyme formulation that supports the final brush border stages of digestion and absorption.",
    delivery_form: "Capsules",
    directions:
      "2 capsules at the beginning of each meal or as directed by a healthcare practitioner.",
  },

  {
    id: 5079905599619,
    title: "5-HTP (5-Hydroxytryptophan) 100 mg (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/5-HTP_5-Hydroxytryptophan_100mg-180ct_600x600.png?v=1704300038",
    short_desc:
      "Promotes brain serotonin levels to support emotional well-being, healthy eating behavior, and healthy sleep.",
    delivery_form: "Capsules",
    directions: "Take 1 capsule, 1-3 times daily, before meals.",
  },

  {
    id: 7993587499139,
    title: "Organ Synergy",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/ORS180_organ-synergy_400cc_watermark_product-image_600x600.png?v=1709926184",
    short_desc:
      "Organ Synergy™ is a unique combination of freeze-dried bovine organs sourced from 100% grass-fed and finished New Zealand cattle (free from bovine spongiform encephalopathy).",
    delivery_form: "Capsules",
    directions:
      "Take 6 capsules per day or as directed by your health-care practitioner.",
  },

  {
    id: 7925258846339,
    title: "PerioPull (RS)",
    vendor: "Designs for Health",
    image:
      "//drhyman.com/cdn/shop/files/PPGLEM_periopull-lemon_8oz_watermark_product-image_600x600.webp?v=1708311483",
    short_desc:
      "PerioPull™ is uniquely designed to help support oral and periodontal health.",
    delivery_form: "Liquid",
    directions:
      "After normal brushing and flossing routine, swish 1 teaspoon (approximately 5 mL) of oil in mouth for 1 to 3 minutes or as directed by your health-care practitioner. Spit out oil and for maximum benefits, do not rinse to allow for longer contact of the ingredients to the teeth and gums.",
  },

  {
    id: 4908962054275,
    title: "A-BAB (RS)",
    vendor: "Byron White Formulas",
    image:
      "//drhyman.com/cdn/shop/products/a-bab_for_ultra_600x600.jpg?v=1587241107",
    short_desc:
      "This formula activates the immune response for the management of acute and chronic Babesiosis.",
    delivery_form: "Liquid",
    directions: "",
  },

  {
    id: 5140233355395,
    title: "Physicians' Elemental Diet  Dextrose Free",
    vendor: "Integrative Therapeutics",
    image:
      "//drhyman.com/cdn/shop/files/DextroseFreeElementalDiet_600x600.png?v=1708615858",
    short_desc:
      "Physicians' Elemental Diet Dextrose Free is an elemental powder medical food formulated to provide dietary management for patients who have limited or impaired capacity to digest, absorb, or metabolize ordinary foods or certain nutrients. Physicians' Elemental Diet Dextrose Free is a strictly hypoallergenic formula with a well-tolerated flavor and is formulated to provide the same dietary management as Physicians' Elemental Diet original, but without the dextrose as a carbohydrate source.",
    delivery_form: "Powder",
    directions:
      "Thoroughly mix each heaping scoopful (35 g) in 4-8 oz. (118-236 mL) chilled or room temperature water. Additional water may be added to the mixture or consumed separately as desired. Consume the mixture slowly for over 15 to 60 minutes or more, depending on individual comfort. Once mixed, any product that is not consumed after 60 minutes should be refrigerated for a maximum of 24 hours, then shaken or stirred prior to consumption. After opening, store the remaining powder in a dry place at room temperature.",
  },

  {
    id: 7826835308675,
    title: "Copper Glycinate 60cap (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/products/copper-glycinate-60-s-cug6.jpg.mst_600x600.webp?v=1674143627",
    short_desc: "Essential mineral with wide-ranging support‡",
    delivery_form: "Capsules",
    directions: "As a dietary supplement, take 2 capsules daily, with meals.",
  },

  {
    id: 8066494955651,
    title: "WeNatal Supplements for Him (pouch)",
    vendor: "WeNatal",
    image:
      "//drhyman.com/cdn/shop/files/wenatalmen_2029707b-42e5-45e6-a849-09b5e4bfdb0d_600x600.png?v=1709586275",
    short_desc:
      "This men's prenatal supplements feature 15 essential nutrients in their most absorbable forms and at the right doses. The formula is made with clinically-proven ingredients that support male reproduction health.",
    delivery_form: "Capsules",
    directions:
      "3 capsules a day. Nutrient density of 6-8 capsules packed into just 3 a day.",
  },

  {
    id: 7925042577539,
    title: "Pantothenic Acid 120's (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_d8d0d87f-73a9-4954-b911-63a15a818789_600x600.png?v=1706583752",
    short_desc:
      "Pantothenic acid is a precursor of coenzyme A (CoA), an important cofactor and acyl group carrier in cells.",
    delivery_form: "Capsules",
    directions: "As a dietary supplement, take 1 capsule daily, with a meal.",
  },

  {
    id: 7933626122371,
    title: "Pancreatic Enzyme Formula 180ct (RS)",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_53d6ec86-5693-4775-962d-70c91a3c669c_600x600.png?v=1706583503",
    short_desc: "Enzyme support for digestive function",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, adults take 1 capsule, 3 times daily, with each meal, or as directed by a healthcare professional.",
  },

  {
    id: 5140762591363,
    title: "ProBioMax Ig 26 DF (RS)",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011735_probiomax-ig-26-df-120-capsules_600x600.png?v=1742327500",
    short_desc:
      "IG 26 DF contains self-affirmed GRAS IgY Max™, which provides IgY immunoglobulins and immunoregulating molecules from hyperimmune chicken egg. Research suggests that this dairy-free source of immunoglobulins and immune cofactors helps support immune function in the intestine and a healthy intestinal environment. These benefits positively impact extraintestinal health. Preliminary research also suggests a role for the formula's immunoregulating molecules in cytokine modulation and in sports recovery applications.*",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules twicw daily with cold water, or as directed by you healthcare practitioner.",
  },

  {
    id: 7896303468675,
    title: "HepatoCore (RS)",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/163-60-HepatoCORE-web_600x600.png?v=1705958511",
    short_desc:
      "HepatoCORE delivers broad-spectrum support for optimal liver function and fat metabolism. HepatoCORE also assists in maintaining healthy blood pressure and cholesterol levels.",
    delivery_form: "Capsules",
    directions:
      "2 capsules per day or as recommended by your health care professional.",
  },

  {
    id: 8138292953219,
    title: "Clear Way Cofactors 120 ct (RS)",
    vendor: "Quicksilver Scientific",
    image:
      "//drhyman.com/cdn/shop/files/Untitled-1_ae078aa4-a542-4740-94d9-a62f75c2caca_600x600.png?v=1712618752",
    short_desc:
      "Clear Way Cofactors is a proprietary blend of phytoextracted polyphenolic antioxidants, R-Lipoic Acid (RLA), targeted vitamins (B1, B5, B6-as both pyroxidine and P5P), selenium, kelp extract and high-potency Nattokinase designed to maximize metal detoxification pathways.",
    delivery_form: "Capsules",
    directions:
      "Build up to 3 capsules per day gradually. Best taken on an empty stomach. If upset occurs, take it with meals.",
  },

  {
    id: 8080748707971,
    title: "NSK-SD (Nattokinase) 100 mg-60ct",
    vendor: "Pure Encapsulations",
    image: "//drhyman.com/cdn/shop/files/NS16_600x600.png?v=1710359234",
    short_desc:
      "An enzyme isolated from Japanese natto, this helps maintain natural clotting and blood flow in the body. Promotes healthy blood vessel and cardiovascular health.120 ct. veg. capsules",
    delivery_form: "Capsules",
    directions:
      "1 capsule, 2 times daily, 12 hours apart, with or between meals.",
  },

  {
    id: 5157234868355,
    title: "DioVasc (RS)",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/products/0005021_diovasc-60-capsules_600x600.png?v=1605124273",
    short_desc: "Natural Support for Healthy Veins and Microcirculation*",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule twice daily, or as directed by your healthcare professional.",
  },

  {
    id: 7917399343235,
    title: "Florassist Heart Health",
    vendor: "Life Extensions",
    image: "//drhyman.com/cdn/shop/files/hearthealth_600x600.png?v=1709577299",
    short_desc:
      "Life Extensions FLORASSIST Heart Health probiotic supplement is made with a novel probiotic shown to promote cardiovascular health by supporting already healthy cholesterol & C-reactive protein levels",
    delivery_form: "Capsules",
    directions:
      "Take one (1) capsule twice daily with food, or as recommended by a healthcare practitioner.",
  },

  {
    id: 5140972175491,
    title: "FlashArrest (formally Aromat8-PN) (RS)",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/products/0005022_flasharrest-60-capsules_600x600.png?v=1602771543",
    short_desc:
      "Supplement name will be changing to FlashArrest with not formula change.  All-natural formula may support cardiovascular, bone, breast, and prostate health and help relieve normal menopausal discomforts.",
    delivery_form: "Capsules",
    directions:
      "Take 1-2 capsules daily, or use as directed by your healthcare professional.",
  },

  {
    id: 7896305598595,
    title: "Berberine ES-5",
    vendor: "Xymogen",
    image:
      "//drhyman.com/cdn/shop/files/0011546_berberine-es-5-60-capsules_600x600.png?v=1742235940",
    short_desc: "5× the Bioavailability of Berberine*",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule once or twice daily, or use diectred by your healthcare professional.",
  },

  {
    id: 4908988563587,
    title: "Circulation P",
    vendor: "Zhang Products",
    image:
      "//drhyman.com/cdn/shop/products/circulation_600x600.png?v=1587241363",
    short_desc:
      "Traditionally, the formula was used for releasing blood stasis, typically for symptoms of dark or purplish tongue, cold hands and feet, dark rings around the eyes, liver palms, spider moles, dry and itchy skin, rashes, and upper abdominal discomfort. It has Qi and blood activation, stasis expelling, and pain releasing effects.",
    delivery_form: "Capsules",
    directions: "1 three times a day with or without food",
  },

  {
    id: 7994997637251,
    title: "Ignite+",
    vendor: "Healthgevity",
    image: "//drhyman.com/cdn/shop/files/iginite_600x600.png?v=1709576734",
    short_desc:
      "Ignite+ is an exclusive breakthrough formula combining the leading ingredients available to increase metabolism, improve insulin signaling, body composition, reduce uptake of glucose into our bodies, and so much more.",
    delivery_form: "Capsules",
    directions:
      "Take three capsule a day or use as directed by your healthcare practitioner.",
  },

  {
    id: 7818022453379,
    title: "Orthomega 820",
    vendor: "Ortho Molecular",
    image:
      "//drhyman.com/cdn/shop/files/440-120OrthomegaWithDPA_600x600.png?v=1705958384",
    short_desc:
      "Orthomega 820 is a high-concentration fish oil sourced from waters off the Chilean coast.",
    delivery_form: "Softgel Capsules",
    directions:
      "1 soft gel capsule per day or as recommended by your health care professional.",
  },

  {
    id: 7828191838339,
    title: "GABA",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/gaba-gab1-gab6.jpeg.mst_600x600.webp?v=1690213547",
    short_desc: "Supports relaxation and moderates occasional stress‡",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take 1 capsule daily, between meals, or as directed by a health professional.",
  },

  {
    id: 5193406021763,
    title: "Ox Bile 500 mg (RS)",
    vendor: "Allergy Research Group",
    image: "//drhyman.com/cdn/shop/files/oxbile100_600x600.png?v=1708301871",
    short_desc:
      "Derived from a bovine source and freeze-dried (lyophilized) to maintain its biological activity, Ox Bile is a suitable supplement to the liver's production of bile.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, 1 capsule one to three times daily with meals containing fat, or as directed by a healthcare practitioner.",
  },

  {
    id: 7708060778627,
    title: "Homocysteine Resist",
    vendor: "Life Extensions",
    image:
      "//drhyman.com/cdn/shop/products/Homocysteineresist_600x600.png?v=1654882982",
    short_desc: "Vitamin B formulation for heart &  brain health support",
    delivery_form: "Capsules",
    directions:
      "Take 1 capsule daily with food, or as recommended by a healthcare practitioner.",
  },

  {
    id: 5140759511171,
    title: "Citicoline Cognizin (RS)",
    vendor: "Vital Nutrients",
    image:
      "//drhyman.com/cdn/shop/products/844c4dbe-c88c-455f-9bdf-2c67141e7ca3-358-358_600x600.png?v=1602711070",
    short_desc:
      "Vital Nutrients uses Cognizin, a patented and research backed form of Citicoline, a naturally occurring nutrient found in every living cell.",
    delivery_form: "Capsules",
    directions:
      "1 to 2 capsules 2 times daily, or as directed by your healthcare professional.",
  },

  {
    id: 7877781815427,
    title: "Receptor Detox (RS)",
    vendor: "Biotics",
    image:
      "//drhyman.com/cdn/shop/products/6271_ReceptorDetox_900x_05efba6d-700a-4fc1-a8c4-ba60bf89675f_600x600.webp?v=1680019890",
    short_desc:
      "Receptor Detox contains carefully selected nutrients shown to gently, effectively and safely optimize hormone receptor function, ensuring healthy hormone signaling. Receptor dysfunction can be multifactorial; often a result of such things as systemic inflammatory responses, reactive oxygen species, endocrine disrupting compounds (EDCs), polymorphisms in receptor genes, signaling pathway anomalies, and altered gene expression.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsule twice daily with food, or as otherwise directed by a healthcare professional.",
  },

  {
    id: 5140767932547,
    title: "Power Adapt 60 ct capsules (RS)",
    vendor: "Natura",
    image: "//drhyman.com/cdn/shop/products/PATC-116F_600x600.jpg?v=1655230562",
    short_desc: "Supplement for a healthy endocrine system.",
    delivery_form: "Capsules",
    directions:
      "Take 2 capsules, 2 times daily or as directed by your healthcare professional.",
  },

  {
    id: 7822429945987,
    title: "Oregon Grape Root",
    vendor: "Integrative Therapeutics",
    image: "//drhyman.com/cdn/shop/products/image007_600x600.png?v=1673982945",
    short_desc: "Oregon Grape provides traditional digestive support.*",
    delivery_form: "Capsules",
    directions: "Take 1 capsule three times daily.",
  },

  {
    id: 5192944255107,
    title: "Iodizyme-HP (RS)",
    vendor: "Biotics",
    image:
      "//drhyman.com/cdn/shop/products/1737-web-NewLabel-nocontent_900x_a7726a11-6726-4ee1-8abf-9e402ffa8e3f_600x600.png?v=1611260735",
    short_desc: "Thyroid and hormonal balance.",
    delivery_form: "Tablets",
    directions: "One 1/2 tablet each day or as directed by your practitioner.",
  },

  {
    id: 7721227026563,
    title: "Sole Jar with Stones",
    vendor: "Symphony Natural Health",
    image:
      "//drhyman.com/cdn/shop/files/3D-SOLE-JAR-SPOON-2000x2000_1024x_360107d3-b88a-460e-a30d-dbde5c5567fa_600x600.webp?v=1709579140",
    short_desc:
      "Himalayan Crystal Stones to create a concentrated salty solution containing 84 ionic minerals to help balance and restore many body functions.",
    delivery_form: "Powder",
    directions:
      "Option #1 Add 1 teaspoon of Sole using your handcrafted wooden spoon to an 8-ounce glass of your preferred drinking water. Drink each morning on an empty stomach and then wait 30 minutes before eating.Option #2 Add 1 teaspoon of Sole to 1 quart of your preferred drinking water and drink it throughout the day.",
  },

  {
    id: 7978783899779,
    title: "Ribose",
    vendor: "Pure Encapsulations",
    image:
      "//drhyman.com/cdn/shop/files/image105_5afd6664-3a8e-4767-9abb-5aa215067836_600x600.png?v=1727454488",
    short_desc: "Supports energy repletion",
    delivery_form: "Powder",
    directions:
      "As a dietary supplement, take 1 heaping scoop,  1-2 times daily, with or between meals.",
  },

  {
    id: 7864150818947,
    title: "Fatty15",
    vendor: "Fatty15",
    image:
      "//drhyman.com/cdn/shop/files/fatty15_2326ebe1-c57f-43f8-91e3-1a7ccb0ccb1c_600x600.png?v=1721825024",
    short_desc:
      "C15:0 is an essential fatty acid that your body needs to stay healthy, especially as you age. Fatty15 is a science-backed, award-winning, pure and vegan-friendly C15:0 supplement to support your long-term health and wellness.",
    delivery_form: "Capsules",
    directions:
      "As a dietary supplement, take one to two capsules daily, or as directed by your health care practitioner.",
  },

  {
    id: 4908988039299,
    title: "Artemisiae (RS)",
    vendor: "Zhang Products",
    image:
      "//drhyman.com/cdn/shop/products/artemisiae_capsules_1_600x600.png?v=1587241357",
    short_desc:
      "Dihydroartemisinin (DHA) has been used as the 1st line anti-malaria remedy recommended by the World Health Organization. Its application has been expanded to treat the malaria-like protozoa infections babesiosis.",
    delivery_form: "Capsules",
    directions: "1 three times a day with or without food - 10 day supply.",
  },

  {
    id: 7896297046147,
    title: "Undecylenic Acid",
    vendor: "Thorne",
    image: "//drhyman.com/cdn/shop/files/sf722-front_600x600.png?v=1705981662",
    short_desc:
      "Fatty acid support for a healthy balance of gut and vaginal flora*",
    delivery_form: "Softgel Capsules",
    directions:
      "Take 5 gelcaps two to three times daily or as recommended by your health professional.",
  },

  {
    id: 7708055601283,
    title: "One-Per-Day Tablets (DC)",
    vendor: "Life Extensions",
    image: "//drhyman.com/cdn/shop/products/oneaday_600x600.png?v=1654881594",
    short_desc: "Multivitamin &  mineral supplement",
    delivery_form: "Tablets",
    directions:
      "Take 1 tablet daily with meals, or as recommended by a health practitioner.",
  },

  {
    id: 4908913262723,
    title: "SAMe 200 60 ct.",
    vendor: "SFI Klaire/Prothera",
    image:
      "//drhyman.com/cdn/shop/files/SAM60_hires_web_600x600.png?v=1706716235",
    short_desc:
      "Supports mood regulation, joints, and liver function.Promotes healthy mood, cognition, and emotional wellbeing†Major source of methyl groups used by the brain in the synthesis of neurotransmitters†Supports joint comfort and mobility, cellular detoxification, and liver function†Supports numerous energy-requiring processes within your body, promoting healthy mood, cognition, and emotional well-being.† In numerous clinical studies, SAMe has also been shown to support bone and joint health, liver detoxification, and healthy cell membranes.†",
    delivery_form: "Tablets",
    directions: "",
  },

  {
    id: 4908956942467,
    title: "DHEA Liquid (RS)",
    vendor: "BioMatrix",
    image:
      "//drhyman.com/cdn/shop/products/dhea_liquid_600x600.jpg?v=1587241058",
    short_desc:
      "DHEA Drops from BioMatrix provides a convenient, easily absorbed, sublingual source of this versatile natural hormone.",
    delivery_form: "Liquid",
    directions:
      "Take 2 drops, three times a day or as directed by your healthcare professional.",
  },

  {
    id: 8018249187459,
    title: "WeNatal Omega DHA+ Fish Oil Supplements",
    vendor: "WeNatal",
    image:
      "//drhyman.com/cdn/shop/files/wenatal-fish-oil-jar-packet_600x600.jpg?v=1704752261",
    short_desc:
      "WeNatal Omega DHA+ contains clinically proven amounts of omega-3 fatty acids to help support baby brain development and optimize the health of both mom and dad before, during, and after pregnancy.",
    delivery_form: "Softgel Capsules",
    directions:
      "2 small capsules daily. Easy to swallow with no aftertaste. Wild caught &amp; sustainably sourced. Non-GMO and made without synthetic dyes, fillers, preservatives, or artificial ingredients.",
  },

  {
    id: 8018250039427,
    title: "WeNatal Supplements for Him",
    vendor: "WeNatal",
    image:
      "//drhyman.com/cdn/shop/files/products_for-him_600x600.webp?v=1709161463",
    short_desc:
      "This men's prenatal supplements feature 15 essential nutrients in their most absorbable forms and at the right doses. The formula is made with clinically-proven ingredients that support male reproduction health.",
    delivery_form: "Capsules",
    directions: "3 capsules a day.",
  },

  {
    id: 8019017433219,
    title: "WeNatal Supplements for Her",
    vendor: "WeNatal",
    image:
      "//drhyman.com/cdn/shop/files/wenatal_5b86c714-bc46-4db3-8d42-63748e8b592f_600x600.png?v=1709575683",
    short_desc:
      "This prenatal supplement for women contains 24 essential nutrients in their most absorbable forms and at the right doses. Includes clinically-proven ingredients (often left out in other prenatals) that support women from preconception, through pregnancy to breastfeeding and beyond.",
    delivery_form: "Capsules",
    directions: "3 capsules a day.",
  },

  {
    id: 7834468712579,
    title: "Young Forever",
    vendor: "Dr. Hyman Store",
    image:
      "//drhyman.com/cdn/shop/files/813d0G3ILGL._SL1500_600x600.jpg?v=1705360105",
    short_desc:
      "In Young Forever, Dr. Mark Hyman challenges us to reimagine our biology, health, and the process of aging.",
    delivery_form: "Book",
    directions: "",
  },

  {
    id: 5097416851587,
    title: "AquaTru",
    vendor: "Dr. Hyman Store",
    image: "//drhyman.com/cdn/shop/products/Aquatrun2_600x600.png?v=1594825333",
    short_desc:
      "Certified to Remove 76 Dangerous Contaminants including Lead, Chromium 6, Fluoride, PFAS, Pesticides, Drug Residue, VOC's, and many others.",
    delivery_form: null,
    directions: "",
  },

  {
    id: 5071266185347,
    title: "Food Fix",
    vendor: "UWC",
    image:
      "//drhyman.com/cdn/shop/products/Image6-19-20at8.12AM_600x600.jpg?v=1592568982",
    short_desc:
      "Food Fix: How to Save Our Health, Our Economy, Our Communities, and Our Planet--One Bite at a Time!This book order is filled through Amazon. Click the &quot;buy now&quot;  link below, prices may fluctuate.",
    delivery_form: "Book",
    directions: "",
  },

  {
    id: 4908970082435,
    title: "10-Day Detox Diet Cookbook",
    vendor: "Dr. Hyman Store",
    image:
      "//drhyman.com/cdn/shop/products/10dd_cookbook_book_cover_600x600.jpg?v=1587241189",
    short_desc:
      "The companion cookbook to Dr. Mark Hyman's revolutionary weight-loss program, the #1 New York Times The Blood Sugar Solution 10-Day Detox Diet, with more than 150 recipes for immediate results!",
    delivery_form: "Book",
    directions: "",
  },
];
